"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cross = exports.crop = exports.credit = exports.card = exports.commons = exports.commonsSharealike = exports.commonsShare = exports.commonsRemix = exports.commonsPublicDomain = exports.commonsNoncommercialUs = exports.commonsNoncommercialEu = exports.commonsNoderivs = exports.commonsAttribution = exports.copy = exports.volume = exports.stop = exports.record = exports.play = exports.paus = exports.next = exports.jumpToStart = exports.fastForward = exports.fastBackward = exports.compass = exports.colours = exports.cog = exports.code = exports.cloud = exports.clock = exports.clipboard = exports.computer = exports.clapperboard = exports.circle = exports.withPlus = exports.withMinus = exports.withCross = exports.thinUp = exports.thinRight = exports.thinLeft = exports.thinDown = exports.smallUp = exports.smallRight = exports.smallLeft = exports.smallDown = exports.check = exports.chat = exports.ccw = exports.camera = exports.calendar = exports.calculator = exports.cake = exports.bug = exports.bucket = exports.brush = exports.browser = exports.briefcase = exports.box = exports.bowl = exports.bookmarks = exports.bookmark = exports.book = exports.block = exports.blackboard = exports.bell = exports.note = exports.battery = exports.back = exports.inTime = exports.ribbon = exports.attachment = exports.withCircleUp = exports.withCircleRight = exports.withCircleLeft = exports.withCircleDown = exports.up = exports.longUp = exports.longRight = exports.longLeft = exports.longDown = exports.down = exports.boldUp = exports.boldRight = exports.boldLeft = exports.boldDown = exports.graph = exports.archive = exports.verticalMiddle = exports.top = exports.right = exports.left = exports.horizontalMiddle = exports.bottom = exports.aircraft = exports.takeOff = exports.landing = exports.air = exports.adjust = exports.address = exports.user = exports.toList = void 0;
exports.network = exports.mouse = exports.pointer = exports.moon = exports.mobile = exports.minus = exports.mic = exports.message = exports.merge = exports.menu = exports.megaphone = exports.medal = exports.mask = exports.map = exports.man = exports.mail = exports.magnet = exports.loop = exports.login = exports.out = exports.lock = exports.open = exports.location = exports.pin = exports.list = exports.link = exports.bulb = exports.lifebuoy = exports.leaf = exports.layers = exports.laptop = exports.language = exports.landline = exports.flask = exports.keyboard = exports.key = exports.install = exports.info = exports.infinity = exports.inbox = exports.image = exports.inverted = exports.glass = exports.home = exports.help = exports.withCircle = exports.heart = exports.outlined = exports.hand = exports.grid = exports.cap = exports.globe = exports.gauge = exports.controller = exports.funnel = exports.forward = exports.folder = exports.video = exports.music = exports.images = exports.flower = exports.tree = exports.parallel = exports.line = exports.cascade = exports.branch = exports.flashlight = exports.flash = exports.flag = exports.fingerprint = exports.feather = exports.eye = exports.withLine = exports.exportIcon = exports.eraser = exports.erase = exports.sad = exports.neutral = exports.happy = exports.flirt = exports.email = exports.edit = exports.drop = exports.drive = exports.drink = exports.download = exports.twoVertical = exports.twoHorizontal = exports.threeVertical = exports.threeHorizontal = exports.single = exports.documents = exports.document = exports.landscape = exports.direction = exports.pad = exports.database = exports.cycle = exports.cw = exports.cup = void 0;
exports.medium = exports.linkedin = exports.lastfm = exports.instagram = exports.icloud = exports.houzz = exports.grooveshark = exports.hangouts = exports.googlePlus = exports.github = exports.foursquare = exports.flickr = exports.flattr = exports.facebook = exports.evernote = exports.dropbox = exports.dribbble = exports.behance = exports.basecamp = exports.baidu = exports.store = exports.fiveHundredPX = exports.water = exports.warning = exports.wallet = exports.voicemail = exports.vinyl = exports.users = exports.upload = exports.toCloud = exports.untag = exports.unread = exports.uninstall = exports.typing = exports.tv = exports.trophy = exports.trash = exports.cone = exports.tools = exports.slot = exports.ticket = exports.thermometer = exports.text = exports.documentInverted = exports.tablet = exports.mobileCombo = exports.switchIcon = exports.sweden = exports.swap = exports.suitcase = exports.stopwatch = exports.star = exports.spreadsheet = exports.club = exports.sound = exports.mute = exports.mix = exports.signal = exports.shuffle = exports.cart = exports.basket = exports.bag = exports.shop = exports.shield = exports.shareable = exports.share = exports.alternative = exports.arrows = exports.scissors = exports.save = exports.ruler = exports.rss = exports.rocket = exports.retweet = exports.fullScreen = exports.oneHundredPercent = exports.reply = exports.all = exports.radio = exports.quote = exports.publish = exports.two = exports.one = exports.full = exports.empty = exports.print = exports.tag = exports.plug = exports.popup = exports.plus = exports.chart = exports.pencil = exports.plane = exports.palette = exports.phone = exports.off = exports.notification = exports.newsletter = exports.news = exports.newIcon = void 0;
exports.youtube = exports.youko = exports.yelp = exports.xing = exports.vk = exports.alternitive = exports.vine = exports.vimeo = exports.twitter = exports.tumblr = exports.tripadvisor = exports.swarm = exports.stumbleupon = exports.spotify = exports.soundcloud = exports.smashing = exports.slideshare = exports.skype = exports.weibo = exports.scribd = exports.renren = exports.rdio = exports.rainbow = exports.raft = exports.qq = exports.pinterest = exports.picasa = exports.paypal = exports.onedrive = exports.mixi = void 0;
var toList = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.4,9H16V5.6C16,5,15.6,5,15,5s-1,0-1,0.6V9h-3.4C10,9,10,9.4,10,10s0,1,0.6,1H14v3.4c0,0.6,0.4,0.6,1,0.6s1,0,1-0.6V11\r\n\th3.4c0.6,0,0.6-0.4,0.6-1S20,9,19.4,9z M7.4,9H0.6C0,9,0,9.4,0,10s0,1,0.6,1h6.8C8,11,8,10.6,8,10S8,9,7.4,9z M7.4,14H0.6\r\n\tC0,14,0,14.4,0,15s0,1,0.6,1h6.8C8,16,8,15.6,8,15S8,14,7.4,14z M7.4,4H0.6C0,4,0,4.4,0,5s0,1,0.6,1h6.8C8,6,8,5.6,8,5S8,4,7.4,4z"
    }
  }]
};
exports.toList = toList;
var user = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.989,19.129C16,17,13.803,15.74,11.672,14.822c-2.123-0.914-2.801-1.684-2.801-3.334c0-0.989,0.648-0.667,0.932-2.481\r\n\tc0.12-0.752,0.692-0.012,0.802-1.729c0-0.684-0.313-0.854-0.313-0.854s0.159-1.013,0.221-1.793c0.064-0.817-0.398-2.56-2.301-3.095\r\n\tC7.88,1.195,7.655,0.654,8.679,0.112c-2.24-0.104-2.761,1.068-3.954,1.93c-1.015,0.756-1.289,1.953-1.24,2.59\r\n\tc0.065,0.78,0.223,1.793,0.223,1.793s-0.314,0.17-0.314,0.854c0.11,1.718,0.684,0.977,0.803,1.729\r\n\tC4.481,10.822,5.13,10.5,5.13,11.489c0,1.65-0.212,2.21-2.336,3.124C0.663,15.53,0,17,0.011,19.129C0.014,19.766,0,20,0,20h16\r\n\tC16,20,15.986,19.766,15.989,19.129z M17,10V7h-2v3h-3v2h3v3h2v-3h3v-2H17z"
    }
  }]
};
exports.user = user;
var address = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.799,5.165l-2.375-1.83c-0.135-0.093-0.324-0.176-0.521-0.237C16.705,3.037,16.5,3,16.336,3H9.5l0.801,5h6.035\r\n\tc0.164,0,0.369-0.037,0.566-0.098s0.387-0.145,0.521-0.236l2.375-1.832C19.933,5.743,20,5.622,20,5.5S19.933,5.257,19.799,5.165z\r\n\t M8.5,1h-1C7.224,1,7,1.224,7,1.5V5H3.664c-0.166,0-0.37,0.037-0.567,0.099C2.899,5.159,2.71,5.242,2.576,5.335l-2.375,1.83\r\n\tC0.066,7.256,0,7.378,0,7.5c0,0.121,0.066,0.242,0.201,0.335l2.375,1.832C2.71,9.758,2.899,9.842,3.097,9.902\r\n\tC3.294,9.963,3.498,10,3.664,10H7v8.5C7,18.776,7.224,19,7.5,19h1C8.776,19,9,18.776,9,18.5v-17C9,1.224,8.776,1,8.5,1z"
    }
  }]
};
exports.address = address;
var adjust = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,9.199c-0.182,0-0.799,0-0.98,0c-0.553,0-1,0.359-1,0.801c0,0.441,0.447,0.799,1,0.799c0.182,0,0.799,0,0.98,0\r\n\tc0.552,0,1-0.357,1-0.799C20,9.559,19.551,9.199,19,9.199z M10,4.5c-3.051,0-5.5,2.449-5.5,5.5c0,3.051,2.449,5.5,5.5,5.5\r\n\tc3.05,0,5.5-2.449,5.5-5.5C15.5,6.949,13.049,4.5,10,4.5z M10,14c-2.211,0-4-1.791-4-4c0-2.211,1.789-4,4-4V14z M3,10\r\n\tc0-0.441-0.449-0.801-1-0.801c-0.185,0-0.816,0-1,0c-0.553,0-1,0.359-1,0.801c0,0.441,0.447,0.799,1,0.799c0.184,0,0.815,0,1,0\r\n\tC2.551,10.799,3,10.441,3,10z M10,3c0.441,0,0.799-0.447,0.799-1c0-0.184,0-0.816,0-1c0-0.553-0.358-1-0.799-1\r\n\tC9.558,0,9.199,0.447,9.199,1c0,0.184,0,0.816,0,1C9.199,2.553,9.558,3,10,3z M10,17c-0.442,0-0.801,0.447-0.801,1\r\n\tc0,0.184,0,0.816,0,1c0,0.553,0.359,1,0.801,1c0.441,0,0.799-0.447,0.799-1c0-0.184,0-0.816,0-1C10.799,17.447,10.441,17,10,17z\r\n\t M17.365,3.766c0.391-0.391,0.454-0.961,0.142-1.273s-0.883-0.248-1.272,0.143c-0.108,0.107-0.593,0.592-0.7,0.699\r\n\tc-0.391,0.391-0.454,0.961-0.142,1.273s0.883,0.248,1.273-0.143C16.773,4.357,17.257,3.873,17.365,3.766z M3.334,15.533\r\n\tc-0.108,0.109-0.593,0.594-0.7,0.701c-0.391,0.391-0.454,0.959-0.142,1.271s0.883,0.25,1.272-0.141\r\n\tc0.108-0.107,0.593-0.592,0.7-0.699c0.391-0.391,0.454-0.961,0.142-1.274S3.723,15.144,3.334,15.533z M3.765,2.635\r\n\tC3.375,2.244,2.804,2.18,2.492,2.492S2.244,3.375,2.633,3.766c0.108,0.107,0.593,0.592,0.7,0.699\r\n\tc0.391,0.391,0.96,0.455,1.272,0.143s0.249-0.883-0.141-1.273C4.357,3.227,3.873,2.742,3.765,2.635z M15.534,16.666\r\n\tc0.108,0.107,0.593,0.592,0.7,0.699c0.391,0.391,0.96,0.453,1.272,0.143c0.312-0.312,0.249-0.883-0.142-1.273\r\n\tc-0.107-0.107-0.592-0.592-0.699-0.699c-0.391-0.391-0.961-0.455-1.274-0.143S15.143,16.275,15.534,16.666z"
    }
  }]
};
exports.adjust = adjust;
var air = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.643,6.357c1.747-1.5,3.127-2.686,6.872-0.57c1.799,1.016,3.25,1.4,4.457,1.398c2.115,0,3.486-1.176,4.671-2.193\r\n\tc0.423-0.363,0.477-1.008,0.122-1.439c-0.357-0.432-0.987-0.488-1.41-0.125c-1.746,1.502-3.127,2.688-6.872,0.57\r\n\tC5.535,1.205,3.217,3.195,1.355,4.795C0.933,5.158,0.879,5.801,1.234,6.234C1.59,6.664,2.22,6.721,2.643,6.357z M17.355,8.535\r\n\tc-1.746,1.5-3.127,2.688-6.872,0.57C5.535,6.31,3.217,8.301,1.355,9.9c-0.422,0.363-0.477,1.008-0.121,1.439\r\n\tc0.355,0.432,0.986,0.488,1.409,0.125C4.39,9.963,5.77,8.777,9.515,10.892c1.799,1.018,3.25,1.4,4.457,1.4\r\n\tc2.115,0,3.486-1.176,4.671-2.195c0.423-0.363,0.477-1.008,0.122-1.438C18.409,8.226,17.778,8.172,17.355,8.535z M17.355,13.641\r\n\tc-1.746,1.502-3.127,2.688-6.872,0.572c-4.948-2.795-7.266-0.805-9.128,0.795c-0.422,0.363-0.477,1.008-0.121,1.439\r\n\tc0.355,0.432,0.986,0.486,1.409,0.123C4.39,15.07,5.77,13.885,9.515,16c1.799,1.016,3.25,1.4,4.457,1.4\r\n\tc2.115,0,3.486-1.178,4.671-2.195c0.423-0.363,0.477-1.008,0.122-1.439C18.409,13.334,17.778,13.279,17.355,13.641z"
    }
  }]
};
exports.air = air;
var landing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.752,16.038c-0.097,0.266-0.822,1.002-6.029-0.878l-5.105-1.843C5.841,12.676,3.34,11.668,2.36,11.1\r\n\tc-0.686-0.397-0.836-1.282-0.836-1.282S1.361,6.862,1.261,6.134c-0.1-0.728,0.095-0.853,0.796-0.492\r\n\tc0.436,0.225,1.865,2.562,2.464,3.567C6.033,9.59,7.383,9.97,8.014,10.158C7.757,8.441,7.274,5.23,7.101,4.225\r\n\tC6.935,3.262,7.651,3.69,7.651,3.69c0.331,0.19,0.983,0.661,1.206,1.002c1.522,2.326,3.672,6.6,3.836,6.928\r\n\tc0.896,0.28,2.277,0.733,3.102,1.03C17.951,13.429,18.882,15.684,18.752,16.038z"
    }
  }]
};
exports.landing = landing;
var takeOff = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.87,6.453c0.119,0.257,0.127,1.29-4.884,3.642l-4.913,2.306c-1.71,0.803-4.191,1.859-5.285,2.151\r\n\tc-0.766,0.204-1.497-0.316-1.497-0.316s-2.206-1.975-2.792-2.419c-0.585-0.444-0.535-0.67,0.215-0.91\r\n\tc0.467-0.149,3.13,0.493,4.265,0.78c1.339-0.8,2.562-1.486,3.141-1.798c-1.396-1.033-4.008-2.962-4.841-3.55\r\n\tc-0.799-0.565,0.01-0.768,0.01-0.768c0.368-0.099,1.162-0.228,1.562-0.144c2.721,0.569,7.263,2.071,7.611,2.186\r\n\tc0.832-0.436,2.128-1.092,2.922-1.465C17.459,5.174,19.711,6.111,19.87,6.453z"
    }
  }]
};
exports.takeOff = takeOff;
var aircraft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.496,17.414c-0.394-1.096-1.805-4.775-2.39-6.297c-1.103,0.737-2.334,1.435-3.512,1.928\r\n\tc-0.366,1.28-1.094,3.709-1.446,4.033c-0.604,0.557-0.832,0.485-0.925-0.279c-0.093-0.764-0.485-3.236-0.485-3.236\r\n\ts-2.162-1.219-2.84-1.568s-0.667-0.591,0.057-0.974c0.422-0.223,2.927-0.085,4.242,0.005c0.861-0.951,1.931-1.882,2.993-2.679\r\n\tC6.975,7.271,4.04,4.672,3.156,3.923C2.38,3.265,3.235,3.126,3.235,3.126c0.39-0.07,1.222-0.132,1.628-0.009\r\n\tc2.524,0.763,6.442,2.068,7.363,2.376c0.353-0.249,0.737-0.52,1.162-0.821c4.702-3.33,5.887-2.593,6.111-2.27\r\n\ts0.503,1.701-4.199,5.032c-0.425,0.301-0.808,0.573-1.16,0.823c-0.029,0.98-0.157,5.151-0.311,7.811\r\n\tc-0.025,0.428-0.367,1.198-0.565,1.544C13.263,17.612,12.841,18.377,12.496,17.414z"
    }
  }]
};
exports.aircraft = aircraft;
var bottom = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,11h-2V3H9v8H7l3,3L13,11z M17.4,15H2.6C2.048,15,2,15.447,2,16c0,0.553,0.048,1,0.6,1H17.4c0.552,0,0.6-0.447,0.6-1\r\n\tC18,15.447,17.952,15,17.4,15z"
    }
  }]
};
exports.bottom = bottom;
var horizontalMiddle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8,10L5,7v2H1v2h4v2L8,10z M15,13v-2h4V9h-4V7l-3,3L15,13z M10,18c0.553,0,1-0.049,1-0.6V2.6C11,2.047,10.553,2,10,2\r\n\tC9.448,2,9,2.047,9,2.6V17.4C9,17.951,9.448,18,10,18z"
    }
  }]
};
exports.horizontalMiddle = horizontalMiddle;
var left = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,10l3,3v-2h8V9H9V7L6,10z M4,2C3.447,2,3,2.047,3,2.6V17.4C3,17.951,3.447,18,4,18c0.552,0,1-0.049,1-0.6V2.6\r\n\tC5,2.047,4.552,2,4,2z"
    }
  }]
};
exports.left = left;
var right = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,7v2H3v2h8v2l3-3L11,7z M15,2.6V17.4c0,0.551,0.448,0.6,1,0.6c0.553,0,1-0.049,1-0.6V2.6C17,2.047,16.553,2,16,2\r\n\tC15.448,2,15,2.047,15,2.6z"
    }
  }]
};
exports.right = right;
var top = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,6L7,9h2v8h2V9h2L10,6z M18,4c0-0.553-0.048-1-0.6-1H2.6C2.048,3,2,3.447,2,4c0,0.553,0.048,1,0.6,1H17.4\r\n\tC17.952,5,18,4.553,18,4z"
    }
  }]
};
exports.top = top;
var verticalMiddle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,12l-3,3h2v4h2v-4h2L10,12z M13,5h-2V1H9v4H7l3,3L13,5z M18,10c0-0.553-0.048-1-0.6-1H2.6C2.048,9,2,9.447,2,10\r\n\tc0,0.551,0.048,1,0.6,1H17.4C17.952,11,18,10.551,18,10z"
    }
  }]
};
exports.verticalMiddle = verticalMiddle;
var archive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.981,2H6.018c0,0-0.996,0-0.996,1h9.955C14.977,2,13.981,2,13.981,2z M16.968,5c0-1-0.995-1-0.995-1H4.027\r\n\tc0,0-0.995,0-0.995,1v1h13.936V5z M18.958,6C18.37,5.408,18.37,5.408,18.37,5.408V7H1.63V5.408c0,0,0,0-0.589,0.592\r\n\tC0.452,6.592,0.03,6.75,0.267,8c0.236,1.246,1.379,8.076,1.549,9c0.186,1.014,1.217,1,1.217,1h13.936c0,0,1.03,0.014,1.217-1\r\n\tc0.17-0.924,1.312-7.754,1.549-9C19.97,6.75,19.548,6.592,18.958,6z M14,11.997C14,12.551,13.551,13,12.997,13H7.003\r\n\tC6.449,13,6,12.551,6,11.997V10h1v2h6v-2h1V11.997z"
    }
  }]
};
exports.archive = archive;
var graph = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,2v16H0.32c-0.318,0-0.416-0.209-0.216-0.465l4.469-5.748c0.199-0.256,0.553-0.283,0.789-0.062l1.419,1.334\r\n\tc0.235,0.221,0.572,0.178,0.747-0.096l3.047-4.74c0.175-0.273,0.509-0.312,0.741-0.09l2.171,2.096c0.232,0.225,0.559,0.18,0.724-0.1\r\n\tl5.133-7.785C19.51,2.062,19.75,2,20,2z"
    }
  }]
};
exports.graph = graph;
var boldDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5,10H6V3h8v7h3.5L10,17.5L2.5,10z"
    }
  }]
};
exports.boldDown = boldDown;
var boldLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5V6h7v8h-7v3.5L2.5,10L10,2.5z"
    }
  }]
};
exports.boldLeft = boldLeft;
var boldRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.5,10L10,17.5V14H3V6h7V2.5L17.5,10z"
    }
  }]
};
exports.boldRight = boldRight;
var boldUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5l7.5,7.5H14v7H6v-7H2.5L10,2.5z"
    }
  }]
};
exports.boldUp = boldUp;
var down = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,17.5L3.5,11H7V3h6v8h3.5L10,17.5z"
    }
  }]
};
exports.down = down;
var longDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,19.25L4.5,14H8V1h4v13h3.5L10,19.25z"
    }
  }]
};
exports.longDown = longDown;
var longLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.75,10L6,4.5V8h13v4H6v3.5L0.75,10z"
    }
  }]
};
exports.longLeft = longLeft;
var longRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,15.5V12H1V8h13V4.5l5.25,5.5L14,15.5z"
    }
  }]
};
exports.longRight = longRight;
var longUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.75L15.5,6H12v13H8V6H4.5L10,0.75z"
    }
  }]
};
exports.longUp = longUp;
var up = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5L16.5,9H13v8H7V9H3.5L10,2.5z"
    }
  }]
};
exports.up = up;
var withCircleDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M12,6H8v4H5.5l4.5,4.5l4.5-4.5H12V6z"
    }
  }]
};
exports.withCircleDown = withCircleDown;
var withCircleLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,5.5L5.5,10l4.5,4.5V12h4V8h-4V5.5z"
    }
  }]
};
exports.withCircleLeft = withCircleLeft;
var withCircleRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,8H6v4h4v2.5l4.5-4.5L10,5.5V8z"
    }
  }]
};
exports.withCircleRight = withCircleRight;
var withCircleUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,5.5l4.5,4.5H12v4H8v-4H5.5L10,5.5z"
    }
  }]
};
exports.withCircleUp = withCircleUp;
var attachment = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.602,19.8c-1.293,0-2.504-0.555-3.378-1.44c-1.695-1.716-2.167-4.711,0.209-7.116c1.391-1.408,6.966-7.053,9.748-9.87\r\n\tc0.988-1,2.245-1.387,3.448-1.06c1.183,0.32,2.151,1.301,2.468,2.498c0.322,1.22-0.059,2.493-1.046,3.493l-9.323,9.44\r\n\tc-0.532,0.539-1.134,0.858-1.738,0.922c-0.599,0.064-1.17-0.13-1.57-0.535c-0.724-0.736-0.828-2.117,0.378-3.337l6.548-6.63\r\n\tc0.269-0.272,0.705-0.272,0.974,0s0.269,0.714,0,0.986l-6.549,6.631c-0.566,0.572-0.618,1.119-0.377,1.364\r\n\tC5.5,15.252,5.66,15.301,5.845,15.28c0.283-0.029,0.606-0.216,0.909-0.521l9.323-9.439c0.64-0.648,0.885-1.41,0.69-2.145\r\n\tc-0.192-0.725-0.778-1.318-1.493-1.513c-0.726-0.197-1.48,0.052-2.12,0.7c-2.782,2.818-8.356,8.462-9.748,9.87\r\n\tc-1.816,1.839-1.381,3.956-0.209,5.143c1.173,1.187,3.262,1.629,5.079-0.212l9.748-9.87c0.269-0.272,0.705-0.272,0.974,0\r\n\tc0.269,0.272,0.269,0.714,0,0.987L9.25,18.15C8.101,19.312,6.814,19.8,5.602,19.8z"
    }
  }]
};
exports.attachment = attachment;
var ribbon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.574,16.338c-0.757-1.051-2.851-3.824-4.57-6.106c0.696-0.999,1.251-1.815,1.505-2.242\r\n\tc1.545-2.594,0.874-4.26,0.022-5.67C12.677,0.909,12.542,0.094,10,0.094c-2.543,0-2.678,0.815-3.531,2.227\r\n\tC5.615,3.731,4.945,5.397,6.49,7.991c0.254,0.426,0.809,1.243,1.506,2.242c-1.72,2.281-3.814,5.055-4.571,6.106\r\n\tc-0.176,0.244-0.16,0.664,0.009,1.082c0.13,0.322,0.63,1.762,0.752,2.064c0.156,0.389,0.664,0.67,1.082,0.092\r\n\tc0.241-0.334,2.582-3.525,4.732-6.522c2.149,2.996,4.491,6.188,4.732,6.522c0.417,0.578,0.926,0.297,1.082-0.092\r\n\tc0.122-0.303,0.622-1.742,0.752-2.064C16.733,17.002,16.75,16.582,16.574,16.338z M9.634,7.063C8.566,5.579,7.802,3.852,7.802,3.852\r\n\tS8.222,3.094,10,3.094c1.778,0,2.198,0.758,2.198,0.758s-0.766,1.727-1.833,3.211C10.277,7.184,10.147,7.36,10,7.56\r\n\tC9.851,7.36,9.721,7.184,9.634,7.063z"
    }
  }]
};
exports.ribbon = ribbon;
var inTime = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,1.799c-4.445,0-8.061,3.562-8.169,7.996V10H0.459l3.594,3.894L7.547,10H4.875V9.795C4.982,6.492,7.683,3.85,11,3.85\r\n\tc3.386,0,6.131,2.754,6.131,6.15c0,3.396-2.745,6.15-6.131,6.15c-1.357,0-2.611-0.445-3.627-1.193l-1.406,1.504\r\n\tc1.388,1.088,3.135,1.738,5.033,1.738c4.515,0,8.174-3.67,8.174-8.199S15.515,1.799,11,1.799z M10,5v5\r\n\tc0,0.13,0.027,0.26,0.077,0.382c0.051,0.122,0.124,0.233,0.216,0.325l3.2,3.2c0.283-0.183,0.55-0.389,0.787-0.628L12,11V5H10z"
    }
  }]
};
exports.inTime = inTime;
var back = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,7v6c0,1.103-0.896,2-2,2H3v-3h13V8H5v2L1,6.5L5,3v2h12C18.104,5,19,5.896,19,7z"
    }
  }]
};
exports.back = back;
var battery = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.408,10c0-2.766,1.277-4.32,2.277-4.32c0.363,0,1.315,0,1.315,0C18.332,4.621,17.779,4,15.342,4H5.334\r\n\tC1.6,4,0,7.441,0,10c0,2.559,1.6,6,5.334,6h10.008c2.438,0,2.99-0.621,3.658-1.68c0,0-0.315,0-1.315,0S15.408,12.766,15.408,10z\r\n\t M12.688,11.795c-0.164,0.25-0.676,0.016-0.676,0.016l-2.957-1.338c0,0-0.264,0.67-0.467,1.141\r\n\tc-0.205,0.471-0.361,1.004-1.209,0.408c-0.849-0.598-3.581-3.25-3.581-3.25S3.453,8.488,3.625,8.221\r\n\tc0.163-0.252,0.676-0.016,0.676-0.016l2.956,1.336c0,0,0.265-0.668,0.468-1.139C7.93,7.932,8.086,7.396,8.934,7.994\r\n\tc0.849,0.596,3.58,3.25,3.58,3.25S12.859,11.527,12.688,11.795z M18.874,7.928h-0.749c-0.559,0-1.105,0.754-1.105,1.979\r\n\tc0,1.227,0.547,1.98,1.105,1.98h0.749c0.56,0,1.126-0.754,1.126-1.98C20,8.682,19.434,7.928,18.874,7.928z"
    }
  }]
};
exports.battery = battery;
var note = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,1l-0.002,13c0,1.243-1.301,3-3.748,3C12.007,17,11,16.347,11,15.125c0-1.589,1.445-2.55,3-2.55\r\n\tc0.432,0,0.754,0.059,1,0.123V5.364L8,6.637L8,16H7.998c0,1.243-1.301,3-3.748,3C3.007,19,2,18.347,2,17.125\r\n\tc0-1.589,1.445-2.55,3-2.55c0.432,0,0.754,0.059,1,0.123V3L17,1z"
    }
  }]
};
exports.note = note;
var bell = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.65,8.512c-2.28-4.907-3.466-6.771-7.191-6.693C6.132,1.846,6.45,0.857,5.438,1.232C4.428,1.607,5.295,2.156,4.261,3.005\r\n\tc-2.902,2.383-2.635,4.587-1.289,9.84c0.567,2.213-1.367,2.321-0.602,4.465c0.559,1.564,4.679,2.219,9.025,0.607\r\n\tc4.347-1.613,7.086-4.814,6.527-6.378C17.157,9.394,15.611,10.578,14.65,8.512z M10.924,16.595c-3.882,1.44-7.072,0.594-7.207,0.217\r\n\tc-0.232-0.65,1.253-2.816,5.691-4.463c4.438-1.647,6.915-1.036,7.174-0.311C16.735,12.467,14.807,15.154,10.924,16.595z\r\n\t M9.676,13.101c-2.029,0.753-3.439,1.614-4.353,2.389c0.643,0.584,1.847,0.726,3.046,0.281c1.527-0.565,2.466-1.866,2.095-2.904\r\n\tc-0.005-0.013-0.011-0.023-0.016-0.036C10.197,12.913,9.94,13.002,9.676,13.101z"
    }
  }]
};
exports.bell = bell;
var blackboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.539,20H6l1.406-3.698L4.44,15.298L2.539,20z M12.594,16.302L14,20h3.461\r\n\tl-1.901-4.702L12.594,16.302z M18,2h-6.5L11,0H9L8.5,2H2C1.447,2,1,2.447,1,3v11c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V3\r\n\tC19,2.448,18.553,2,18,2z"
    }
  }]
};
exports.blackboard = blackboard;
var block = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M2.399,10c0-4.197,3.402-7.6,7.6-7.6c1.829,0,3.506,0.647,4.817,1.723L4.122,14.817\r\n\tC3.046,13.505,2.399,11.829,2.399,10z M9.999,17.599c-1.828,0-3.505-0.646-4.815-1.722L15.878,5.184\r\n\tC16.953,6.496,17.6,8.171,17.6,10C17.6,14.197,14.196,17.599,9.999,17.599z"
    }
  }]
};
exports.block = block;
var book = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,5.95v10.351c0,0.522-0.452,0.771-1,1.16c-0.44,0.313-1-0.075-1-0.587c0,0,0-9.905,0-10.114\r\n\tc0-0.211-0.074-0.412-0.314-0.535c-0.24-0.123-7.738-4.065-7.738-4.065C6.827,2.115,6.299,1.782,5.595,2.144\r\n\tC4.926,2.488,4.562,2.862,4.469,3.038l8.18,4.482C12.866,7.634,13,7.81,13,8.036v10.802c0,0.23-0.142,0.476-0.369,0.585\r\n\tc-0.104,0.052-0.219,0.077-0.333,0.077c-0.135,0-0.271-0.033-0.386-0.104c-0.215-0.131-7.774-4.766-8.273-5.067\r\n\tc-0.24-0.144-0.521-0.439-0.527-0.658L3,3.385c0-0.198-0.023-0.547,0.289-1.032c0.697-1.084,3.129-2.317,4.36-1.678l8.999,4.555\r\n\tC16.865,5.342,17,5.566,17,5.95z"
    }
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,2v17l-4-4l-4,4V2c0-0.553,0.585-1.02,1-1h6C13.689,0.98,14,1.447,14,2z"
    }
  }]
};
exports.bookmark = bookmark;
var bookmarks = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,0h-4c-0.553,0-1,0.447-1,1l0.023,0.222c1.102,0,2,0.897,2,2v11.359L13,13.4l3,3.6V1C16,0.447,15.553,0,15,0z M9.023,3H5\r\n\tC4.447,3,4,3.447,4,4v16l3-3.6l3,3.6V4C10,3.447,9.576,3,9.023,3z"
    }
  }]
};
exports.bookmarks = bookmarks;
var bowl = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.949,7.472c-2.176,2.902-4.095,3.002-7.046,3.152H9.802c-3.591-0.002-6.138-1.336-6.138-1.832\r\n\tC3.662,8.321,5.962,7.095,9.269,6.973l0.59-1.473c-0.019,0-0.037-0.002-0.057-0.002c-4.908,0-7.791,1.562-7.791,3.051v2\r\n\tc0,0.918,0.582,8.949,7.582,8.949s8-8.031,8-8.949v-2c0-0.391-0.201-0.787-0.584-1.158L16.949,7.472z M17.589,2.702\r\n\tc-0.441-0.33-1.069-0.242-1.399,0.201l-3.608,4.809l2.336-5.838c0.206-0.512-0.044-1.094-0.557-1.301\r\n\tc-0.508-0.205-1.096,0.043-1.3,0.559L9.802,9.274c2.882-0.147,4.277-0.227,6.067-2.611c1.789-2.387,1.919-2.561,1.919-2.561\r\n\tC18.12,3.661,18.031,3.034,17.589,2.702z"
    }
  }]
};
exports.bowl = bowl;
var box = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.399,2H1.6C1.268,2,1,2.267,1,2.6V5h18V2.6C19,2.267,18.73,2,18.399,2z M2,16.6c0,0.77,0.629,1.4,1.399,1.4h13.2\r\n\tc0.77,0,1.4-0.631,1.4-1.4V6H2V16.6z M7,8h6v2H7V8z"
    }
  }]
};
exports.box = box;
var briefcase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9,10h2v2h9c0,0-0.149-4.459-0.2-5.854C19.75,4.82,19.275,4,17.8,4h-3.208c-0.497-0.938-1.032-1.945-1.197-2.256\r\n\tC13.064,1.121,12.951,1,12.216,1H7.783C7.048,1,6.936,1.121,6.604,1.744C6.439,2.055,5.904,3.062,5.408,4H2.199\r\n\tc-1.476,0-1.945,0.82-2,2.146C0.145,7.473,0,12,0,12h9V10z M7.649,2.916C7.879,2.484,7.957,2.4,8.466,2.4h3.067\r\n\tc0.509,0,0.588,0.084,0.816,0.516c0.086,0.16,0.318,0.6,0.575,1.084H7.074C7.331,3.516,7.563,3.076,7.649,2.916z M11,15H9v-2H0.5\r\n\tc0,0,0.124,1.797,0.199,3.322C0.73,16.955,0.917,18,2.499,18H17.5c1.582,0,1.765-1.047,1.8-1.678C19.387,14.754,19.5,13,19.5,13H11\r\n\tV15z"
    }
  }]
};
exports.briefcase = briefcase;
var browser = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,2H2C0.9,2,0,2.9,0,4v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M4.5,3.75\r\n\tc0.414,0,0.75,0.336,0.75,0.75c0,0.414-0.336,0.75-0.75,0.75c-0.414,0-0.75-0.336-0.75-0.75C3.75,4.086,4.086,3.75,4.5,3.75z\r\n\t M1.75,4.5c0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75c0,0.414-0.336,0.75-0.75,0.75\r\n\tC2.086,5.25,1.75,4.914,1.75,4.5z M18,16H2V7h16V16z M18,5H6V4h12.019L18,5z"
    }
  }]
};
exports.browser = browser;
var brush = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.763,13.563c-1.515,1.488-0.235,3.016-2.247,5.279c-0.908,1.023,3.738,0.711,6.039-1.551\r\n\tc0.977-0.961,0.701-2.359-0.346-3.389C5.162,12.874,3.739,12.602,2.763,13.563z M19.539,0.659C18.763-0.105,10.16,6.788,7.6,9.305\r\n\tc-1.271,1.25-1.695,1.92-2.084,2.42c-0.17,0.219,0.055,0.285,0.154,0.336c0.504,0.258,0.856,0.496,1.311,0.943\r\n\tc0.456,0.447,0.699,0.793,0.959,1.289c0.053,0.098,0.121,0.318,0.342,0.152c0.51-0.383,1.191-0.801,2.462-2.049\r\n\tC13.305,9.88,20.317,1.422,19.539,0.659z"
    }
  }]
};
exports.brush = brush;
var bucket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,1C6.092,1,3.002,2.592,3.21,3.95c0.06,0.389,0.225,1.945,0.434,3.273c-2.405,0.934-3.202,2.449-3.095,3.684\r\n\tc0.127,1.461,1.441,3.025,4.328,3.295c1.648,0.154,3.631-0.75,4.916-2.295C9.671,11.7,9.6,11.457,9.6,11.2\r\n\tc0-0.774,0.627-1.4,1.4-1.4c0.774,0,1.4,0.627,1.4,1.4c0,0.762-0.61,1.381-1.369,1.398c-1.529,1.973-3.858,3.164-6.064,3.025\r\n\tc0.051,0.324,0.07,0.947,0.096,1.113C5.153,17.315,7.41,18.996,11,19c3.59-0.004,5.847-1.685,5.938-2.263\r\n\tC17.026,16.16,18.579,5.328,18.79,3.95C18.998,2.592,15.907,1,11,1z M1.943,10.785c-0.055-0.643,0.455-1.498,1.924-2.139\r\n\tc0.211,1.34,0.441,2.797,0.643,4.074C2.906,12.407,2.012,11.571,1.943,10.785z M11,6.024C7.41,6.022,4.863,4.69,4.863,4.192\r\n\tC4.861,3.698,7.41,2.402,11,2.404c3.59-0.002,6.139,1.294,6.137,1.788C17.137,4.69,14.59,6.022,11,6.024z"
    }
  }]
};
exports.bucket = bucket;
var bug = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C7.7907715,1,6,2.7908325,6,5h8C14,2.7908325,12.2092285,1,10,1z M19,10h-3V7.5031738\r\n\tc0-0.02771-0.0065918-0.0535278-0.0080566-0.0808716l2.2150879-2.21521c0.390625-0.3905029,0.390625-1.0236816,0-1.4141846\r\n\tc-0.3903809-0.390564-1.0236816-0.390564-1.4140625,0l-2.215332,2.21521C14.550293,6.0066528,14.5246582,6,14.4970703,6H5.5029297\r\n\tC5.4753418,6,5.449707,6.0066528,5.4223633,6.0081177l-2.215332-2.21521c-0.3903809-0.390564-1.0236816-0.390564-1.4140625,0\r\n\tc-0.390625,0.3905029-0.390625,1.0236816,0,1.4141846l2.2150879,2.21521C4.0065918,7.449646,4,7.4754639,4,7.5031738V10H1\r\n\tc-0.5522461,0-1,0.4476929-1,1c0,0.5522461,0.4477539,1,1,1h3c0,0.7799683,0.15625,1.520813,0.4272461,2.2037354\r\n\tc-0.0441895,0.0316162-0.0947266,0.0494995-0.1342773,0.0891724l-2.8286133,2.8283691\r\n\tc-0.3903809,0.390564-0.3903809,1.0237427,0,1.4142456c0.390625,0.3905029,1.0239258,0.3905029,1.4143066,0L5.4802246,15.93396\r\n\tC6.3725586,16.9555054,7.6027832,17.6751099,9,17.9100342V8h2v9.9100342\r\n\tc1.3972168-0.2349243,2.6274414-0.9545288,3.5197754-1.9760132l2.6015625,2.6015015\r\n\tc0.3903809,0.3905029,1.0236816,0.3905029,1.4143066,0c0.3903809-0.3905029,0.3903809-1.0236816,0-1.4142456l-2.8286133-2.8283691\r\n\tc-0.0395508-0.0396729-0.0900879-0.0575562-0.1342773-0.0891724C15.84375,13.520813,16,12.7799683,16,12h3\r\n\tc0.5522461,0,1-0.4477539,1-1C20,10.4476929,19.5522461,10,19,10z"
    }
  }]
};
exports.bug = bug;
var cake = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.584,6.036c1.952,0,2.591-1.381,1.839-2.843c-0.871-1.693,1.895-3.155,0.521-3.155c-1.301,0-3.736,1.418-4.19,3.183\r\n\tC7.415,4.545,8.05,6.036,9.584,6.036z M14.796,14.987l-0.444-0.383c-0.487-0.42-1.25-0.418-1.735,0l-0.442,0.382\r\n\tc-0.62,0.534-1.397,0.801-2.174,0.801c-0.777,0-1.554-0.267-2.173-0.8l-0.444-0.384c-0.487-0.418-1.249-0.419-1.734,0.001\r\n\tl-0.444,0.383c-1.193,1.028-2.967,1.056-4.204,0.1V19c0,0.552,0.448,1,1,1h16c0.552,0,1-0.448,1-1v-3.912\r\n\tC17.765,16.042,15.991,16.017,14.796,14.987z M10,7c-7.574,0-9,3.361-9,5v0.469l1.164,1.003c0.486,0.421,1.249,0.417,1.735,0\r\n\tl0.444-0.383c1.237-1.065,3.105-1.066,4.345,0l0.444,0.384c0.484,0.417,1.245,0.42,1.735-0.001l0.442-0.382\r\n\tc1.24-1.067,3.107-1.067,4.346-0.001l0.444,0.383c0.487,0.421,1.25,0.417,1.735,0L19,12.469V12C19,10.361,17.574,7,10,7z"
    }
  }]
};
exports.cake = cake;
var calculator = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.6,1H5.398C4.629,1,4,1.629,4,2.4V17.6c0,0.77,0.629,1.4,1.398,1.4H14.6c0.769,0,1.4-0.631,1.4-1.4V2.4\r\n\tC16,1.629,15.369,1,14.6,1z M7,12c0.689,0,1.25,0.447,1.25,1S7.689,14,7,14c-0.69,0-1.25-0.447-1.25-1S6.31,12,7,12z M5.75,10\r\n\tc0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1c0,0.553-0.561,1-1.25,1C6.31,11,5.75,10.553,5.75,10z M7,15\r\n\tc0.689,0,1.25,0.447,1.25,1S7.689,17,7,17c-0.69,0-1.25-0.447-1.25-1S6.31,15,7,15z M10,12c0.689,0,1.25,0.447,1.25,1\r\n\ts-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S9.31,12,10,12z M8.75,10c0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1\r\n\tc0,0.553-0.561,1-1.25,1C9.31,11,8.75,10.553,8.75,10z M10,15c0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1\r\n\tS9.31,15,10,15z M13,12c0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S12.31,12,13,12z M11.75,10\r\n\tc0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1c0,0.553-0.561,1-1.25,1C12.31,11,11.75,10.553,11.75,10z M13,15\r\n\tc0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S12.31,15,13,15z M5,7V4h10v3H5z"
    }
  }]
};
exports.calculator = calculator;
var calendar = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,3h-1v2h-3V3H7v2H4V3H3C1.899,3,1,3.9,1,5v12c0,1.1,0.899,2,2,2h14c1.1,0,2-0.9,2-2V5C19,3.9,18.1,3,17,3z M17,17H3V9h14\r\n\tV17z M6.5,1h-2v3.5h2V1z M15.5,1h-2v3.5h2V1z"
    }
  }]
};
exports.calendar = calendar;
var camera = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,8c-1.657,0-3,1.344-3,3c0,1.656,1.343,3,3,3c1.656,0,3-1.344,3-3C13,9.344,11.656,8,10,8z M18,5h-2.4\r\n\tc-0.33,0-0.686-0.256-0.789-0.57l-0.621-1.861C14.085,2.256,13.731,2,13.4,2H6.6C6.27,2,5.914,2.256,5.811,2.568L5.189,4.43\r\n\tC5.085,4.744,4.73,5,4.4,5H2C0.9,5,0,5.9,0,7v9c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M10,16\r\n\tc-2.762,0-5-2.238-5-5c0-2.762,2.238-5,5-5c2.761,0,5,2.238,5,5C15,13.762,12.761,16,10,16z M17.5,8.2c-0.387,0-0.7-0.314-0.7-0.701\r\n\tc0-0.385,0.313-0.7,0.7-0.7s0.7,0.314,0.7,0.7C18.2,7.886,17.887,8.2,17.5,8.2z"
    }
  }]
};
exports.camera = camera;
var ccw = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.685,10h2.372V9.795c0.108-4.434,3.724-7.996,8.169-7.996c4.515,0,8.174,3.672,8.174,8.201s-3.659,8.199-8.174,8.199\r\n\tc-1.898,0-3.645-0.65-5.033-1.738l1.406-1.504c1.016,0.748,2.27,1.193,3.627,1.193c3.386,0,6.131-2.754,6.131-6.15\r\n\tc0-3.396-2.745-6.15-6.131-6.15c-3.317,0-6.018,2.643-6.125,5.945V10h2.672l-3.494,3.894L0.685,10z"
    }
  }]
};
exports.ccw = ccw;
var chat = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.8,12.2V6H2C0.9,6,0,6.9,0,8v6c0,1.1,0.9,2,2,2h1v3l3-3h5c1.1,0,2-0.9,2-2v-1.82c-0.064,0.014-0.132,0.021-0.2,0.021h-7\r\n\tV12.2z M18,1H9C7.9,1,7,1.9,7,3v8h7l3,3v-3h1c1.1,0,2-0.899,2-2V3C20,1.9,19.1,1,18,1z"
    }
  }]
};
exports.chat = chat;
var check = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.294,16.998c-0.435,0-0.847-0.203-1.111-0.553L3.61,11.724c-0.465-0.613-0.344-1.486,0.27-1.951\r\n\tc0.615-0.467,1.488-0.344,1.953,0.27l2.351,3.104l5.911-9.492c0.407-0.652,1.267-0.852,1.921-0.445\r\n\tc0.653,0.406,0.854,1.266,0.446,1.92L9.478,16.34c-0.242,0.391-0.661,0.635-1.12,0.656C8.336,16.998,8.316,16.998,8.294,16.998z"
    }
  }]
};
exports.check = check;
var smallDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.418,7.859c0.271-0.268,0.709-0.268,0.978,0c0.27,0.268,0.272,0.701,0,0.969l-3.908,3.83\r\n\tc-0.27,0.268-0.707,0.268-0.979,0l-3.908-3.83c-0.27-0.267-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.978,0L10,11L13.418,7.859z\r\n\t"
    }
  }]
};
exports.smallDown = smallDown;
var smallLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.141,13.418c0.268,0.271,0.268,0.709,0,0.978c-0.268,0.27-0.701,0.272-0.969,0l-3.83-3.908\r\n\tc-0.268-0.27-0.268-0.707,0-0.979l3.83-3.908c0.267-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.978L9,10L12.141,13.418z"
    }
  }]
};
exports.smallLeft = smallLeft;
var smallRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,10L7.859,6.58c-0.268-0.27-0.268-0.707,0-0.978c0.268-0.27,0.701-0.27,0.969,0l3.83,3.908\r\n\tc0.268,0.271,0.268,0.709,0,0.979l-3.83,3.908c-0.267,0.272-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.978L11,10z"
    }
  }]
};
exports.smallRight = smallRight;
var smallUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.582,12.141c-0.271,0.268-0.709,0.268-0.978,0c-0.269-0.268-0.272-0.701,0-0.969l3.908-3.83\r\n\tc0.27-0.268,0.707-0.268,0.979,0l3.908,3.83c0.27,0.267,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.979,0L10,9L6.582,12.141z"
    }
  }]
};
exports.smallUp = smallUp;
var thinDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.418,6.109c0.272-0.268,0.709-0.268,0.979,0c0.27,0.268,0.271,0.701,0,0.969l-7.908,7.83\r\n\tc-0.27,0.268-0.707,0.268-0.979,0l-7.908-7.83c-0.27-0.268-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.979,0L10,13.25\r\n\tL17.418,6.109z"
    }
  }]
};
exports.thinDown = thinDown;
var thinLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979c-0.268,0.27-0.701,0.271-0.969,0l-7.83-7.908\r\n\tc-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418\r\n\tz"
    }
  }]
};
exports.thinLeft = thinLeft;
var thinRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908\r\n\tc0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"
    }
  }]
};
exports.thinRight = thinRight;
var thinUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.582,13.891c-0.272,0.268-0.709,0.268-0.979,0s-0.271-0.701,0-0.969l7.908-7.83c0.27-0.268,0.707-0.268,0.979,0\r\n\tl7.908,7.83c0.27,0.268,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.978,0L10,6.75L2.582,13.891z"
    }
  }]
};
exports.thinUp = thinUp;
var withCross = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z\r\n\t M14.789,13.061l-1.729,1.729L10,11.729l-3.061,3.06l-1.729-1.729L8.272,10L5.211,6.939L6.94,5.211L10,8.271l3.061-3.061\r\n\tl1.729,1.729L11.728,10L14.789,13.061z"
    }
  }]
};
exports.withCross = withCross;
var withMinus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z M15,11H5V9\r\n\th10V11z"
    }
  }]
};
exports.withMinus = withMinus;
var withPlus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z M15,11h-4\r\n\tv4H9v-4H5V9h4V5h2v4h4V11z"
    }
  }]
};
exports.withPlus = withPlus;
var circle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6S5.802,2.4,10,2.4c4.197,0,7.601,3.402,7.601,7.6\r\n\tS14.197,17.599,10,17.599z"
    }
  }]
};
exports.circle = circle;
var clapperboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20,3v14c0,0.552-0.447,1-1,1H1c-0.553,0-1-0.448-1-1V3c0-0.553,0.447-1,1-1h1l3,3\r\n\th2.5l-3-3h3l3,3H13l-3-3h3l3,3h2.5l-3-3H19C19.553,2,20,2.448,20,3z"
    }
  }]
};
exports.clapperboard = clapperboard;
var computer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,0H4C2.9,0,2,0.899,2,2v15c0,0.552,0.447,1,1,1v2h14v-2c0.553,0,1-0.448,1-1V2C18,0.899,17.101,0,16,0z M14,15h-4v-1h4\r\n\tV15z M15,11H5V3h10V11z"
    }
  }]
};
exports.computer = computer;
var clipboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,2l-1.2,3H5.6l-1.2-3C3.629,2,3,2.629,3,3.4V18.6c0,0.77,0.629,1.4,1.399,1.4h11.2c0.77,0,1.4-0.631,1.4-1.4V3.4\r\n\tC17,2.629,16.369,2,15.6,2z M13.6,4l0.9-2h-2.181L11.6,0h-3.2L7.68,2H5.5l0.899,2H13.6z"
    }
  }]
};
exports.clipboard = clipboard;
var clock = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.601,3.402,7.601,7.6\r\n\tC17.6,14.197,14.196,17.6,9.999,17.6z M11,9.33V4H9v6.245l-3.546,2.048l1,1.732l4.115-2.377C10.807,11.511,11,11.175,11,10.9v-0.168\r\n\tl4.24-4.166c-0.198-0.271-0.411-0.529-0.647-0.766L11,9.33z"
    }
  }]
};
exports.clock = clock;
var cloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,11.32c0,2.584-2.144,4.68-4.787,4.68H3.617C1.619,16,0,14.416,0,12.463c0-1.951,1.619-3.535,3.617-3.535\r\n\tc0.146,0,0.288,0.012,0.429,0.027C4.009,8.709,3.989,8.457,3.989,8.199C3.989,5.328,6.37,3,9.309,3c2.407,0,4.439,1.562,5.096,3.707\r\n\tc0.263-0.043,0.532-0.066,0.809-0.066C17.856,6.641,20,8.734,20,11.32z"
    }
  }]
};
exports.cloud = cloud;
var code = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.719,14.75c-0.236,0-0.474-0.083-0.664-0.252L-0.005,10l5.341-4.748C5.748,4.887,6.38,4.922,6.747,5.335\r\n\tc0.367,0.413,0.33,1.045-0.083,1.412L3.005,10l3.378,3.002c0.413,0.367,0.45,0.999,0.083,1.412\r\n\tC6.269,14.637,5.994,14.75,5.719,14.75z M14.664,14.748L20.005,10l-5.06-4.498c-0.413-0.367-1.045-0.33-1.411,0.083\r\n\tc-0.367,0.413-0.33,1.045,0.083,1.412L16.995,10l-3.659,3.252c-0.413,0.367-0.45,0.999-0.083,1.412C13.45,14.887,13.725,15,14,15\r\n\tC14.236,15,14.474,14.917,14.664,14.748z M9.986,16.165l2-12c0.091-0.545-0.277-1.06-0.822-1.151\r\n\tc-0.547-0.092-1.061,0.277-1.15,0.822l-2,12c-0.091,0.545,0.277,1.06,0.822,1.151C8.892,16.996,8.946,17,9.001,17\r\n\tC9.481,17,9.905,16.653,9.986,16.165z"
    }
  }]
};
exports.code = code;
var cog = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.783,10c0-1.049,0.646-1.875,1.617-2.443c-0.176-0.584-0.407-1.145-0.692-1.672c-1.089,0.285-1.97-0.141-2.711-0.883\r\n\tc-0.741-0.74-0.968-1.621-0.683-2.711c-0.527-0.285-1.088-0.518-1.672-0.691C12.074,2.57,11.047,3.215,10,3.215\r\n\tc-1.048,0-2.074-0.645-2.643-1.615C6.772,1.773,6.213,2.006,5.686,2.291c0.285,1.09,0.059,1.971-0.684,2.711\r\n\tC4.262,5.744,3.381,6.17,2.291,5.885C2.006,6.412,1.774,6.973,1.6,7.557C2.57,8.125,3.215,8.951,3.215,10\r\n\tc0,1.047-0.645,2.074-1.615,2.643c0.175,0.584,0.406,1.144,0.691,1.672c1.09-0.285,1.971-0.059,2.711,0.682\r\n\tc0.741,0.742,0.969,1.623,0.684,2.711c0.527,0.285,1.087,0.518,1.672,0.693c0.568-0.973,1.595-1.617,2.643-1.617\r\n\tc1.047,0,2.074,0.645,2.643,1.617c0.584-0.176,1.144-0.408,1.672-0.693c-0.285-1.088-0.059-1.969,0.683-2.711\r\n\tc0.741-0.74,1.622-1.166,2.711-0.883c0.285-0.527,0.517-1.086,0.692-1.672C17.429,11.873,16.783,11.047,16.783,10z M10,13.652\r\n\tc-2.018,0-3.653-1.635-3.653-3.652c0-2.018,1.636-3.654,3.653-3.654c2.018,0,3.652,1.637,3.652,3.654\r\n\tC13.652,12.018,12.018,13.652,10,13.652z"
    }
  }]
};
exports.cog = cog;
var colours = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.179,5.998C2.756,5.648,2.122,5.708,1.771,6.13L0.494,7.669c-0.35,0.423-0.291,1.058,0.131,1.407l7.888,6.542L4.706,7.264\r\n\tL3.179,5.998z M7.013,2.683l-1.82,0.829C4.694,3.74,4.471,4.337,4.698,4.836l4.25,9.325l0.213-9.179L8.339,3.178\r\n\tC8.109,2.678,7.513,2.455,7.013,2.683z M14.211,2.887c0.013-0.55-0.427-1.01-0.976-1.023l-2-0.046\r\n\tc-0.549-0.013-1.009,0.427-1.022,0.976L9.974,13.037l4.19-8.167L14.211,2.887z M19.191,3.837l-1.779-0.913\r\n\tc-0.489-0.25-1.096-0.055-1.347,0.434L9.674,15.814c-0.251,0.489-0.056,1.096,0.434,1.347l1.779,0.913\r\n\tc0.489,0.251,1.095,0.056,1.346-0.433l6.391-12.456C19.875,4.694,19.68,4.088,19.191,3.837z M12.799,16.293\r\n\tc-0.252,0.492-0.855,0.686-1.346,0.434c-0.492-0.252-0.685-0.854-0.433-1.346c0.252-0.492,0.854-0.685,1.346-0.433\r\n\tC12.858,15.199,13.051,15.802,12.799,16.293z"
    }
  }]
};
exports.colours = colours;
var compass = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.454,14.548c0,0,4.568-0.627,6.518-2.576s2.576-6.518,2.576-6.518S9.979,6.081,8.03,8.03S5.454,14.548,5.454,14.548z\r\n\t M9.017,9.015c0.818-0.818,2.385-1.4,3.729-1.762c-0.361,1.342-0.945,2.92-1.76,3.732c-0.543,0.545-1.426,0.545-1.969,0\r\n\tC8.472,10.442,8.472,9.56,9.017,9.015z M10.001,0.4C4.698,0.4,0.4,4.698,0.4,10c0,5.303,4.298,9.601,9.601,9.601\r\n\tc5.301,0,9.6-4.298,9.6-9.601C19.601,4.698,15.302,0.4,10.001,0.4z M10,17.6c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6\r\n\tc4.197,0,7.601,3.402,7.601,7.6C17.601,14.197,14.197,17.6,10,17.6z"
    }
  }]
};
exports.compass = compass;
var fastBackward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.959,4.571L10.756,9.52c0,0-0.279,0.201-0.279,0.481s0.279,0.479,0.279,0.479l7.203,4.951\r\n\tC18.531,15.811,19,15.53,19,14.805V5.196C19,4.469,18.531,4.188,17.959,4.571z M8.883,4.571L1.68,9.52c0,0-0.279,0.201-0.279,0.481\r\n\ts0.279,0.479,0.279,0.479l7.203,4.951c0.572,0.381,1.041,0.1,1.041-0.625V5.196C9.924,4.469,9.455,4.188,8.883,4.571z"
    }
  }]
};
exports.fastBackward = fastBackward;
var fastForward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.244,9.52L2.041,4.571C1.469,4.188,1,4.469,1,5.196v9.609c0,0.725,0.469,1.006,1.041,0.625l7.203-4.951\r\n\tc0,0,0.279-0.199,0.279-0.478C9.523,9.721,9.244,9.52,9.244,9.52z M18.6,10.001c0,0.279-0.279,0.478-0.279,0.478l-7.203,4.951\r\n\tc-0.572,0.381-1.041,0.1-1.041-0.625V5.196c0-0.727,0.469-1.008,1.041-0.625L18.32,9.52C18.32,9.52,18.6,9.721,18.6,10.001z"
    }
  }]
};
exports.fastForward = fastForward;
var jumpToStart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.959,4.571L7.756,9.52c0,0-0.279,0.201-0.279,0.481s0.279,0.479,0.279,0.479l7.203,4.951\r\n\tC15.531,15.811,16,15.53,16,14.805V5.196C16,4.469,15.531,4.188,14.959,4.571z M6,4H5C4.447,4,4,4.048,4,4.6V15.4\r\n\tC4,15.952,4.447,16,5,16h1c0.553,0,1-0.048,1-0.6V4.6C7,4.048,6.553,4,6,4z"
    }
  }]
};
exports.jumpToStart = jumpToStart;
var next = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.244,9.52L5.041,4.571C4.469,4.188,4,4.469,4,5.196v9.609c0,0.725,0.469,1.006,1.041,0.625l7.203-4.951\r\n\tc0,0,0.279-0.199,0.279-0.478C12.523,9.721,12.244,9.52,12.244,9.52z M14,4h1c0.553,0,1,0.048,1,0.6V15.4c0,0.552-0.447,0.6-1,0.6\r\n\th-1c-0.553,0-1-0.048-1-0.6V4.6C13,4.048,13.447,4,14,4z"
    }
  }]
};
exports.next = next;
var paus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,3h-2c-0.553,0-1,0.048-1,0.6V16.4c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5\r\n\tC4.447,3,4,3.048,4,3.6V16.4C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
    }
  }]
};
exports.paus = paus;
var play = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852\r\n\tc0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
    }
  }]
};
exports.play = play;
var record = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,3c-3.866,0-7,3.133-7,7c0,3.865,3.134,7,7,7s7-3.135,7-7C17,6.133,13.866,3,10,3z"
    }
  }]
};
exports.record = record;
var stop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808\r\n\tC15.554,4,16,4.446,16,4.995z"
    }
  }]
};
exports.stop = stop;
var volume = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9\r\n\tV13.805z"
    }
  }]
};
exports.volume = volume;
var copy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,0H3C2.447,0,2,0.447,2,1v12c0,0.552,0.447,1,1,1h5v2h2v-2H8.001v-2H10v-2H8v2H4V2h6v4h2V1C12,0.448,11.553,0,11,0z M8,7\r\n\tv1h2V6H9C8.447,6,8,6.447,8,7z M12,20h2v-2h-2V20z M12,8h2V6h-2V8z M8,19c0,0.552,0.447,1,1,1h1v-2H8V19z M17,6h-1v2h2V7\r\n\tC18,6.448,17.553,6,17,6z M16,20h1c0.553,0,1-0.448,1-1v-1h-2V20z M16,12h2v-2h-2V12z M16,16h2v-2h-2V16z"
    }
  }]
};
exports.copy = copy;
var commonsAttribution = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.6,7.6v3.9h-1.1v4.6h-3v-4.6H7.4V7.6C7.4,7.3,7.7,7,8,7H12C12.3,7,12.6,7.3,12.6,7.6z M10,6.5c0.7,0,1.3-0.6,1.3-1.3\r\n\tc0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3C8.7,5.9,9.3,6.5,10,6.5z M19.6,10c0,2.7-0.9,4.9-2.7,6.7c-1.9,1.9-4.2,2.9-6.9,2.9\r\n\tc-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.9-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8C5.1,1.3,7.3,0.4,10,0.4c2.7,0,5,0.9,6.8,2.8\r\n\tC18.7,5,19.6,7.3,19.6,10z M17.9,10c0-2.2-0.8-4-2.3-5.6C14,2.9,12.2,2.1,10,2.1c-2.2,0-4,0.8-5.5,2.3C2.9,6,2.1,7.9,2.1,10\r\n\tc0,2.1,0.8,4,2.3,5.5s3.4,2.3,5.6,2.3c2.1,0,4-0.8,5.6-2.4C17.1,14,17.9,12.2,17.9,10z"
    }
  }]
};
exports.commonsAttribution = commonsAttribution;
var commonsNoderivs = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1s4,0.8,5.6,2.3\r\n\tc1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M6.6,10.8h7v1.7h-7V10.8z M6.6,7.7h7v1.7h-7V7.7z"
    }
  }]
};
exports.commonsNoderivs = commonsNoderivs;
var commonsNoncommercialEu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-0.9,0.1-1.8,0.4-2.6l2.5,1.1H4.9v1.1h0.9\r\n\tc0,0.2,0,0.3,0,0.5v0.3H4.9v1.1h1c0.1,0.9,0.5,1.5,0.9,2.1c0.9,1.2,2.3,1.8,3.9,1.8c1,0,2-0.3,2.5-0.6l-0.4-1.8\r\n\tc-0.3,0.2-1.1,0.4-1.8,0.4c-0.8,0-1.6-0.2-2.1-0.8c-0.2-0.3-0.4-0.6-0.5-1.1H12l5,2.2C16.6,14.4,16.1,15,15.6,15.5z M9.3,10.5\r\n\tL9.3,10.5L9.3,10.5L9.3,10.5z M12.4,9.7h0.1V8.6H9.8L8.7,8.1C8.8,7.9,8.9,7.7,9,7.5c0.5-0.6,1.2-0.9,2-0.9c0.7,0,1.4,0.2,1.8,0.4\r\n\tl0.5-1.8c-0.6-0.3-1.4-0.5-2.4-0.5C9.3,4.7,8,5.3,7.1,6.4C6.9,6.6,6.7,6.9,6.6,7.1L3.4,5.8c0.3-0.5,0.7-0.9,1.1-1.3\r\n\tC6,2.9,7.8,2.1,10,2.1c2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6c0,0.7-0.1,1.4-0.2,2L12.4,9.7z"
    }
  }]
};
exports.commonsNoncommercialEu = commonsNoncommercialEu;
var commonsNoncommercialUs = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10s0.9,4.9,2.8,6.8c1.9,1.9,4.1,2.8,6.8,2.8\r\n\tc2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7S18.7,5,16.8,3.2z M15.6,15.5c-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3\r\n\tC2.9,14,2.1,12.1,2.1,10c0-0.9,0.1-1.8,0.4-2.6l4.9,2.2c0.5,0.2,1,0.4,1.5,0.7l1.1,0.5l0.9,0.4c0.2,0.1,0.3,0.3,0.3,0.6\r\n\tc0,0.7-0.6,1-1.2,1c-0.9,0-1.5-0.3-2.1-0.9l-1.3,1.3c0.8,0.7,1.8,1.1,2.9,1.1v1.5h1.1v-1.5c1.3-0.1,2.4-0.9,2.6-2.1l3.6,1.6\r\n\tC16.6,14.4,16.1,15,15.6,15.5z M12.7,9.9c-0.5-0.2-1-0.4-1.5-0.7l-0.8-0.4L9.1,8.3C9.1,8.2,9,8.1,9,8c0-0.6,0.7-0.7,1.2-0.7\r\n\tc0.6,0,1.2,0.2,1.6,0.6l1.3-1.3c-0.8-0.6-1.7-0.8-2.4-0.9V4.2H9.6v1.5C8.4,5.7,7.4,6.3,7.1,7.4L3.4,5.7c0.3-0.5,0.7-0.9,1.1-1.3\r\n\tC6,2.9,7.8,2.1,10,2.1c2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6c0,0.7-0.1,1.4-0.2,2.1L12.7,9.9z"
    }
  }]
};
exports.commonsNoncommercialUs = commonsNoncommercialUs;
var commonsPublicDomain = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M8.1,7.3H5.5v5.3h1.3v-1.7h1c1.8,0,2.2-1.1,2.2-1.8\r\n\tC10.1,8,9.6,7.3,8.1,7.3z M7.9,9.9H6.8V8.3h1.1c0.6,0,0.9,0.3,0.9,0.8C8.8,9.5,8.5,9.9,7.9,9.9z M12.5,7.3h-2.1v5.3h2.1\r\n\tc1.6,0,2.7-0.8,2.7-2.7C15.2,8.1,14.1,7.3,12.5,7.3z M12.5,11.5h-0.8V8.4h0.8c1,0,1.4,0.7,1.4,1.5C13.9,10.8,13.5,11.5,12.5,11.5z"
    }
  }]
};
exports.commonsPublicDomain = commonsPublicDomain;
var commonsRemix = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M16.3,10.2l-1.9-0.8V7L8.5,4.6L5.9,5.7v2.7l0,0l-2.3,1\r\n\tv2.5l2.5,1.1l2.5-1L8.7,12l5,2.1l0.1,0l0.1,0l2.3-1l0.2-0.1v-2.7L16.3,10.2z M13.6,13.3L13.6,13.3L13.6,13.3l-4.4-1.8V9.8l4.4,1.8\r\n\tv0.1l0,0V13.3z M13.8,11.1l-1.4-0.6L14,9.9l1.4,0.6L13.8,11.1z M15.9,12.6l-1.7,0.7v-1.7l1.7-0.7V12.6z"
    }
  }]
};
exports.commonsRemix = commonsRemix;
var commonsShare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M13.9,7.2h-2.1V5.2c0-0.3-0.2-0.5-0.5-0.5H6.1\r\n\tc0,0,0,0,0,0c-0.3,0-0.5,0.3-0.5,0.5v7.1c0,0.3,0.2,0.5,0.5,0.5h2.1v2.1c0,0.3,0.2,0.5,0.5,0.5h5.2c0.3,0,0.5-0.2,0.5-0.5V7.8\r\n\tC14.5,7.5,14.2,7.2,13.9,7.2z M8.6,7.2c-0.3,0-0.5,0.3-0.5,0.5v3.9H6.6v-6h4.2v1.6H8.6C8.7,7.2,8.7,7.2,8.6,7.2z M13.4,14.3H9.2v-6\r\n\th4.2V14.3z"
    }
  }]
};
exports.commonsShare = commonsShare;
var commonsSharealike = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10s0.9,4.9,2.8,6.8c1.9,1.9,4.1,2.8,6.8,2.8\r\n\tc2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7S18.7,5,16.8,3.2z M15.6,15.5c-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3\r\n\tC2.9,14,2.1,12.1,2.1,10s0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1s4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z\r\n\t M14.9,10.1c0,2.9-2,5.1-5,5.1c-2.1,0-3.9-1.3-4.2-3.8h2.4c0.1,1.3,0.9,1.7,2.1,1.7c1.4,0,2.3-1.3,2.3-3.2c0-2-0.8-3.1-2.2-3.1\r\n\tc-1.1,0-2,0.4-2.2,1.7l0.7,0l-1.9,1.9L5,8.6l0.8,0c0.4-2.4,2.1-3.7,4.2-3.7C13,4.9,14.9,7.2,14.9,10.1z"
    }
  }]
};
exports.commonsSharealike = commonsSharealike;
var commons = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.8,10.8l1.1,0.6c-0.2,0.4-0.6,0.8-1,1.1c-0.4,0.3-0.9,0.4-1.4,0.4c-0.8,0-1.5-0.2-2-0.8C5,11.6,4.8,10.9,4.8,10\r\n\tc0-0.9,0.3-1.6,0.8-2.1C6,7.4,6.7,7.1,7.5,7.1c1.1,0,2,0.4,2.4,1.3L8.7,9.1C8.5,8.8,8.4,8.6,8.2,8.5S7.8,8.4,7.7,8.4\r\n\tc-0.8,0-1.2,0.5-1.2,1.6c0,0.5,0.1,0.9,0.3,1.2c0.2,0.3,0.5,0.4,0.9,0.4C8.2,11.6,8.6,11.4,8.8,10.8z M13,11.6\r\n\tc-0.4,0-0.7-0.1-0.9-0.4c-0.2-0.3-0.3-0.7-0.3-1.2c0-1.1,0.4-1.6,1.2-1.6c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.3,0.5,0.6l1.2-0.6\r\n\tc-0.5-0.9-1.3-1.3-2.4-1.3c-0.8,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2.1c0,0.9,0.2,1.6,0.7,2.1c0.5,0.5,1.2,0.8,2,0.8\r\n\tc0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.8-0.6,1-1.1l-1.2-0.6C13.9,11.4,13.5,11.6,13,11.6z M19.6,10c0,2.7-0.9,4.9-2.7,6.7\r\n\tc-1.9,1.9-4.2,2.9-6.9,2.9c-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.9-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8C5.1,1.3,7.3,0.4,10,0.4\r\n\tc2.7,0,5,0.9,6.8,2.8C18.7,5,19.6,7.3,19.6,10z M17.9,10c0-2.2-0.8-4-2.3-5.6C14,2.9,12.2,2.1,10,2.1c-2.2,0-4,0.8-5.5,2.3\r\n\tC2.9,6,2.1,7.9,2.1,10c0,2.1,0.8,4,2.3,5.5c1.6,1.6,3.4,2.3,5.6,2.3c2.1,0,4-0.8,5.6-2.4C17.1,14,17.9,12.2,17.9,10z"
    }
  }]
};
exports.commons = commons;
var card = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C0.899,3,0,3.9,0,5v10c0,1.1,0.899,2,2,2h16c1.1,0,2-0.9,2-2V5C20,3.9,19.1,3,18,3z M18,15H2V9h16V15z M18,6H2V5h16\r\n\tV6z M4,11.1v0.6h0.6v-0.6H4z M7.6,12.299V12.9h1.2v-0.601h0.6v-0.6H10v-0.6H8.8v0.6H8.199v0.6H7.6z M10,12.9v-0.601H9.399V12.9H10z\r\n\t M7,12.9v-0.601H5.8V12.9H7z M7.6,11.699h0.6v-0.6H7v1.199h0.6V11.699z M5.199,12.299H5.8v-0.6h0.6v-0.6h-1.2v0.6H4.6v0.6H4V12.9\r\n\th1.199V12.299z"
    }
  }]
};
exports.card = card;
var credit = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,16.755V19H9v-2.143c-1.712-0.1-3.066-0.589-4.241-1.797l1.718-1.74c0.859,0.87,2.023,1.16,3.282,1.16\r\n\tc1.565,0,2.405-0.599,2.405-1.702c0-0.483-0.133-0.889-0.42-1.16c-0.267-0.251-0.572-0.387-1.202-0.483L8.9,10.903\r\n\tc-1.164-0.174-2.022-0.541-2.634-1.141C5.618,9.105,5.293,8.216,5.293,7.055c0-2.155,1.382-3.743,3.707-4.1V1h2v1.932\r\n\tc1.382,0.145,2.465,0.62,3.415,1.551l-1.679,1.682c-0.859-0.832-1.889-0.947-2.787-0.947c-1.412,0-2.099,0.792-2.099,1.74\r\n\tc0,0.348,0.115,0.716,0.401,0.986c0.267,0.252,0.706,0.464,1.26,0.541l1.602,0.232c1.241,0.174,2.023,0.522,2.596,1.063\r\n\tc0.726,0.696,1.05,1.702,1.05,2.92C14.759,14.95,13.192,16.362,11,16.755z"
    }
  }]
};
exports.credit = credit;
var crop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,14V1H4v3H1v2h3v8c0,1.0996094,0.8989258,2,2,2h8v3h2v-3h3v-2H6z M14,13h2V6c0-1.0996094-0.8989258-2-2-2H7v2h7V13z"
    }
  }]
};
exports.crop = crop;
var cross = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.348,14.849c-0.469,0.469-1.229,0.469-1.697,0L10,11.819l-2.651,3.029c-0.469,0.469-1.229,0.469-1.697,0\r\n\tc-0.469-0.469-0.469-1.229,0-1.697l2.758-3.15L5.651,6.849c-0.469-0.469-0.469-1.228,0-1.697c0.469-0.469,1.228-0.469,1.697,0\r\n\tL10,8.183l2.651-3.031c0.469-0.469,1.228-0.469,1.697,0c0.469,0.469,0.469,1.229,0,1.697l-2.758,3.152l2.758,3.15\r\n\tC14.817,13.62,14.817,14.38,14.348,14.849z"
    }
  }]
};
exports.cross = cross;
var cup = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C5.721,1,3.06,2.41,3.205,3.555l1.442,13.467C4.705,17.482,6.868,18.998,10,19c3.131-0.002,5.295-1.518,5.351-1.979\r\n\tl1.442-13.467C16.938,2.41,14.279,1,10,1z M10,5.291C6.868,5.289,4.647,4.174,4.647,3.756C4.646,3.342,6.869,2.225,10,2.227\r\n\tc3.131-0.002,5.354,1.115,5.351,1.529C15.351,4.174,13.131,5.289,10,5.291z"
    }
  }]
};
exports.cup = cup;
var cw = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.315,10h-2.372V9.795c-0.108-4.434-3.724-7.996-8.169-7.996C4.259,1.799,0.6,5.471,0.6,10s3.659,8.199,8.174,8.199\r\n\tc1.898,0,3.645-0.65,5.033-1.738l-1.406-1.504c-1.016,0.748-2.27,1.193-3.627,1.193c-3.386,0-6.131-2.754-6.131-6.15\r\n\ts2.745-6.15,6.131-6.15c3.317,0,6.018,2.643,6.125,5.945V10h-2.672l3.494,3.894L19.315,10z"
    }
  }]
};
exports.cw = cw;
var cycle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.516,14.224c-2.262-2.432-2.222-6.244,0.128-8.611c0.962-0.969,2.164-1.547,3.414-1.736L8.989,1.8\r\n\tC7.234,2.013,5.537,2.796,4.192,4.151c-3.149,3.17-3.187,8.289-0.123,11.531l-1.741,1.752l5.51,0.301l-0.015-5.834L5.516,14.224z\r\n\t M12.163,2.265l0.015,5.834l2.307-2.322c2.262,2.434,2.222,6.246-0.128,8.611c-0.961,0.969-2.164,1.547-3.414,1.736l0.069,2.076\r\n\tc1.755-0.213,3.452-0.996,4.798-2.35c3.148-3.172,3.186-8.291,0.122-11.531l1.741-1.754L12.163,2.265z"
    }
  }]
};
exports.cycle = cycle;
var database = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.726,12.641c-0.843,1.363-3.535,2.361-6.726,2.361c-3.191,0-5.883-0.998-6.727-2.361C3.095,12.351,3,12.506,3,12.648\r\n\tc0,0.144,0,2.002,0,2.002C3,16.59,6.134,18.6,10,18.6s7-2.01,7-3.949c0,0,0-1.858,0-2.002C17,12.506,16.904,12.351,16.726,12.641z\r\n\t M16.737,7.525c-0.83,1.205-3.532,2.09-6.737,2.09c-3.205,0-5.908-0.885-6.738-2.09C3.091,7.277,3,7.412,3,7.523\r\n\tc0,0.113,0,2.357,0,2.357c0,1.762,3.134,3.189,7,3.189s7-1.428,7-3.189c0,0,0-2.244,0-2.357C17,7.412,16.908,7.277,16.737,7.525z\r\n\t M10,1C6.134,1,3,2.18,3,3.633v1.26c0,1.541,3.134,2.791,7,2.791s7-1.25,7-2.791v-1.26C17,2.18,13.866,1,10,1z"
    }
  }]
};
exports.database = database;
var pad = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6,0H4C3.448,0,3,0.448,3,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1\r\n\tC7,0.448,6.552,0,6,0z M11,0H9C8.448,0,8,0.448,8,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1C12,0.448,11.552,0,11,0z M16,0\r\n\th-2c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1C17,0.448,16.552,0,16,0z M6,5H4C3.448,5,3,5.448,3,6v2\r\n\tc0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V6C7,5.448,6.552,5,6,5z M11,5H9C8.448,5,8,5.448,8,6v2c0,0.552,0.448,1,1,1h2\r\n\tc0.552,0,1-0.448,1-1V6C12,5.448,11.552,5,11,5z M16,5h-2c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V6\r\n\tC17,5.448,16.552,5,16,5z M6,10H4c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C7,10.448,6.552,10,6,10z\r\n\t M11,10H9c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C12,10.448,11.552,10,11,10z M11,16H9\r\n\tc-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C12,16.448,11.552,16,11,16z M16,10h-2c-0.552,0-1,0.448-1,1\r\n\tv2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C17,10.448,16.552,10,16,10z"
    }
  }]
};
exports.pad = pad;
var direction = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.06,1.941c-0.586-0.586-1.144-0.033-3.041,0.879C9.944,5.259,1.1,10.216,1.1,10.216L8.699,11.3l1.085,7.599\r\n\tc0,0,4.958-8.843,7.396-13.916C18.092,3.085,18.645,2.527,18.06,1.941z M16.236,3.896l-5.519,10.247l-0.561-4.655L16.236,3.896z"
    }
  }]
};
exports.direction = direction;
var landscape = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,3H1C0.448,3,0,3.447,0,4v12c0,0.553,0.448,1,1,1h18c0.552,0,1-0.447,1-1V4C20,3.447,19.553,3,19,3z M18,15H2V5h16V15z"
    }
  }]
};
exports.landscape = landscape;
var document = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M15,17H5V3h10V17z"
    }
  }]
};
exports.document = document;
var documents = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.398,7.415l-7.444-1.996l-1.303-4.861c-0.109-0.406-0.545-0.642-0.973-0.529L0.602,2.461\r\n\tC0.174,2.575-0.084,2.999,0.025,3.405l3.23,12.051c0.109,0.406,0.544,0.643,0.971,0.527l3.613-0.967l-0.492,1.838\r\n\tc-0.109,0.406,0.149,0.83,0.577,0.943l8.11,2.174c0.428,0.115,0.862-0.121,0.972-0.529l2.97-11.084\r\n\tC20.084,7.952,19.826,7.528,19.398,7.415z M1.633,3.631l7.83-2.096l2.898,10.818l-7.83,2.096L1.633,3.631z M15.678,18.463\r\n\tL8.864,16.6L9.4,14.598l3.901-1.047c0.428-0.113,0.688-0.537,0.578-0.943l-1.508-5.627l5.947,1.631L15.678,18.463z"
    }
  }]
};
exports.documents = documents;
var single = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.8,10c0,1.215,0.986,2.2,2.201,2.2S12.2,11.214,12.2,10c0-1.215-0.984-2.199-2.199-2.199S7.8,8.785,7.8,10z"
    }
  }]
};
exports.single = single;
var threeHorizontal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,7.8C8.786,7.8,7.8,8.785,7.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,7.8,10.001,7.8z\r\n\t M3.001,7.8C1.786,7.8,0.8,8.785,0.8,10s0.986,2.2,2.201,2.2C4.216,12.2,5.2,11.214,5.2,10S4.216,7.8,3.001,7.8z M17.001,7.8\r\n\tC15.786,7.8,14.8,8.785,14.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S18.216,7.8,17.001,7.8z"
    }
  }]
};
exports.threeHorizontal = threeHorizontal;
var threeVertical = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,7.8C8.786,7.8,7.8,8.785,7.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,7.8,10.001,7.8z\r\n\t M10.001,5.2C11.216,5.2,12.2,4.214,12.2,3S11.216,0.8,10.001,0.8C8.786,0.8,7.8,1.785,7.8,3S8.786,5.2,10.001,5.2z M10.001,14.8\r\n\tC8.786,14.8,7.8,15.785,7.8,17s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,14.8,10.001,14.8z"
    }
  }]
};
exports.threeVertical = threeVertical;
var twoHorizontal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.001,7.8C12.786,7.8,11.8,8.785,11.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S15.216,7.8,14.001,7.8z\r\n\t M6.001,7.8C4.786,7.8,3.8,8.785,3.8,10s0.986,2.2,2.201,2.2C7.216,12.2,8.2,11.214,8.2,10S7.216,7.8,6.001,7.8z"
    }
  }]
};
exports.twoHorizontal = twoHorizontal;
var twoVertical = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,8.2C11.216,8.2,12.2,7.214,12.2,6S11.216,3.8,10.001,3.8C8.786,3.8,7.8,4.785,7.8,6S8.786,8.2,10.001,8.2z\r\n\t M10.001,11.8C8.786,11.8,7.8,12.785,7.8,14s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,11.8,10.001,11.8z"
    }
  }]
};
exports.twoVertical = twoVertical;
var download = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757\r\n\tl3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408\r\n\tL5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449\r\n\tl0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074\r\n\tC20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  }]
};
exports.download = download;
var drink = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.538,2.639C17.932,2.094,18,1,18,1H2c0,0,0.068,1.094,0.462,1.639L9,11v6H7c-2,0-2,2-2,2h10c0,0,0-2-2-2h-2v-6\r\n\tL17.538,2.639z M9.4,6c0-0.885,0.716-1.6,1.6-1.6s1.6,0.715,1.6,1.6c0,0.883-0.716,1.6-1.6,1.6S9.4,6.883,9.4,6z"
    }
  }]
};
exports.drink = drink;
var drive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H5.546C4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927\r\n\tc-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18h14.383c0.755,0,1.399-0.546,1.523-1.291\r\n\tl0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M16.959,15.245C16.887,15.681,16.51,16,16.068,16H3.932\r\n\tc-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867c0.558,0,0.983,0.501,0.891,1.052\r\n\tL16.959,15.245z"
    }
  }]
};
exports.drive = drive;
var drop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.203,0.561c-0.027-0.215-0.38-0.215-0.406,0C8.914,7.668,4.399,9.133,4.399,14.073c0,3.053,2.564,5.527,5.601,5.527\r\n\tc3.036,0,5.6-2.475,5.6-5.527C15.6,9.133,11.086,7.668,10.203,0.561z M9.35,8.418C9.291,8.637,9.227,8.862,9.161,9.096\r\n\tc-0.401,1.424-0.856,3.039-0.856,4.906c0,1.012-0.598,1.371-1.156,1.371c-0.639,0-1.156-0.523-1.156-1.166\r\n\tc0-2.207,1.062-3.649,2-4.92c0.295-0.398,0.572-0.775,0.797-1.15C8.893,7.965,9.17,7.973,9.296,8.143\r\n\tC9.355,8.223,9.375,8.325,9.35,8.418z"
    }
  }]
};
exports.drop = drop;
var edit = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.561,2.439c-1.442-1.443-2.525-1.227-2.525-1.227L8.984,7.264L2.21,14.037L1.2,18.799l4.763-1.01l6.774-6.771\r\n\tl6.052-6.052C18.788,4.966,19.005,3.883,17.561,2.439z M5.68,17.217l-1.624,0.35c-0.156-0.293-0.345-0.586-0.69-0.932\r\n\tc-0.346-0.346-0.639-0.533-0.932-0.691l0.35-1.623l0.47-0.469c0,0,0.883,0.018,1.881,1.016c0.997,0.996,1.016,1.881,1.016,1.881\r\n\tL5.68,17.217z"
    }
  }]
};
exports.edit = edit;
var email = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.608,12.172c0,0.84,0.239,1.175,0.864,1.175c1.393,0,2.28-1.775,2.28-4.727c0-4.512-3.288-6.672-7.393-6.672\r\n\tc-4.223,0-8.064,2.832-8.064,8.184c0,5.112,3.36,7.896,8.52,7.896c1.752,0,2.928-0.192,4.727-0.792l0.386,1.607\r\n\tc-1.776,0.577-3.674,0.744-5.137,0.744c-6.768,0-10.393-3.72-10.393-9.456c0-5.784,4.201-9.72,9.985-9.72\r\n\tc6.024,0,9.215,3.6,9.215,8.016c0,3.744-1.175,6.6-4.871,6.6c-1.681,0-2.784-0.672-2.928-2.161\r\n\tc-0.432,1.656-1.584,2.161-3.145,2.161c-2.088,0-3.84-1.609-3.84-4.848c0-3.264,1.537-5.28,4.297-5.28\r\n\tc1.464,0,2.376,0.576,2.782,1.488l0.697-1.272h2.016v7.057H14.608z M11.657,9.004c0-1.319-0.985-1.872-1.801-1.872\r\n\tc-0.888,0-1.871,0.719-1.871,2.832c0,1.68,0.744,2.616,1.871,2.616c0.792,0,1.801-0.504,1.801-1.896V9.004z"
    }
  }]
};
exports.email = email;
var flirt = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.5,9.75C8.329,9.75,9,8.967,9,8S8.329,6.25,7.5,6.25S6,7.034,6,8S6.672,9.75,7.5,9.75z M10,0.4\r\n\tC4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601C19.6,4.698,15.301,0.4,10,0.4z M10,17.599\r\n\tc-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6S17.6,5.802,17.6,10C17.6,14.197,14.197,17.599,10,17.599z M14.341,11.336\r\n\tc-0.363-0.187-0.815-0.043-1.008,0.32c-0.034,0.065-0.869,1.593-3.332,1.593c-2.451,0-3.291-1.513-3.333-1.592\r\n\tc-0.188-0.365-0.632-0.514-1.004-0.329c-0.37,0.185-0.521,0.636-0.335,1.007c0.05,0.099,1.248,2.414,4.672,2.414\r\n\tc3.425,0,4.621-2.316,4.67-2.415C14.855,11.967,14.707,11.524,14.341,11.336z M11.25,8.75h2.5c0.414,0,0.75-0.336,0.75-0.75\r\n\tc0-0.414-0.336-0.75-0.75-0.75h-2.5c-0.414,0-0.75,0.336-0.75,0.75C10.5,8.415,10.836,8.75,11.25,8.75z"
    }
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }]
};
exports.flirt = flirt;
var happy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6S5.802,2.4,10,2.4c4.197,0,7.601,3.402,7.601,7.6\r\n\tS14.197,17.599,10,17.599z M7.501,9.75C8.329,9.75,9,8.967,9,8s-0.672-1.75-1.5-1.75s-1.5,0.783-1.5,1.75S6.672,9.75,7.501,9.75z\r\n\t M12.5,9.75C13.329,9.75,14,8.967,14,8s-0.672-1.75-1.5-1.75S11,7.034,11,8S11.672,9.75,12.5,9.75z M14.341,11.336\r\n\tc-0.363-0.186-0.815-0.043-1.008,0.32c-0.034,0.066-0.869,1.593-3.332,1.593c-2.451,0-3.291-1.513-3.333-1.592\r\n\tc-0.188-0.365-0.632-0.514-1.004-0.329c-0.37,0.186-0.52,0.636-0.335,1.007c0.05,0.099,1.248,2.414,4.672,2.414\r\n\tc3.425,0,4.621-2.316,4.67-2.415C14.855,11.967,14.707,11.524,14.341,11.336z"
    }
  }]
};
exports.happy = happy;
var neutral = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.6,3.402,7.6,7.6\r\n\tC17.6,14.197,14.197,17.599,10,17.599z M12.5,6.251C11.672,6.251,11,7.034,11,8s0.672,1.75,1.5,1.75C13.329,9.75,14,8.967,14,8\r\n\tS13.329,6.251,12.5,6.251z M7.501,9.75C8.329,9.75,9,8.967,9,8s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS6.672,9.75,7.501,9.75z M13,12.25h-6c-0.414,0-0.75,0.336-0.75,0.75c0,0.414,0.336,0.75,0.75,0.75h6c0.414,0,0.75-0.336,0.75-0.75\r\n\tC13.75,12.585,13.415,12.25,13,12.25z"
    }
  }]
};
exports.neutral = neutral;
var sad = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,0.4C4.698,0.4,0.4,4.698,0.4,10c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10.001,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.6,3.402,7.6,7.6\r\n\tC17.6,14.197,14.197,17.599,10,17.599z M12.501,9.75c0.828,0,1.5-0.783,1.5-1.75s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS11.672,9.75,12.501,9.75z M7.501,9.75c0.828,0,1.5-0.783,1.5-1.75s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS6.672,9.75,7.501,9.75z M10.002,11.25c-3.424,0-4.622,2.315-4.672,2.414c-0.186,0.371-0.035,0.821,0.335,1.007\r\n\tC5.773,14.724,5.887,14.75,6,14.75c0.275,0,0.54-0.151,0.672-0.414c0.008-0.017,0.822-1.586,3.33-1.586\r\n\tc2.463,0,3.298,1.527,3.328,1.585c0.184,0.37,0.635,0.523,1.006,0.336c0.371-0.184,0.521-0.636,0.336-1.006\r\n\tC14.623,13.566,13.426,11.25,10.002,11.25z"
    }
  }]
};
exports.sad = sad;
var erase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H8.446c-0.44,0-1.071,0.236-1.402,0.525L0.248,9.473c-0.331,0.289-0.331,0.764,0,1.053l6.796,5.947\r\n\tC7.375,16.762,8.006,17,8.446,17H18c1.1,0,2-0.9,2-2V5C20,3.9,19.1,3,18,3z M15.191,14l-2.557-2.557L10.078,14l-1.443-1.443\r\n\tL11.191,10L8.635,7.443L10.078,6l2.557,2.555L15.19,6l1.444,1.443L14.078,10l2.557,2.555L15.191,14z"
    }
  }]
};
exports.erase = erase;
var eraser = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.998,4.18l-3.154-2.425c-0.872-0.671-2.135-0.506-2.807,0.365l-8.4,10.897c-0.671,0.871-0.507,2.132,0.365,2.803\r\n\tl3.153,2.425c0.872,0.671,2.135,0.506,2.807-0.365l8.401-10.897C18.034,6.112,17.87,4.851,16.998,4.18z M8.548,16.467l-0.537,0.681\r\n\tc-0.152,0.197-0.385,0.31-0.639,0.31c-0.124,0-0.309-0.029-0.485-0.164l-3.153-2.425c-0.168-0.129-0.275-0.317-0.303-0.53\r\n\tc-0.028-0.213,0.028-0.422,0.157-0.589l0.537-0.681c0.152-0.197,0.385-0.311,0.64-0.311c0.124,0,0.309,0.029,0.485,0.164\r\n\tl3.154,2.425c0.168,0.129,0.275,0.317,0.303,0.53C8.733,16.09,8.677,16.299,8.548,16.467z"
    }
  }]
};
exports.eraser = eraser;
var exportIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,15H2V6h2.595c0,0,0.689-0.896,2.17-2H1C0.447,4,0,4.449,0,5v11c0,0.553,0.447,1,1,1h15c0.553,0,1-0.447,1-1v-3.746\r\n\tl-2,1.645V15z M13.361,8.05v3.551L20,6.4l-6.639-4.999v3.131C5.3,4.532,5.3,12.5,5.3,12.5C7.582,8.752,8.986,8.05,13.361,8.05z"
    }
  }]
};
exports.exportIcon = exportIcon;
var withLine = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.5214844,1.4776001C18.131958,1.086853,17.4981079,1.086792,17.1074829,1.477478L1.4785156,17.1084595\r\n\tc-0.390625,0.390625-0.390625,1.0244141,0.0001221,1.4140015c0.390625,0.390686,1.0233765,0.390625,1.4140015-0.000061\r\n\tL18.5214233,2.8916016C18.9121704,2.5009766,18.9121704,1.8682251,18.5214844,1.4776001z M3.1083984,13.4973145l2.5593262-2.5584717\r\n\tC5.5981445,10.6357422,5.5546875,10.3234863,5.5546875,10c0-2.3789062,1.9902344-4.3085938,4.4453125-4.3085938\r\n\tc0.2861328,0,0.5644531,0.0314941,0.8354492,0.081665l1.2021484-1.2016602C11.394043,4.467041,10.7192383,4.4003906,10,4.4003906\r\n\tC3.4394531,4.4003906,0,9.2324219,0,10C0,10.4234619,1.057373,12.0908203,3.1083984,13.4973145z M16.8950195,6.5046387\r\n\tL14.3330078,9.065918C14.4018555,9.3674316,14.4443359,9.6784668,14.4443359,10\r\n\tc0,2.3789062-1.9892578,4.3066406-4.4443359,4.3066406c-0.2839355,0-0.5598145-0.0317383-0.8288574-0.0810547L7.967041,15.4291992\r\n\tC8.609375,15.5330811,9.2827148,15.5996094,10,15.5996094c6.5605469,0,10-4.8339844,10-5.5996094\r\n\tC20,9.5756836,18.9438477,7.9101562,16.8950195,6.5046387z"
    }
  }]
};
exports.withLine = withLine;
var eye = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,4.4C3.439,4.4,0,9.232,0,10c0,0.766,3.439,5.6,10,5.6c6.56,0,10-4.834,10-5.6C20,9.232,16.56,4.4,10,4.4z M10,14.307\r\n\tc-2.455,0-4.445-1.928-4.445-4.307c0-2.379,1.99-4.309,4.445-4.309c2.455,0,4.444,1.93,4.444,4.309\r\n\tC14.444,12.379,12.455,14.307,10,14.307z M10,10c-0.407-0.447,0.663-2.154,0-2.154c-1.228,0-2.223,0.965-2.223,2.154\r\n\tc0,1.189,0.995,2.154,2.223,2.154c1.227,0,2.223-0.965,2.223-2.154C12.223,9.453,10.346,10.379,10,10z"
    }
  }]
};
exports.eye = eye;
var feather = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.254,19.567c0.307-0.982,0.77-2.364,1.391-4.362c2.707-0.429,3.827,0.341,5.546-2.729\r\n\tc-1.395,0.427-3.077-0.792-2.987-1.321c0.091-0.528,3.913,0.381,6.416-3.173c-3.155,0.696-4.164-0.836-3.757-1.067\r\n\tc0.939-0.534,3.726-0.222,5.212-1.669c0.766-0.745,1.125-2.556,0.813-3.202c-0.374-0.781-2.656-1.946-3.914-1.836\r\n\tc-1.258,0.109-3.231,4.79-3.817,4.754C8.573,4.925,8.454,2.864,9.476,0.949c-1.077,0.477-3.051,1.959-3.67,3.226\r\n\tc-1.153,2.357,0.108,7.766-0.296,7.958c-0.405,0.193-1.766-2.481-2.172-3.694c-0.555,1.859-0.568,3.721,1.053,6.194\r\n\tc-0.611,1.623-0.945,3.491-0.996,4.441C3.371,19.833,4.119,19.996,4.254,19.567z"
    }
  }]
};
exports.feather = feather;
var fingerprint = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.6795855,7.8502398c-0.3737011,0.09375-0.6062469,0.4970703-0.5193815,0.9003906\r\n\tc0.7166376,3.3271484,0.8731756,6.8144531,0.4515181,10.0849619c-0.0524817,0.4106445,0.2126379,0.7895508,0.5926733,0.8461914\r\n\tc0.0325747,0.0048828,0.0651484,0.0073242,0.096818,0.0073242c0.3411264,0,0.6388206-0.2714844,0.6876822-0.6464844\r\n\tc0.4442797-3.4511728,0.2805023-7.1274424-0.4750433-10.6318369C10.4269867,8.0064898,10.0532856,7.7584429,9.6795855,7.8502398z\r\n\t M8.0689611,12.0733843c-0.3818445,0.0380859-0.6632514,0.4033203-0.6279626,0.815918\r\n\tc0.1692061,1.9672852,0.1248689,3.9091806-0.1321073,5.7714853c-0.0561004,0.409668,0.2063046,0.7915039,0.5854349,0.8520508\r\n\tc0.0343838,0.0058594,0.068768,0.0083008,0.1031523,0.0083008c0.3384123,0,0.6352015-0.2675781,0.6867771-0.6396484\r\n\tc0.2723579-1.980957,0.3203154-4.0439463,0.1411562-6.1308603C8.790122,12.3380327,8.439043,12.0304155,8.0689611,12.0733843z\r\n\t M9.1583948,5.4142046c-0.783596,0.1967773-1.4495621,0.7114258-1.8757439,1.4487305\r\n\tC6.8564687,7.6012163,6.7225518,8.4727983,6.9044256,9.3165483c0.08777,0.409668,0.1673961,0.8198242,0.2370691,1.2294922\r\n\tc0.0678635,0.4077148,0.4388499,0.6767578,0.8080268,0.6025391c0.3782248-0.074707,0.6279626-0.4658203,0.5582891-0.8730469\r\n\tc-0.0732918-0.4321289-0.156538-0.8647461-0.2497368-1.2983398c-0.097723-0.4541016-0.0253363-0.9228516,0.2044945-1.3203125\r\n\tc0.2298307-0.3979492,0.5890541-0.6757812,1.0098076-0.78125c0.8722706-0.2192383,1.7418261,0.3706055,1.9436064,1.309082\r\n\tc0.7464972,3.4614258,0.9419441,6.9296875,0.5809107,10.309083c-0.0443373,0.4116211,0.2298307,0.7836914,0.6107702,0.8310547\r\n\tc0.0271454,0.003418,0.0542908,0.0048828,0.0805311,0.0048828c0.3483658,0,0.6487741-0.2817383,0.6894922-0.6640625\r\n\tc0.3791304-3.5507822,0.1746349-7.1914072-0.6080561-10.8203135C12.3950253,6.1026812,10.7789717,5.0118608,9.1583948,5.4142046z\r\n\t M6.7478876,5.9469194c0.2388787-0.3251953,0.1873026-0.796875-0.1140108-1.0537109\r\n\tc-0.302218-0.2573242-0.7383533-0.2001953-0.9754229,0.1230469C5.5363002,5.1827593,5.4222894,5.3580523,5.3173275,5.5396929\r\n\tc-0.753736,1.3056641-0.9917102,2.8481445-0.6686802,4.34375c0.5935779,2.7563477,0.7320194,5.5878906,0.400846,8.1889658\r\n\tc-0.0524807,0.4101562,0.2135434,0.7885742,0.5935783,0.8452148c0.0325747,0.0043945,0.0642443,0.0068359,0.0959134,0.0068359\r\n\tc0.3420315,0,0.6397257-0.2719727,0.6876826-0.6479492c0.3537941-2.7802744,0.2072091-5.7998056-0.4243727-8.7329111\r\n\tC5.7643209,8.4386187,5.9398608,7.2984819,6.4972453,6.3326616C6.5750618,6.197896,6.6583076,6.069478,6.7478876,5.9469194z\r\n\t M15.10956,12.8189898c-0.3827496,0.0205078-0.6786337,0.3720703-0.6596327,0.7861328\r\n\tc0.0633392,1.3837891,0.0434332,2.7739267-0.058814,4.1313486c-0.0316696,0.4130859,0.253356,0.7749023,0.6361055,0.8085938\r\n\tc0.019002,0.0014648,0.0380039,0.0024414,0.0570049,0.0024414c0.3583193,0,0.6623468-0.296875,0.6913023-0.6889648\r\n\tc0.1076765-1.4223633,0.1284876-2.8784189,0.0624342-4.3276377C15.8189583,13.1168413,15.4841652,12.8082476,15.10956,12.8189898z\r\n\t M14.9403534,11.7843218c0.0289555,0,0.05791-0.0019531,0.0868654-0.0058594\r\n\tc0.3809395-0.0507812,0.6505833-0.4257812,0.6035318-0.8364258c-0.1402512-1.2226562-0.3447466-2.4550781-0.6053419-3.6625977\r\n\tc-0.5528603-2.574707-2.7498236-4.4438477-5.22367-4.4438477c-0.390893,0-0.781786,0.0478516-1.1636305,0.1425781\r\n\tc-0.3157902,0.0791016-0.625248,0.1889648-0.9211321,0.3271484C7.3649917,3.4698689,7.2030244,3.9117634,7.3550382,4.291646\r\n\tC7.507957,4.6720171,7.9178519,4.8473101,8.2689314,4.682271c0.2189732-0.1025391,0.449708-0.184082,0.6822538-0.2426758\r\n\tc0.2777872-0.0688477,0.5637178-0.1040039,0.8505535-0.1040039c1.8341208,0,3.4610329,1.3803711,3.8700228,3.2836914\r\n\tc0.2497368,1.1572266,0.4451838,2.3374023,0.5800056,3.5073242C14.2951994,11.5064898,14.5947027,11.7843218,14.9403534,11.7843218z\r\n\t M17.282093,6.7164507c-0.3157921-1.4726562-1.0152359-2.8251951-2.0205193-3.913574\r\n\tc-0.2705488-0.2929688-0.7103033-0.2920532-0.9826622,0.0009155c-0.2723579,0.2924805-0.2723579,0.7734375-0.0018091,1.0664062\r\n\tc0.822504,0.8906248,1.3934612,2.0072629,1.6513424,3.2074583c0.6469641,3.003418,0.9365149,6.0850124,0.860507,9.0986834\r\n\tC16.7789993,16.5904026,17.0812168,17,17.4648705,17h0.0190029c0.3755093,0,0.684063-0.3749294,0.6949196-0.782156\r\n\tC18.257515,13.0757551,17.9562016,9.8443804,17.282093,6.7164507z M3.3900077,12.8546343\r\n\tc0.0334792,0,0.0678635-0.0024414,0.1022475-0.0078125c0.3791301-0.0600586,0.6415353-0.4414062,0.5863395-0.8510742\r\n\tc-0.0841506-0.6181641-0.1954465-1.2524414-0.332078-1.8867188C3.3673866,8.3546343,3.6460788,6.5435991,4.5319219,5.0108843\r\n\tc0.8831291-1.5297849,2.2675419-2.597656,3.8944526-3.0063474c1.4052248-0.3491211,2.9009333-0.1430664,4.1930523,0.5581055\r\n\tc0.3411264,0.1875,0.7600698,0.0371094,0.9328947-0.3325195c0.1728258-0.3701172,0.0343838-0.8212891-0.3085518-1.0073242\r\n\tc-1.5789547-0.8579102-3.4076462-1.105957-5.1304712-0.6796875c-1.9897542,0.5-3.6809092,1.8046875-4.7612944,3.6738279\r\n\tC2.2698097,6.0909624,1.929588,8.3043413,2.3928685,10.4488726c0.1275833,0.59375,0.2316403,1.1870117,0.3103619,1.7646484\r\n\tC2.7539017,12.5865679,3.0506909,12.8546343,3.3900077,12.8546343z M3.5972173,14h-0.023526\r\n\tc-0.3836544,0-0.684063,0.2493391-0.6713951,0.6634016c0.0271454,0.8476562,0.0036194,1.5799913-0.0696731,2.3895617\r\n\tc-0.0380034,0.4121094,0.2415936,0.777544,0.6234381,0.8180714c0.0226212,0.0024414,0.0461471,0.0025425,0.0687683,0.0025425\r\n\tc0.3528895,0,0.6551077-0.2373772,0.6903965-0.6245842c0.0796266-0.875,0.1058669-1.7228241,0.0769119-2.6368866\r\n\tC4.2785654,14.2068329,3.9700134,14,3.5972173,14z"
    }
  }]
};
exports.fingerprint = fingerprint;
var flag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.926,5.584c-9.339,13.568-6.142-0.26-14.037,6.357L6.684,19H4.665L1,4.59l1.85-0.664\r\n\tc8.849-6.471,4.228,5.82,15.637,1.254C18.851,5.033,19.142,5.27,18.926,5.584z"
    }
  }]
};
exports.flag = flag;
var flash = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.803,18.998c-0.194-0.127,3.153-7.16,3.038-7.469c-0.116-0.309-3.665-1.436-3.838-1.979\r\n\tc-0.174-0.543,7.007-8.707,7.196-8.549c0.188,0.158-3.129,7.238-3.039,7.469c0.091,0.23,3.728,1.404,3.838,1.979\r\n\tC14.109,11.024,6.996,19.125,6.803,18.998z"
    }
  }]
};
exports.flash = flash;
var flashlight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.115,2.884c-1.676-1.676-3.779-2.288-4.449-1.618L9.97,3.962C9.561,4.372,9.204,5.741,9.368,7.126l-8.161,8.161\r\n\tc-0.484,0.484-0.092,1.66,0.876,2.629c0.968,0.969,2.146,1.359,2.629,0.877l8.161-8.162c1.386,0.164,2.755-0.193,3.164-0.601\r\n\tl2.696-2.697C19.403,6.663,18.791,4.559,17.115,2.884z M8.141,11.039C7.768,10.667,7.89,9.943,8.41,9.422\r\n\tc0.521-0.521,1.246-0.643,1.618-0.27c0.372,0.371,0.251,1.097-0.27,1.617C9.237,11.291,8.513,11.412,8.141,11.039z M14.891,5.108\r\n\tc-1.298-1.297-1.623-3.01-1.508-3.125c0.115-0.116,1.76,0.277,3.059,1.575c1.298,1.298,1.688,2.946,1.575,3.059\r\n\tC17.905,6.729,16.188,6.407,14.891,5.108z"
    }
  }]
};
exports.flashlight = flashlight;
var branch = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.4,4c0-1.326-1.074-2.4-2.4-2.4S11.6,2.674,11.6,4c0,0.961,0.568,1.784,1.384,2.167c-0.082,1.584-1.27,2.122-3.335,2.896\r\n\tC8.779,9.39,7.82,9.752,7,10.297V6.176C7.825,5.796,8.4,4.967,8.4,4c0-1.326-1.074-2.4-2.4-2.4S3.6,2.674,3.6,4\r\n\tc0,0.967,0.576,1.796,1.4,2.176v7.649C4.175,14.204,3.6,15.033,3.6,16c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4\r\n\tc0-0.961-0.568-1.784-1.384-2.167c0.082-1.583,1.271-2.122,3.335-2.896c2.03-0.762,4.541-1.711,4.64-4.756\r\n\tC15.82,5.803,16.4,4.971,16.4,4z M6,2.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385\r\n\tC5.235,5.385,4.616,4.764,4.616,4C4.616,3.234,5.235,2.615,6,2.615z M6,17.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C7.384,16.764,6.764,17.385,6,17.385z M14,5.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC15.384,4.764,14.764,5.385,14,5.385z"
    }
  }]
};
exports.branch = branch;
var cascade = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,14.6c-0.967,0-1.796,0.576-2.176,1.4H8.5C7.672,16,7,15.328,7,14.5v-3.85C7.456,10.868,7.961,11,8.5,11h3.324\r\n\tc0.38,0.824,1.208,1.4,2.176,1.4c1.326,0,2.4-1.075,2.4-2.4S15.326,7.6,14,7.6c-0.967,0-1.796,0.576-2.176,1.4H8.5\r\n\tC7.672,9,7,8.328,7,7.5V5.176C7.825,4.796,8.4,3.967,8.4,3c0-1.326-1.074-2.4-2.4-2.4S3.6,1.674,3.6,3\r\n\tc0,0.967,0.576,1.796,1.4,2.176V14.5C5,16.433,6.567,18,8.5,18h3.324c0.38,0.824,1.208,1.4,2.176,1.4c1.326,0,2.4-1.075,2.4-2.4\r\n\tS15.326,14.6,14,14.6z M14,8.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tC12.616,9.234,13.235,8.615,14,8.615z M6,1.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385\r\n\tC5.235,4.385,4.616,3.764,4.616,3C4.616,2.234,5.235,1.615,6,1.615z M14,18.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C15.384,17.764,14.764,18.385,14,18.385z"
    }
  }]
};
exports.cascade = cascade;
var line = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,13.824V6.176c0.825-0.38,1.4-1.208,1.4-2.176c0-1.326-1.074-2.4-2.4-2.4S7.6,2.674,7.6,4c0,0.967,0.576,1.796,1.4,2.176\r\n\tv7.649C8.175,14.204,7.6,15.033,7.6,16c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C12.4,15.033,11.825,14.204,11,13.824z\r\n\t M10,2.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C9.235,5.385,8.616,4.764,8.616,4\r\n\tC8.616,3.234,9.235,2.615,10,2.615z M10,17.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C11.384,16.764,10.764,17.385,10,17.385z"
    }
  }]
};
exports.line = line;
var parallel = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.4,4c0-1.326-1.074-2.4-2.4-2.4S3.6,2.674,3.6,4c0,0.967,0.576,1.796,1.4,2.176v7.649C4.175,14.204,3.6,15.033,3.6,16\r\n\tc0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V6.176C7.825,5.796,8.4,4.967,8.4,4z M7.384,16\r\n\tc0,0.764-0.62,1.385-1.384,1.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tC6.764,14.615,7.384,15.234,7.384,16z M6,5.385C5.235,5.385,4.616,4.764,4.616,4c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C7.384,4.764,6.764,5.385,6,5.385z M15,13.824V6.176c0.825-0.38,1.4-1.208,1.4-2.176\r\n\tc0-1.326-1.074-2.4-2.4-2.4S11.6,2.674,11.6,4c0,0.967,0.576,1.796,1.4,2.176v7.649c-0.825,0.38-1.4,1.208-1.4,2.176\r\n\tc0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C16.4,15.033,15.825,14.204,15,13.824z M12.616,4c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C13.235,5.385,12.616,4.764,12.616,4z M14,17.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC15.384,16.764,14.764,17.385,14,17.385z"
    }
  }]
};
exports.parallel = parallel;
var tree = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,14.824V12.5c0-1.933-1.567-3.5-3.5-3.5h-2C11.672,9,11,8.328,11,7.5V5.176c0.825-0.38,1.4-1.208,1.4-2.176\r\n\tc0-1.326-1.074-2.4-2.4-2.4S7.6,1.674,7.6,3c0,0.967,0.576,1.796,1.4,2.176V7.5C9,8.328,8.328,9,7.5,9h-2C3.567,9,2,10.567,2,12.5\r\n\tv2.324C1.175,15.204,0.6,16.033,0.6,17c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V12.5\r\n\tC4,11.672,4.672,11,5.5,11h2c0.539,0,1.044-0.132,1.5-0.35v4.174C8.175,15.204,7.6,16.033,7.6,17c0,1.326,1.074,2.4,2.4,2.4\r\n\ts2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V10.65c0.456,0.218,0.961,0.35,1.5,0.35h2c0.828,0,1.5,0.672,1.5,1.5v2.324\r\n\tc-0.825,0.38-1.4,1.208-1.4,2.176c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C19.4,16.033,18.825,15.204,18,14.824z M10,1.615\r\n\tc0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C9.235,4.385,8.616,3.764,8.616,3\r\n\tC8.616,2.234,9.235,1.615,10,1.615z M3,18.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C4.384,17.764,3.764,18.385,3,18.385z M10,18.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C11.384,17.764,10.764,18.385,10,18.385z M17,18.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC18.384,17.764,17.764,18.385,17,18.385z"
    }
  }]
};
exports.tree = tree;
var flower = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.6591797,8.7595215c0.4396973-1.0861816-0.3630371-2.5083008-1.2099609-3.4055176\r\n\tc0.3283691-1.1893311,0.3718262-2.8215332-0.5253906-3.5754395c-0.8969727-0.7540283-2.4973145-0.4300537-3.6125488,0.0980225\r\n\tC6.2817383,1.1970215,4.7426758,0.651123,3.748291,1.2713623C2.7543945,1.8916016,2.5678711,3.513916,2.7253418,4.7375488\r\n\tc-0.9645996,0.7692871-1.9592285,2.064209-1.6765137,3.201416s1.7678223,1.815918,2.9804688,2.0440674\r\n\tc0.4333496,1.1551514,1.357666,2.5012207,2.5266113,2.5838623c0.828125,0.0585938,1.619873-0.53125,2.223877-1.2633057\r\n\tc1.2209473,1.5201416,2.0817871,3.1278076,2.5551758,4.706543C10.6123047,14.9285889,9.1147461,14,6,14\r\n\tc0,4.1550293,3.0419922,5.0028076,5,5.0028076l3.2001953,0.0020752c0-2.7229004-0.986084-5.909668-3.2895508-8.9008789\r\n\tC11.692627,9.8570557,12.388916,9.4267578,12.6591797,8.7595215z M8.2827148,8.5396729\r\n\tC7.1357422,9.255127,5.6259766,8.9055176,4.9106445,7.7585449C4.1950684,6.6116943,4.5446777,5.1018066,5.6916504,4.3863525\r\n\tS8.3483887,4.020752,9.0639648,5.1674805C9.7792969,6.3144531,9.4296875,7.8242188,8.2827148,8.5396729z M14.0200195,12.2478027\r\n\tc1.0825195,2.1699219,1.6687012,4.4530029,1.6774902,6.7053223C18.9963379,16.5820312,19,12.2062988,19,8.0028076\r\n\tC19,8.0028076,15.3293457,9.0374756,14.0200195,12.2478027z"
    }
  }]
};
exports.flower = flower;
var images = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M12.438,8.375c0.518,0,0.938,0.42,0.938,0.938\r\n\tc0,0.518-0.42,0.938-0.938,0.938S11.5,9.83,11.5,9.312C11.5,8.795,11.92,8.375,12.438,8.375z M5.5,14l2.486-5.714l2.827,4.576\r\n\tl2.424-1.204L14.5,14H5.5z"
    }
  }]
};
exports.images = images;
var music = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M11.942,12.521c-0.128,0.265-0.258,0.279-0.202,0\r\n\tc0.146-0.721,0.047-2.269-1.043-2.441v3.294c0,0.674-0.311,1.262-1.136,1.528c-0.802,0.256-1.699-0.011-1.908-0.586\r\n\tc-0.21-0.576,0.261-1.276,1.052-1.564c0.442-0.161,0.954-0.203,1.299-0.07V8h0.694C10.697,9.633,13.516,9.275,11.942,12.521z"
    }
  }]
};
exports.music = music;
var video = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M8,14V9l4.383,2.5L8,14z"
    }
  }]
};
exports.video = video;
var folder = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,4.799C18.294,4.359,17.75,4,17.195,4h-6.814C9.827,4,9.051,3.682,8.659,3.293L8.063,2.705\r\n\tC7.671,2.316,6.896,2,6.342,2H3.087C2.532,2,2.028,2.447,1.967,2.994L1.675,6h16.931L18.405,4.799z M19.412,7H0.588\r\n\tc-0.342,0-0.61,0.294-0.577,0.635l0.923,9.669C0.971,17.698,1.303,18,1.7,18H18.3c0.397,0,0.728-0.302,0.766-0.696l0.923-9.669\r\n\tC20.022,7.294,19.754,7,19.412,7z"
    }
  }]
};
exports.folder = folder;
var forward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12,11.874v4.357l7-6.69l-7-6.572v3.983c-8.775,0-11,9.732-11,9.732C3.484,12.296,7.237,11.874,12,11.874z"
    }
  }]
};
exports.forward = forward;
var funnel = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C5.092,1,2,2.512,2,4.001v2c0,0.918,6,6,6,6v6c-0.001,0.684,1,1,2,1s2.001-0.316,2-1v-6c0,0,6-5.082,6-6v-2\r\n\tC18,2.512,14.908,1,10,1z M10,6.123C6.409,6.122,3.862,4.79,3.862,4.292C3.86,3.797,6.41,2.461,10,2.463\r\n\tc3.59-0.002,6.14,1.334,6.138,1.828C16.138,4.79,13.591,6.122,10,6.123z"
    }
  }]
};
exports.funnel = funnel;
var controller = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.444,9.361c-0.882-4.926-2.854-6.379-3.903-6.379\r\n\tc-1.637,0-2.057,1.217-5.541,1.258C6.516,4.199,6.096,2.982,4.459,2.982c-1.049,0-3.022,1.453-3.904,6.379\r\n\tc-0.503,2.812-1.049,7.01,0.252,7.514c1.619,0.627,2.168-0.941,3.946-2.266C6.558,13.266,7.424,12.95,10,12.95\r\n\tc2.576,0,3.442,0.316,5.247,1.659c1.778,1.324,2.327,2.893,3.946,2.266C20.494,16.371,19.948,12.174,19.444,9.361z M6,10\r\n\tc-1.105,0-2-0.896-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C8,9.104,7.104,10,6,10z M13,10c-0.553,0-1-0.447-1-1s0.447-1,1-1\r\n\tc0.553,0,1,0.447,1,1S13.553,10,13,10z M15,8c-0.553,0-1-0.447-1-1s0.447-1,1-1c0.553,0,1,0.447,1,1S15.553,8,15,8z"
    }
  }]
};
exports.controller = controller;
var gauge = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.127,13.6c-0.689,1.197-0.225,2.18,0.732,2.732c0.956,0.553,2.041,0.465,2.732-0.732\r\n\tc0.689-1.195,5.047-11.865,4.668-12.084C15.88,3.297,8.817,12.404,8.127,13.6z M10,6c0.438,0,0.864,0.037,1.281,0.109\r\n\tc0.438-0.549,0.928-1.154,1.405-1.728C11.834,4.135,10.934,4,10,4C4.393,4,0,8.729,0,14.766c0,0.371,0.016,0.742,0.049,1.103\r\n\tc0.049,0.551,0.54,0.955,1.084,0.908c0.551-0.051,0.957-0.535,0.908-1.086C2.014,15.389,2,15.076,2,14.766C2,9.85,5.514,6,10,6z\r\n\t M17.219,7.25C16.94,8,16.645,8.764,16.385,9.424C17.4,10.894,18,12.738,18,14.766c0,0.316-0.015,0.635-0.043,0.943\r\n\tc-0.05,0.551,0.355,1.037,0.905,1.088c0.03,0.002,0.061,0.004,0.092,0.004c0.511,0,0.948-0.391,0.995-0.91\r\n\tC19.982,15.521,20,15.143,20,14.766C20,11.812,18.947,9.176,17.219,7.25z"
    }
  }]
};
exports.gauge = gauge;
var globe = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.295,0-9.601,4.307-9.601,9.6c0,5.293,4.306,9.6,9.601,9.6c5.293,0,9.6-4.307,9.6-9.6\r\n\tC19.6,4.707,15.293,0.4,10,0.4z M18.188,10c0,1.873-0.636,3.6-1.696,4.98c-0.3-0.234-0.619-0.867-0.319-1.523\r\n\tc0.303-0.66,0.382-2.188,0.312-2.783c-0.066-0.594-0.375-2.025-1.214-2.039c-0.838-0.012-1.413-0.289-1.911-1.283\r\n\tc-1.033-2.068,1.939-2.465,0.906-3.609c-0.289-0.322-1.783,1.322-2.002-0.869C12.25,2.717,12.399,2.482,12.6,2.238\r\n\tC15.844,3.328,18.188,6.395,18.188,10z M8.875,1.893C8.679,2.275,8.162,2.43,7.848,2.717C7.164,3.336,6.87,3.25,6.502,3.844\r\n\tC6.131,4.438,4.935,5.293,4.935,5.723s0.604,0.936,0.906,0.838c0.302-0.1,1.099-0.094,1.567,0.07\r\n\tc0.469,0.166,3.914,0.332,2.816,3.244c-0.348,0.926-1.873,0.77-2.279,2.303c-0.061,0.225-0.272,1.186-0.285,1.5\r\n\tc-0.025,0.486,0.344,2.318-0.125,2.318c-0.471,0-1.738-1.639-1.738-1.936c0-0.297-0.328-1.338-0.328-2.23\r\n\tc0-0.891-1.518-0.877-1.518-2.062c0-1.068,0.823-1.6,0.638-2.113c-0.181-0.51-1.627-0.527-2.23-0.59\r\n\tC3.412,4.334,5.889,2.307,8.875,1.893z M7.424,17.77c0.492-0.26,0.542-0.596,0.988-0.613c0.51-0.023,0.925-0.199,1.5-0.326\r\n\tc0.51-0.111,1.423-0.629,2.226-0.695c0.678-0.055,2.015,0.035,2.375,0.689c-1.295,0.861-2.848,1.363-4.514,1.363\r\n\tC9.1,18.188,8.234,18.039,7.424,17.77z"
    }
  }]
};
exports.globe = globe;
var cap = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.302,12.238c0.464,1.879,1.054,2.701,3.022,3.562C8.293,16.66,9.228,17.6,10,17.6c0.771,0,1.648-0.822,3.616-1.684\r\n\tc1.969-0.861,1.443-1.123,1.907-3.002L10,15.6L3.302,12.238z M19.511,7.336l-8.325-4.662c-0.652-0.365-1.72-0.365-2.372,0\r\n\tL0.488,7.336c-0.652,0.365-0.652,0.963,0,1.328l8.325,4.662c0.652,0.365,1.72,0.365,2.372,0l5.382-3.014l-5.836-1.367\r\n\tC10.506,9,10.259,9.031,10,9.031c-1.052,0-1.904-0.506-1.904-1.131c0-0.627,0.853-1.133,1.904-1.133c0.816,0,1.51,0.307,1.78,0.734\r\n\tl6.182,2.029l1.549-0.867C20.162,8.299,20.162,7.701,19.511,7.336z M16.967,16.17c-0.065,0.385,1.283,1.018,1.411-0.107\r\n\tc0.579-5.072-0.416-6.531-0.416-6.531l-1.395,0.781C16.567,10.312,17.75,11.438,16.967,16.17z"
    }
  }]
};
exports.cap = cap;
var grid = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8,4H5C4.447,4,4,4.447,4,5v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1V5\r\n\tC9,4.448,8.553,4,8,4z M15,4h-3c-0.553,0-1,0.447-1,1v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1V5C16,4.448,15.553,4,15,4z M8,11\r\n\tH5c-0.553,0-1,0.447-1,1v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1v-3C9,11.448,8.553,11,8,11z M15,11h-3c-0.553,0-1,0.447-1,1v3\r\n\tc0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1v-3C16,11.448,15.553,11,15,11z"
    }
  }]
};
exports.grid = grid;
var hand = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.924,17.315c-0.057,0.174-0.193,0.367-0.416,0.432c-0.161,0.047-5.488,1.59-5.652,1.633\r\n\tc-0.469,0.125-0.795,0.033-1.009-0.156c-0.326-0.287-4.093-2.85-8.845-3.092c-0.508-0.025-0.259-1.951,1.193-1.951\r\n\tc0.995,0,3.904,0.723,4.255,0.371c0.271-0.272,0.394-1.879-0.737-4.683l0,0L4.438,4.232C4.222,3.697,4.482,3.089,5.016,2.873\r\n\tc0.535-0.216,1.145,0.043,1.359,0.578c0,0,1.791,4.438,1.986,4.919c0.193,0.48,0.431,0.662,0.69,0.562\r\n\tC9.282,8.844,9.33,8.69,9.19,8.223L7.144,2.195C6.958,1.649,7.25,1.057,7.796,0.871c0.547-0.187,1.141,0.106,1.325,0.652\r\n\tl1.946,5.732c0.172,0.504,0.354,0.768,0.642,0.646c0.173-0.073,0.161-0.338,0.115-0.569l-1.366-5.471\r\n\tc-0.14-0.561,0.201-1.127,0.761-1.267c0.56-0.139,1.125,0.2,1.266,0.761l1.26,5.042c0.184,0.741,0.353,1.008,0.646,0.935\r\n\tc0.299-0.073,0.285-0.319,0.244-0.522c-0.095-0.475-0.872-4.328-0.872-4.328c-0.103-0.515,0.23-1.015,0.744-1.118\r\n\tc0.513-0.103,1.014,0.23,1.116,0.743l0.948,4.711l0.001,0.001c0,0,0,0,0,0.001l0.568,2.825c0.124,0.533,0.266,1.035,0.45,1.527\r\n\tC18.675,14.061,18.109,16.736,17.924,17.315z"
    }
  }]
};
exports.hand = hand;
var outlined = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.19,4.156c-1.672-1.535-4.383-1.535-6.055,0L10,5.197L8.864,4.156c-1.672-1.535-4.382-1.535-6.054,0\r\n\tc-1.881,1.726-1.881,4.519,0,6.245L10,17l7.19-6.599C19.07,8.675,19.07,5.881,17.19,4.156z M16.124,9.375L10,15.09L3.875,9.375\r\n\tC3.258,8.808,3.019,8.068,3.019,7.281s0.138-1.433,0.756-1.999C4.32,4.781,5.053,4.505,5.838,4.505c0.784,0,1.517,0.476,2.062,0.978\r\n\tL10,7.308l2.099-1.826c0.546-0.502,1.278-0.978,2.063-0.978s1.518,0.276,2.063,0.777c0.618,0.566,0.755,1.212,0.755,1.999\r\n\tS16.742,8.808,16.124,9.375z"
    }
  }]
};
exports.outlined = outlined;
var heart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.19,4.155c-1.672-1.534-4.383-1.534-6.055,0L10,5.197L8.864,4.155c-1.672-1.534-4.382-1.534-6.054,0\r\n\tc-1.881,1.727-1.881,4.52,0,6.246L10,17l7.19-6.599C19.07,8.675,19.07,5.881,17.19,4.155z"
    }
  }]
};
exports.heart = heart;
var withCircle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6c5.301,0,9.6-4.298,9.6-9.601C19.6,4.698,15.301,0.4,10,0.4z\r\n\t M9.849,15.599H9.798c-0.782-0.023-1.334-0.6-1.311-1.371c0.022-0.758,0.587-1.309,1.343-1.309l0.046,0.002\r\n\tc0.804,0.023,1.35,0.594,1.327,1.387C11.18,15.068,10.625,15.599,9.849,15.599z M13.14,9.068c-0.184,0.26-0.588,0.586-1.098,0.983\r\n\tl-0.562,0.387c-0.308,0.24-0.494,0.467-0.563,0.688c-0.056,0.174-0.082,0.221-0.087,0.576v0.09H8.685l0.006-0.182\r\n\tc0.027-0.744,0.045-1.184,0.354-1.547c0.485-0.568,1.555-1.258,1.6-1.287c0.154-0.115,0.283-0.246,0.379-0.387\r\n\tc0.225-0.311,0.324-0.555,0.324-0.793c0-0.334-0.098-0.643-0.293-0.916c-0.188-0.266-0.545-0.398-1.061-0.398\r\n\tc-0.512,0-0.863,0.162-1.072,0.496c-0.216,0.341-0.325,0.7-0.325,1.067v0.092H6.386L6.39,7.841c0.057-1.353,0.541-2.328,1.435-2.897\r\n\tC8.388,4.583,9.089,4.4,9.906,4.4c1.068,0,1.972,0.26,2.682,0.772c0.721,0.519,1.086,1.297,1.086,2.311\r\n\tC13.673,8.05,13.494,8.583,13.14,9.068z"
    }
  }]
};
exports.withCircle = withCircle;
var help = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.help = help;
var home = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.672,11H17v6c0,0.445-0.194,1-1,1h-4v-6H8v6H4c-0.806,0-1-0.555-1-1v-6H1.328c-0.598,0-0.47-0.324-0.06-0.748L9.292,2.22\r\n\tC9.487,2.018,9.743,1.918,10,1.908c0.257,0.01,0.513,0.109,0.708,0.312l8.023,8.031C19.142,10.676,19.27,11,18.672,11z"
    }
  }]
};
exports.home = home;
var glass = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,4.576c0-2.139,0-2.348,0-2.348C15.6,1.439,13.092,0,10,0C6.907,0,4.4,1.439,4.4,2.228c0,0,0,0.209,0,2.348\r\n\tC4.4,6.717,8.277,8.484,8.277,10c0,1.514-3.877,3.281-3.877,5.422c0,2.141,0,2.35,0,2.35C4.4,18.56,6.907,20,10,20\r\n\tc3.092,0,5.6-1.44,5.6-2.229c0,0,0-0.209,0-2.35c0-2.141-3.877-3.908-3.877-5.422C11.723,8.484,15.6,6.717,15.6,4.576z M5.941,2.328\r\n\tc0.696-0.439,2-1.082,4.114-1.082c2.113,0,4.006,1.082,4.006,1.082c0.142,0.086,0.698,0.383,0.317,0.609\r\n\tC13.54,3.434,11.9,3.957,10,3.957c-1.9,0-3.484-0.576-4.324-1.074C5.295,2.658,5.941,2.328,5.941,2.328z M10.501,10\r\n\tc0,1.193,0.996,1.961,2.051,2.986c0.771,0.748,1.826,1.773,1.826,2.435v1.328c-0.97-0.483-3.872-0.955-3.872-2.504\r\n\tc0-0.783-1.013-0.783-1.013,0c0,1.549-2.902,2.021-3.872,2.504v-1.328c0-0.662,1.056-1.688,1.826-2.435\r\n\tC8.502,11.961,9.498,11.193,9.498,10c0-1.193-0.996-1.961-2.051-2.986c-0.771-0.75-1.826-1.775-1.826-2.438L5.575,3.578\r\n\tC6.601,4.131,8.227,4.656,10,4.656c1.772,0,3.406-0.525,4.433-1.078l-0.055,0.998c0,0.662-1.056,1.688-1.826,2.438\r\n\tC11.498,8.039,10.501,8.807,10.501,10z"
    }
  }]
};
exports.glass = glass;
var inverted = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C1.447,3,1,3.447,1,4v12c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V4C19,3.448,18.553,3,18,3z M13.25,6.5\r\n\tc0.69,0,1.25,0.56,1.25,1.25S13.94,9,13.25,9S12,8.44,12,7.75S12.56,6.5,13.25,6.5z M4,14l3.314-7.619l3.769,6.102l3.231-1.605\r\n\tL16,14H4z"
    }
  }]
};
exports.inverted = inverted;
var image = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19,2H1C0.447,2,0,2.447,0,3v14c0,0.552,0.447,1,1,1h18c0.553,0,1-0.448,1-1V3\r\n\tC20,2.448,19.553,2,19,2z M18,16H2V4h16V16z M14.315,10.877l-3.231,1.605L7.314,6.381L4,14h12L14.315,10.877z M13.25,9\r\n\tc0.69,0,1.25-0.56,1.25-1.25S13.94,6.5,13.25,6.5S12,7.06,12,7.75S12.56,9,13.25,9z"
    }
  }]
};
exports.image = image;
var inbox = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.253,9.542c-0.388-0.416-2.265-2.271-3.122-3.118C15.868,6.165,15.492,6,15.098,6H4.902c-0.394,0-0.77,0.165-1.033,0.424\r\n\tC3.011,7.271,1.135,9.125,0.747,9.542c-0.485,0.521-0.723,0.902-0.624,1.449s0.466,2.654,0.556,3.074\r\n\tC0.767,14.484,1.363,15,1.919,15h16.162c0.556,0,1.152-0.516,1.241-0.935c0.089-0.42,0.457-2.527,0.556-3.074\r\n\tS19.739,10.062,19.253,9.542z M14.014,10.003c-0.101,0-0.193,0.052-0.238,0.133L12.966,12H7.034l-0.809-1.864\r\n\tc-0.045-0.081-0.137-0.133-0.238-0.133H2.473L4.495,8h11.01l2.023,2.003H14.014z"
    }
  }]
};
exports.inbox = inbox;
var infinity = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.902,5.6c-2.079,0-4.358,1.158-5.902,2.916C8.455,6.758,6.175,5.6,4.096,5.6C2.116,5.6,0,6.756,0,10\r\n\tc0,3.244,2.116,4.398,4.096,4.4l0,0c2.079,0,4.358-1.158,5.903-2.916c1.544,1.758,3.823,2.916,5.902,2.916\r\n\tC17.882,14.4,20,13.244,20,10C20,6.756,17.882,5.6,15.902,5.6z M4.096,12.641C2.584,12.641,1.8,11.752,1.8,10\r\n\tc0-1.752,0.784-2.641,2.296-2.641c1.673,0,3.614,1.086,4.807,2.641C7.71,11.555,5.769,12.641,4.096,12.641z M15.902,12.641\r\n\tc-1.673,0-3.614-1.086-4.807-2.641c1.192-1.555,3.135-2.641,4.807-2.641c1.512,0,2.298,0.889,2.298,2.641\r\n\tC18.2,11.752,17.414,12.641,15.902,12.641z"
    }
  }]
};
exports.infinity = infinity;
var info = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.432,0c1.34,0,2.01,0.912,2.01,1.957c0,1.305-1.164,2.512-2.679,2.512c-1.269,0-2.009-0.75-1.974-1.99\r\n\tC9.789,1.436,10.67,0,12.432,0z M8.309,20c-1.058,0-1.833-0.652-1.093-3.524l1.214-5.092c0.211-0.814,0.246-1.141,0-1.141\r\n\tc-0.317,0-1.689,0.562-2.502,1.117L5.4,10.48c2.572-2.186,5.531-3.467,6.801-3.467c1.057,0,1.233,1.273,0.705,3.23l-1.391,5.352\r\n\tc-0.246,0.945-0.141,1.271,0.106,1.271c0.317,0,1.357-0.392,2.379-1.207l0.6,0.814C12.098,19.02,9.365,20,8.309,20z"
    }
  }]
};
exports.info = info;
var install = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H12.02l0.38,4.065h2.7L10,10.293L4.9,6.065h2.7L7.98,2H5.546\r\n\tC4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927c-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18\r\n\th14.383c0.755,0,1.399-0.546,1.523-1.291l0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M16.959,15.245\r\n\tC16.887,15.681,16.51,16,16.068,16H3.932c-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867\r\n\tc0.558,0,0.983,0.501,0.891,1.052L16.959,15.245z"
    }
  }]
};
exports.install = install;
var key = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.691,4.725c-0.503-2.977-3.22-4.967-6.069-4.441C8.772,0.809,6.366,3.1,6.869,6.079c0.107,0.641,0.408,1.644,0.763,2.365\r\n\tl-5.175,7.723c-0.191,0.285-0.299,0.799-0.242,1.141l0.333,1.971c0.058,0.342,0.372,0.572,0.7,0.514l1.516-0.281\r\n\tc0.328-0.059,0.744-0.348,0.924-0.639l2.047-3.311l0.018-0.022l1.386-0.256l2.39-3.879c0.785,0.139,1.912,0.092,2.578-0.031\r\n\tC16.955,10.848,18.194,7.704,17.691,4.725z M15.166,6.252c-0.784,1.17-1.584,0.346-2.703-0.475\r\n\tc-1.119-0.818-2.135-1.322-1.352-2.492c0.784-1.17,2.326-1.455,3.447-0.635C15.678,3.469,15.949,5.082,15.166,6.252z"
    }
  }]
};
exports.key = key;
var keyboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.6,4h-17.2C0.629,4,0,4.629,0,5.4V14.6C0,15.369,0.629,16,1.399,16h17.2c0.77,0,1.4-0.631,1.4-1.4V5.4\r\n\tC20,4.629,19.369,4,18.6,4z M11,6h2v2h-2V6z M14,9v2h-2V9H14z M8,6h2v2H8V6z M11,9v2H9V9H11z M5,6h2v2H5V6z M8,9v2H6V9H8z M2,6h2v2\r\n\tH2V6z M5,9v2H3V9H5z M4,14H2v-2h2V14z M15,14H5v-2h10V14z M18,14h-2v-2h2V14z M15,11V9h2v2H15z M18,8h-4V6h4V8z"
    }
  }]
};
exports.keyboard = keyboard;
var flask = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.432,15C14.387,9.893,12,8.547,12,6V3h0.5C12.776,3,13,2.776,13,2.5v-1\r\n\tC13,1.224,12.776,1,12.5,1h-5C7.224,1,7,1.224,7,1.5v1C7,2.776,7.224,3,7.5,3H8v3c0,2.547-2.387,3.893-4.432,9\r\n\tC2.917,16.625,1.245,19,10,19S17.083,16.625,16.432,15z M14.815,16.751C14.113,16.961,12.716,17.2,10,17.2s-4.113-0.239-4.815-0.449\r\n\tc-0.249-0.074-0.346-0.363-0.258-0.628c0.22-0.67,0.635-1.828,1.411-3.121c1.896-3.159,3.863,0.497,5.5,0.497\r\n\tc1.637,0,1.188-1.561,1.824-0.497c0.774,1.294,1.191,2.451,1.411,3.121C15.161,16.388,15.064,16.676,14.815,16.751z"
    }
  }]
};
exports.flask = flask;
var landline = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.902,0.25C3.498-0.027,2.115,0.875,1.833,2.273c-1.105,5.455-1.105,9.997,0,15.454C2.08,18.952,3.17,19.8,4.388,19.8\r\n\tc0.17,0,0.342-0.016,0.515-0.05c1.412-0.279,2.329-1.638,2.046-3.036c-0.978-4.832-0.978-8.598,0-13.43\r\n\tC7.231,1.888,6.314,0.529,4.902,0.25z M17,2H8.436c0.073,0.467,0.081,0.951-0.017,1.44c-0.936,4.72-0.936,8.398,0,13.12\r\n\tc0.098,0.49,0.09,0.973,0.017,1.44H17c1.1,0,2-0.9,2-2V4C19,2.9,18.101,2,17,2z M12,14.5c-0.828,0-1.5-0.672-1.5-1.5\r\n\ts0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S12.828,14.5,12,14.5z M17,9h-7V5h7V9z"
    }
  }]
};
exports.landline = landline;
var language = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.753,10.909c-0.624-1.707-2.366-2.726-4.661-2.726c-0.09,0-0.176,0.002-0.262,0.006l-0.016-2.063\r\n\tc0,0,3.41-0.588,3.525-0.607s0.133-0.119,0.109-0.231c-0.023-0.111-0.167-0.883-0.188-0.976c-0.027-0.131-0.102-0.127-0.207-0.109\r\n\tc-0.104,0.018-3.25,0.461-3.25,0.461s-0.012-1.953-0.013-2.078c-0.001-0.125-0.069-0.158-0.194-0.156\r\n\tc-0.125,0.002-0.92,0.014-1.025,0.016c-0.105,0.002-0.164,0.049-0.162,0.148c0.002,0.1,0.033,2.307,0.033,2.307\r\n\ts-3.061,0.527-3.144,0.543c-0.084,0.014-0.17,0.053-0.151,0.143c0.019,0.09,0.19,1.094,0.208,1.172\r\n\tc0.018,0.08,0.072,0.129,0.188,0.107c0.115-0.019,2.924-0.504,2.924-0.504l0.035,2.018c-1.077,0.281-1.801,0.824-2.256,1.303\r\n\tc-0.768,0.807-1.207,1.887-1.207,2.963c0,1.586,0.971,2.529,2.328,2.695c3.162,0.387,5.119-3.06,5.769-4.715\r\n\tc1.097,1.506,0.256,4.354-2.094,5.98c-0.043,0.029-0.098,0.129-0.033,0.207c0.065,0.078,0.541,0.662,0.619,0.756\r\n\tc0.08,0.096,0.206,0.059,0.256,0.023C19.394,15.862,20.545,13.077,19.753,10.909z M12.367,14.097\r\n\tc-0.966-0.121-0.944-0.914-0.944-1.453c0-0.773,0.327-1.58,0.876-2.156c0.335-0.354,0.75-0.621,1.229-0.799l0.082,4.277\r\n\tC13.225,14.097,12.811,14.151,12.367,14.097z M14.794,13.544l0.046-4.109c0.084-0.004,0.166-0.01,0.252-0.01\r\n\tc0.773,0,1.494,0.145,1.885,0.361C17.368,10.003,15.954,12.499,14.794,13.544z M5.844,5.876C5.814,5.782,5.741,5.731,5.648,5.731\r\n\th-1.95c-0.093,0-0.165,0.051-0.194,0.144c-0.412,1.299-3.48,10.99-3.496,11.041c-0.017,0.051-0.011,0.076,0.062,0.076h1.733\r\n\tc0.075,0,0.099-0.023,0.114-0.072c0.015-0.051,1.008-3.318,1.008-3.318h3.496c0,0,0.992,3.268,1.008,3.318\r\n\tc0.016,0.049,0.039,0.072,0.113,0.072h1.734c0.072,0,0.078-0.025,0.062-0.076C9.324,16.866,6.255,7.175,5.844,5.876z M3.226,12.194\r\n\tl1.447-5.25l1.447,5.25H3.226z"
    }
  }]
};
exports.language = language;
var laptop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.754,15.631C19.507,15.26,18,13,18,13V4c0-1.102-0.9-2-2-2H4C2.899,2,2,2.898,2,4v9c0,0-1.507,2.26-1.754,2.631\r\n\tC0,16,0,16.213,0,16.5V17c0,0.5,0.5,1,0.999,1h18.002C19.5,18,20,17.5,20,17v-0.5C20,16.213,20,16,19.754,15.631z M7,16l0.6-1h4.8\r\n\tl0.6,1H7z M16,12H4V4h12V12z"
    }
  }]
};
exports.laptop = laptop;
var layers = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.248,11.601c0.45,0.313,1.05,0.313,1.5,0l9.088-5.281c0.236-0.164,0.21-0.518-0.048-0.646l-9.205-3.537\r\n\tc-0.368-0.183-0.802-0.183-1.17,0L0.208,5.674C-0.05,5.801-0.076,6.156,0.16,6.32L9.248,11.601z M19.788,10.811l-2.486-1.233\r\n\tl-5.725,3.327c-0.469,0.309-1.014,0.471-1.579,0.471s-1.11-0.163-1.579-0.471L2.698,9.576l-2.49,1.234\r\n\tc-0.258,0.128-0.284,0.482-0.048,0.646l9.088,6.309c0.45,0.313,1.05,0.313,1.5,0l9.088-6.309\r\n\tC20.072,11.293,20.046,10.939,19.788,10.811z"
    }
  }]
};
exports.layers = layers;
var leaf = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.025,3.587c-4.356,2.556-4.044,7.806-7.096,10.175c-2.297,1.783-5.538,0.88-7.412,0.113c0,0-1.27,1.603-2.181,3.74\r\n\tc-0.305,0.717-1.644-0.073-1.409-0.68C3.905,9.25,14.037,5.416,14.037,5.416S6.888,5.113,2.11,11.356\r\n\tC1.982,9.93,1.77,6.072,5.47,3.706C10.486,0.495,20.042,2.991,19.025,3.587z"
    }
  }]
};
exports.leaf = leaf;
var lifebuoy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.788,3.212c-3.749-3.749-9.827-3.749-13.575,0c-3.75,3.75-3.75,9.828-0.002,13.576c3.75,3.75,9.828,3.75,13.578,0\r\n\tC20.537,13.039,20.537,6.961,16.788,3.212z M6.748,13.252c-1.797-1.797-1.797-4.709,0-6.505c1.795-1.796,4.709-1.796,6.506,0\r\n\tc1.797,1.797,1.795,4.709,0,6.505C11.457,15.049,8.545,15.049,6.748,13.252z M15.347,12.879c0.968-1.799,0.969-3.959,0-5.759\r\n\tl1.783-0.96c1.289,2.391,1.289,5.29,0.002,7.678L15.347,12.879z M13.839,2.869l-0.961,1.784c-1.799-0.967-3.959-0.967-5.756,0\r\n\tL6.161,2.87C8.551,1.582,11.448,1.582,13.839,2.869z M2.87,6.16l1.784,0.961c-0.968,1.798-0.968,3.957-0.001,5.756l-1.784,0.961\r\n\tC1.581,11.449,1.582,8.551,2.87,6.16z M6.159,17.129l0.961-1.783c1.799,0.969,3.96,0.969,5.759,0l0.961,1.785\r\n\tC11.448,18.418,8.55,18.418,6.159,17.129z"
    }
  }]
};
exports.lifebuoy = lifebuoy;
var bulb = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.186,19.172C7.975,19.682,8.887,20.027,10,20\r\n\tc1.111,0.027,2.025-0.318,2.814-0.828L12.797,17H7.203L7.186,19.172z M12.697,16c0-4.357,4.63-5.848,4.283-10.188\r\n\tC16.762,3.074,14.907,0.002,10,0.002c-4.907,0-6.762,3.072-6.981,5.811C2.672,10.152,7.303,11.643,7.303,16H12.697z M5,6\r\n\tc0.207-2.598,2.113-4,5-4c2.886,0,4.654,1.371,4.861,3.969c0.113,1.424-0.705,2.373-1.809,3.926C12.238,11.041,11.449,12.238,11,14\r\n\tH9c-0.449-1.762-1.238-2.959-2.053-4.106C5.844,8.342,4.886,7.424,5,6z"
    }
  }]
};
exports.bulb = bulb;
var link = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.859,14.691l-0.81,0.805c-0.701,0.695-1.843,0.695-2.545,0c-0.336-0.334-0.521-0.779-0.521-1.252\r\n\tc0-0.473,0.186-0.916,0.521-1.252l2.98-2.955c0.617-0.613,1.779-1.515,2.626-0.675c0.389,0.386,1.016,0.384,1.403-0.005\r\n\tc0.385-0.389,0.383-1.017-0.006-1.402C10.069,6.527,7.941,6.791,6.088,8.63l-2.98,2.956C2.393,12.295,2,13.24,2,14.244\r\n\tc0,1.006,0.394,1.949,1.108,2.658c0.736,0.73,1.702,1.096,2.669,1.096c0.967,0,1.934-0.365,2.669-1.096l0.811-0.805\r\n\tc0.389-0.385,0.391-1.012,0.005-1.4C8.875,14.309,8.248,14.307,7.859,14.691z M16.891,3.207c-1.547-1.534-3.709-1.617-5.139-0.197\r\n\tl-1.009,1.002c-0.389,0.386-0.392,1.013-0.006,1.401c0.386,0.389,1.013,0.391,1.402,0.005l1.01-1.001\r\n\tc0.74-0.736,1.711-0.431,2.346,0.197c0.336,0.335,0.522,0.779,0.522,1.252s-0.186,0.917-0.522,1.251l-3.18,3.154\r\n\tc-1.454,1.441-2.136,0.766-2.427,0.477c-0.389-0.386-1.016-0.383-1.401,0.005c-0.386,0.389-0.384,1.017,0.005,1.401\r\n\tc0.668,0.662,1.43,0.99,2.228,0.99c0.977,0,2.01-0.492,2.993-1.467l3.18-3.153C17.605,7.814,18,6.87,18,5.866\r\n\tC18,4.861,17.605,3.917,16.891,3.207z"
    }
  }]
};
exports.link = link;
var list = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.4,9H8.6C8.048,9,8,9.447,8,10s0.048,1,0.6,1H14.4c0.552,0,0.6-0.447,0.6-1S14.952,9,14.4,9z M16.4,14H8.6\r\n\tC8.048,14,8,14.447,8,15s0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1S16.952,14,16.4,14z M8.6,6H16.4C16.952,6,17,5.553,17,5\r\n\ts-0.048-1-0.6-1H8.6C8.048,4,8,4.447,8,5S8.048,6,8.6,6z M5.4,9H3.6C3.048,9,3,9.447,3,10s0.048,1,0.6,1H5.4C5.952,11,6,10.553,6,10\r\n\tS5.952,9,5.4,9z M5.4,14H3.6C3.048,14,3,14.447,3,15s0.048,1,0.6,1H5.4C5.952,16,6,15.553,6,15S5.952,14,5.4,14z M5.4,4H3.6\r\n\tC3.048,4,3,4.447,3,5s0.048,1,0.6,1H5.4C5.952,6,6,5.553,6,5S5.952,4,5.4,4z"
    }
  }]
};
exports.list = list;
var pin = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76\r\n\tc-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z"
    }
  }]
};
exports.pin = pin;
var location = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.367,18.102L18,14h-1.5l0.833,4H2.667L3.5,14H2l-1.368,4.102C0.285,19.146,0.9,20,2,20h16\r\n\tC19.1,20,19.715,19.146,19.367,18.102z M15,5c0-2.761-2.238-5-5-5S5,2.239,5,5c0,4.775,5,10,5,10S15,9.775,15,5z M7.3,5.06\r\n\tc0-1.491,1.208-2.699,2.7-2.699s2.7,1.208,2.7,2.699c0,1.492-1.209,2.7-2.7,2.7S7.3,6.551,7.3,5.06z"
    }
  }]
};
exports.location = location;
var open = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.8,8H14V5.6C14,2.703,12.665,1,10,1C7.334,1,6,2.703,6,5.6V6h2V5.199C8,3.754,8.797,3,10,3c1.203,0,2,0.754,2,2.199V8H4\r\n\tC3.447,8,3,8.646,3,9.199V17c0,0.549,0.428,1.139,0.951,1.307l1.197,0.387C5.672,18.861,6.55,19,7.1,19H12.9\r\n\tc0.549,0,1.428-0.139,1.951-0.307l1.196-0.387C16.571,18.139,17,17.549,17,17V9.199C17,8.646,16.352,8,15.8,8z"
    }
  }]
};
exports.open = open;
var lock = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.8,8H14V5.6C14,2.703,12.665,1,10,1C7.334,1,6,2.703,6,5.6V8H4C3.447,8,3,8.646,3,9.199V17\r\n\tc0,0.549,0.428,1.139,0.951,1.307l1.197,0.387C5.672,18.861,6.55,19,7.1,19H12.9c0.549,0,1.428-0.139,1.951-0.307l1.196-0.387\r\n\tC16.571,18.139,17,17.549,17,17V9.199C17,8.646,16.352,8,15.8,8z M12,8H8V5.199C8,3.754,8.797,3,10,3c1.203,0,2,0.754,2,2.199V8z"
    }
  }]
};
exports.lock = lock;
var out = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,10l-6-5v3H6v4h7v3L19,10z M3,3h8V1H3C1.9,1,1,1.9,1,3v14c0,1.1,0.9,2,2,2h8v-2H3V3z"
    }
  }]
};
exports.out = out;
var login = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,10L8,5v3H1v4h7v3L14,10z M17,17H9v2h8c1.1,0,2-0.9,2-2V3c0-1.1-0.9-2-2-2H9v2h8V17z"
    }
  }]
};
exports.login = login;
var loop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4\r\n\tC19.104,5,20,5.896,20,7z"
    }
  }]
};
exports.loop = loop;
var magnet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.165,17.86c-0.028,0.309,0.217,0.584,0.545,0.611l3.985,0.326c0.329,0.027,0.621-0.203,0.65-0.512l0.311-3.287\r\n\tl-5.18-0.426L12.165,17.86z M2.344,14.999l0.312,3.287c0.028,0.309,0.321,0.539,0.65,0.512l3.985-0.326\r\n\tc0.328-0.027,0.573-0.303,0.546-0.611l-0.312-3.287L2.344,14.999z M1.831,9.583l0.321,3.391l5.181-0.426L7.011,9.161\r\n\tc-0.007-0.082-0.011-0.166-0.011-0.25c0-1.555,1.346-2.82,3-2.82s3,1.266,3,2.82c0,0.084-0.004,0.168-0.012,0.25l-0.321,3.387\r\n\tl5.181,0.426l0.321-3.391c0.021-0.225,0.03-0.449,0.03-0.672C18.2,4.659,14.522,1.2,10,1.2S1.8,4.659,1.8,8.911\r\n\tC1.8,9.134,1.811,9.358,1.831,9.583z"
    }
  }]
};
exports.magnet = magnet;
var mail = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.574,5.286c0.488,0.262,7.248,3.894,7.5,4.029C9.326,9.45,9.652,9.514,9.98,9.514c0.328,0,0.654-0.064,0.906-0.199\r\n\ts7.012-3.767,7.5-4.029C18.875,5.023,19.337,4,18.44,4H1.521C0.624,4,1.086,5.023,1.574,5.286z M18.613,7.489\r\n\tc-0.555,0.289-7.387,3.849-7.727,4.027s-0.578,0.199-0.906,0.199s-0.566-0.021-0.906-0.199S1.941,7.777,1.386,7.488\r\n\tC0.996,7.284,1,7.523,1,7.707S1,15,1,15c0,0.42,0.566,1,1,1h16c0.434,0,1-0.58,1-1c0,0,0-7.108,0-7.292S19.004,7.285,18.613,7.489z"
    }
  }]
};
exports.mail = mail;
var man = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,4c1.104,0,2-0.896,2-2c0-1.105-0.896-2-2-2S8,0.895,8,2C8,3.104,8.896,4,10,4z M15.978,11.583\r\n\tc-0.385-1.775-1.058-4.688-2.042-5.894C12.979,4.516,11.051,4.467,10,4.467h0c-1.051,0-2.979,0.049-3.936,1.222\r\n\tC5.08,6.895,4.407,9.808,4.022,11.583c-0.213,0.983,1.154,1.344,1.511,0.355c0.531-1.473,0.941-2.71,1.839-3.736\r\n\tC7.844,11.109,6.102,16.168,6,19c0,0.552,0.448,1,1,1c0.426,0,0.79-0.266,0.934-0.642C8.391,17.771,10,13.355,10,13.355l0,0l0,0\r\n\tc0,0,1.609,4.416,2.066,6.003C12.21,19.734,12.574,20,13,20c0.552,0,1-0.448,1-1c-0.102-2.832-1.844-7.891-1.372-10.797\r\n\tc0.898,1.026,1.308,2.263,1.839,3.736C14.823,12.927,16.191,12.566,15.978,11.583z"
    }
  }]
};
exports.man = man;
var map = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.447,3.718l-6-3c-0.281-0.141-0.613-0.141-0.895,0l-5.63,2.815L1.316,1.664C1.01,1.562,0.676,1.613,0.415,1.802\r\n\tC0.154,1.99,0,2.292,0,2.613v13.001c0,0.379,0.214,0.725,0.553,0.894l6,3c0.141,0.07,0.294,0.106,0.447,0.106\r\n\ts0.307-0.035,0.447-0.106l5.63-2.814l5.606,1.869c0.305,0.1,0.64,0.049,0.901-0.139c0.261-0.188,0.415-0.49,0.415-0.81V4.612\r\n\tC20,4.233,19.786,3.887,19.447,3.718z M8,5.231l4-2v11.763l-4,2V5.231z M2,4l4,1.333v11.661l-4-2V4z M18,16.227l-4-1.334V3.231l4,2\r\n\tV16.227z"
    }
  }]
};
exports.map = map;
var mask = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.581,5.84c-0.043-0.469-0.462-0.803-0.92-0.73C16.919,5.388,12.835,7,10,7C7.165,7,3.081,5.388,1.339,5.11\r\n\tc-0.458-0.073-0.876,0.26-0.92,0.729C0.277,7.371,0,11.45,0,12.068c0,0.83,3.472,2.732,6,2.732c2.452,0,2.95-2.732,4-2.732\r\n\ts1.548,2.732,4,2.732c2.528,0,6-1.902,6-2.732C20,11.45,19.723,7.371,19.581,5.84z M7.66,10.72c-0.353,0.318-1.335,1.07-2.531,0.835\r\n\tc-1.196-0.235-1.919-1.323-2.166-1.758C2.903,9.691,2.922,9.557,3.007,9.48C3.36,9.162,4.342,8.41,5.539,8.645\r\n\tc1.196,0.235,1.919,1.323,2.166,1.758C7.764,10.509,7.745,10.643,7.66,10.72z M17.037,9.797c-0.246,0.436-0.969,1.523-2.166,1.758\r\n\tc-1.196,0.235-2.179-0.517-2.531-0.835c-0.086-0.077-0.104-0.211-0.045-0.317c0.246-0.436,0.969-1.523,2.166-1.758\r\n\tc1.196-0.235,2.179,0.517,2.531,0.835C17.078,9.557,17.097,9.691,17.037,9.797z"
    }
  }]
};
exports.mask = mask;
var medal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,10c0.528,0,1.026,0.104,1.504,0.256L5.427,1.141C5.368,1.053,5.27,1,5.164,1H1.608C1.491,1,1.42,1.131,1.486,1.229\r\n\tl6.231,9.347C8.404,10.22,9.173,10,10,10z M18.392,1h-3.556c-0.106,0-0.204,0.053-0.263,0.141L10.75,6.875l2,3l5.764-8.646\r\n\tC18.579,1.131,18.509,1,18.392,1z M10,11c-2.209,0-4,1.791-4,4c0,2.209,1.791,4,4,4s4-1.791,4-4C14,12.791,12.209,11,10,11z\r\n\t M12.112,15.117c0.062,0.064,0.052,0.158-0.022,0.208c-0.074,0.05-0.095,0.153-0.049,0.229c0.047,0.076,0.018,0.165-0.065,0.199\r\n\ts-0.125,0.13-0.095,0.214s-0.017,0.165-0.104,0.181s-0.149,0.101-0.137,0.189s-0.051,0.158-0.14,0.155\r\n\tc-0.089-0.003-0.167,0.068-0.174,0.156s-0.083,0.144-0.169,0.123s-0.178,0.031-0.203,0.117s-0.111,0.124-0.191,0.085\r\n\tc-0.08-0.039-0.18-0.006-0.222,0.072s-0.134,0.098-0.205,0.043s-0.175-0.044-0.232,0.024s-0.151,0.068-0.209,0\r\n\ts-0.162-0.079-0.232-0.024s-0.162,0.035-0.205-0.043s-0.142-0.111-0.222-0.072c-0.08,0.039-0.166,0-0.191-0.085\r\n\ts-0.116-0.138-0.203-0.117s-0.163-0.034-0.169-0.123S8.589,16.489,8.5,16.491c-0.089,0.003-0.152-0.067-0.14-0.155\r\n\ts-0.05-0.173-0.137-0.189s-0.135-0.097-0.104-0.181s-0.013-0.18-0.095-0.214s-0.111-0.123-0.065-0.199\r\n\tc0.047-0.076,0.025-0.179-0.049-0.229c-0.074-0.05-0.083-0.144-0.022-0.208c0.062-0.064,0.062-0.169,0-0.234\r\n\ts-0.052-0.158,0.022-0.208s0.095-0.153,0.049-0.229c-0.047-0.076-0.018-0.165,0.065-0.199s0.125-0.13,0.095-0.214\r\n\ts0.017-0.165,0.104-0.181s0.149-0.101,0.137-0.189s0.051-0.158,0.14-0.155c0.089,0.003,0.167-0.068,0.174-0.156\r\n\ts0.083-0.144,0.169-0.123s0.178-0.031,0.203-0.117s0.111-0.124,0.191-0.085c0.08,0.039,0.18,0.006,0.222-0.072\r\n\ts0.134-0.098,0.205-0.043s0.175,0.044,0.232-0.024s0.151-0.068,0.209,0s0.162,0.079,0.232,0.024s0.162-0.035,0.205,0.043\r\n\ts0.142,0.111,0.222,0.072c0.08-0.039,0.166,0,0.191,0.085s0.116,0.138,0.203,0.117s0.163,0.034,0.169,0.123s0.085,0.159,0.174,0.156\r\n\tc0.089-0.003,0.152,0.067,0.14,0.155s0.05,0.173,0.137,0.189s0.135,0.097,0.104,0.181s0.013,0.18,0.095,0.214\r\n\ts0.111,0.123,0.065,0.199c-0.047,0.076-0.025,0.179,0.049,0.229s0.083,0.144,0.022,0.208S12.05,15.053,12.112,15.117z"
    }
  }]
};
exports.medal = medal;
var megaphone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.223,7.03c-1.584-3.686-4.132-6.49-5.421-5.967c-2.189,0.891,1.304,5.164-9.447,9.533\r\n\tc-0.929,0.379-1.164,1.888-0.775,2.792c0.388,0.902,1.658,1.801,2.587,1.424c0.161-0.066,0.751-0.256,0.751-0.256\r\n\tc0.663,0.891,1.357,0.363,1.604,0.928c0.296,0.68,0.939,2.158,1.158,2.66c0.219,0.502,0.715,0.967,1.075,0.83\r\n\tc0.359-0.137,1.582-0.602,2.05-0.779c0.468-0.178,0.579-0.596,0.436-0.924c-0.154-0.355-0.786-0.459-0.967-0.873\r\n\tc-0.18-0.412-0.769-1.738-0.938-2.156c-0.23-0.568,0.259-1.031,0.97-1.104c4.894-0.512,5.809,2.512,7.475,1.834\r\n\tC19.068,14.447,18.806,10.713,17.223,7.03z M16.672,13.006c-0.287,0.115-2.213-1.402-3.443-4.267\r\n\tc-1.231-2.863-1.076-5.48-0.79-5.597c0.286-0.115,2.165,1.717,3.395,4.58C17.065,10.585,16.958,12.889,16.672,13.006z"
    }
  }]
};
exports.megaphone = megaphone;
var menu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.4,9H3.6C3.048,9,3,9.447,3,10c0,0.553,0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1C17,9.447,16.952,9,16.4,9z M16.4,13\r\n\tH3.6C3.048,13,3,13.447,3,14c0,0.553,0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1C17,13.447,16.952,13,16.4,13z M3.6,7H16.4\r\n\tC16.952,7,17,6.553,17,6c0-0.553-0.048-1-0.6-1H3.6C3.048,5,3,5.447,3,6C3,6.553,3.048,7,3.6,7z"
    }
  }]
};
exports.menu = menu;
var merge = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.8896484,17.7070312L16.8916016,20C13.7548828,18.6341553,11.3964844,16.8476562,10,14.7250977\r\n\tC8.6035156,16.8476562,6.2451172,18.6341553,3.1083984,20l-0.9980469-2.2929688\r\n\tC5.1396484,16.3886719,8.5498047,14.1015625,8.5498047,10V7H5.5L10,0l4.5,7h-3.0498047v3\r\n\tC11.4501953,14.1015625,14.8603516,16.3886719,17.8896484,17.7070312z"
    }
  }]
};
exports.merge = merge;
var message = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,6v7c0,1.1-0.9,2-2,2h-4v3l-4-3H4c-1.101,0-2-0.9-2-2V6c0-1.1,0.899-2,2-2h12C17.1,4,18,4.9,18,6z"
    }
  }]
};
exports.message = message;
var mic = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.399,7.643V10.4c0,2.236-1.643,4.629-5.399,4.959V18h2.6c0.22,0,0.4,0.18,0.4,0.4V19.6c0,0.221-0.181,0.4-0.4,0.4h-7.2\r\n\tC6.18,20,6,19.82,6,19.6V18.4C6,18.18,6.18,18,6.399,18H9v-2.641c-3.758-0.33-5.4-2.723-5.4-4.959V7.643c0-0.221,0.18-0.4,0.4-0.4\r\n\th0.6c0.22,0,0.4,0.18,0.4,0.4V10.4c0,1.336,1.053,3.6,5,3.6c3.946,0,5-2.264,5-3.6V7.643c0-0.221,0.18-0.4,0.399-0.4H16\r\n\tC16.22,7.242,16.399,7.422,16.399,7.643z M10,12c2.346,0,3-0.965,3-1.6V7.242H7V10.4C7,11.035,7.652,12,10,12z M13,1.6\r\n\tC13,0.963,12.346,0,10,0C7.652,0,7,0.963,7,1.6v4.242h6V1.6z"
    }
  }]
};
exports.mic = mic;
var minus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,10c0,0.553-0.048,1-0.601,1H4.601C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1h10.799C15.952,9,16,9.447,16,10z"
    }
  }]
};
exports.minus = minus;
var mobile = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.004,0H5.996C4.894,0,4,0.894,4,1.996v16.007C4,19.106,4.894,20,5.996,20h8.007C15.106,20,16,19.106,16,18.004V1.996\r\n\tC16,0.894,15.106,0,14.004,0z M10,19c-0.69,0-1.25-0.447-1.25-1s0.56-1,1.25-1s1.25,0.447,1.25,1S10.69,19,10,19z M14,16H6V2h8V16z"
    }
  }]
};
exports.mobile = mobile;
var moon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.719,1.8c0.686,0.385,1.332,0.867,1.916,1.449c3.42,3.422,3.42,8.966,0,12.386c-3.42,3.42-8.965,3.42-12.386,0\r\n\tc-0.583-0.584-1.065-1.231-1.449-1.916c3.335,1.867,7.633,1.387,10.469-1.449C15.106,9.433,15.587,5.136,13.719,1.8z"
    }
  }]
};
exports.moon = moon;
var pointer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.8601685,11.9953299l2.5251465,6.0802317L11.1703491,19l-2.5252075-6.050354L5,16.6248779V1.1005249\r\n\tl10.9461327,10.8882742L10.8601685,11.9953299z"
    }
  }]
};
exports.pointer = pointer;
var mouse = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.402,14.402l-2.627-7.535c-0.722-2.073-2.966-3.22-5.092-2.653L5.707,0.379C5.528,0.033,5.109-0.1,4.769,0.083\r\n\tC4.43,0.266,4.3,0.697,4.48,1.044l1.929,3.742C4.872,5.806,4.073,7.74,4.58,9.56l2.139,7.696c0.602,2.162,3.08,3.264,5.571,2.502\r\n\tC14.749,18.895,16.14,16.521,15.402,14.402z M8.899,8.923c-0.73,0.24-1.511-0.172-1.745-0.921C6.919,7.254,7.322,6.454,8.051,6.214\r\n\tc0.73-0.24,1.512,0.172,1.746,0.92S9.629,8.683,8.899,8.923z"
    }
  }]
};
exports.mouse = mouse;
var network = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.274,6.915c0.2,0,0.394,0.029,0.576,0.086c0.69-0.773,1.455-1.477,2.283-2.1C8.098,4.755,8.079,4.602,8.079,4.446\r\n\tc0-0.217,0.036-0.426,0.102-0.621C7.252,3.161,6.244,2.602,5.17,2.171C4.165,2.792,3.288,3.602,2.588,4.552\r\n\tc0.519,0.92,1.136,1.777,1.838,2.557C4.682,6.985,4.969,6.915,5.274,6.915z M3.316,8.872c0-0.275,0.058-0.537,0.159-0.773\r\n\tC2.847,7.407,2.278,6.663,1.78,5.87C1.155,7.112,0.8,8.515,0.8,10.001c0,1.719,0.474,3.328,1.295,4.705\r\n\tc0.294-1.654,0.851-3.219,1.62-4.652C3.465,9.726,3.316,9.315,3.316,8.872z M10.036,2.489c0.517,0,0.985,0.201,1.336,0.529\r\n\tc1.021-0.439,2.096-0.777,3.215-0.992C13.236,1.247,11.67,0.8,10,0.8c-1.139,0-2.229,0.209-3.236,0.588\r\n\tc0.799,0.395,1.561,0.855,2.277,1.375C9.333,2.589,9.672,2.489,10.036,2.489z M12.962,11.708c0.122-0.254,0.295-0.479,0.509-0.656\r\n\tc-0.578-1.777-1.493-3.404-2.672-4.803c-0.234,0.1-0.492,0.154-0.764,0.154c-0.425,0-0.816-0.137-1.137-0.365\r\n\tc-0.71,0.539-1.367,1.143-1.964,1.803C7.122,8.14,7.231,8.493,7.231,8.872c0,0.203-0.031,0.4-0.09,0.586\r\n\tC8.858,10.604,10.835,11.392,12.962,11.708z M15.501,14.351c0.026,0.371,0.041,0.744,0.041,1.121c0,0.664-0.042,1.318-0.122,1.961\r\n\tc1.56-1.139,2.748-2.758,3.347-4.639c-0.71,0.172-1.438,0.295-2.181,0.365C16.413,13.696,16.014,14.128,15.501,14.351z\r\n\t M12.504,13.024c-2.272-0.377-4.377-1.244-6.21-2.484c-0.298,0.182-0.647,0.289-1.021,0.289c-0.139,0-0.272-0.014-0.402-0.041\r\n\tc-0.877,1.662-1.438,3.517-1.599,5.484c0.876,0.94,1.944,1.697,3.145,2.205C7.909,16.184,9.993,14.288,12.504,13.024z M16.176,3.181\r\n\tc-1.475,0.143-2.883,0.514-4.193,1.068c0.006,0.066,0.01,0.131,0.01,0.197c0,0.309-0.074,0.6-0.201,0.859\r\n\tc1.311,1.539,2.327,3.33,2.969,5.291c0.797,0.016,1.477,0.502,1.77,1.195c0.886-0.09,1.748-0.26,2.578-0.504\r\n\tc0.06-0.42,0.092-0.85,0.092-1.287C19.2,7.296,18.034,4.864,16.176,3.181z M13.489,14.069c-2.344,1.098-4.304,2.789-5.723,4.856\r\n\tC8.481,19.104,9.229,19.2,10,19.2c1.387,0,2.702-0.309,3.882-0.859c0.19-0.928,0.29-1.887,0.29-2.869\r\n\tc0-0.355-0.016-0.707-0.043-1.055C13.893,14.341,13.676,14.224,13.489,14.069z"
    }
  }]
};
exports.network = network;
var newIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.69,12.344l-1.727-1.538c-0.5-0.445-0.5-1.174,0-1.619l1.727-1.539c0.5-0.445,0.367-0.859-0.296-0.924l-2.29-0.217\r\n\tc-0.662-0.062-1.02-0.633-0.791-1.266l1.215-3.383c0.228-0.635-0.051-0.865-0.619-0.514l-2.701,1.67\r\n\tc-0.568,0.354-1.303,0.16-1.631-0.426l-0.978-1.746c-0.329-0.588-0.872-0.59-1.207-0.008l-0.909,1.58\r\n\tC8.146,2.999,7.375,3.247,6.77,2.97l-1.6-0.734C4.562,1.956,4.097,2.278,4.133,2.952l0.086,1.615\r\n\tc0.037,0.674-0.461,1.367-1.104,1.541L1.57,6.522C0.928,6.696,0.81,7.202,1.31,7.647l1.727,1.539c0.5,0.445,0.5,1.174,0,1.619\r\n\tL1.31,12.344c-0.5,0.445-0.368,0.877,0.293,0.957l2.095,0.254c0.661,0.08,1.029,0.67,0.818,1.311l-1.074,3.258\r\n\tc-0.211,0.641,0.09,0.889,0.668,0.555l2.463-1.426c0.578-0.334,1.356-0.15,1.729,0.408l1.022,1.539\r\n\tc0.372,0.559,0.931,0.529,1.24-0.068l0.899-1.733c0.31-0.598,1.052-0.842,1.648-0.543l1.734,0.867\r\n\tc0.598,0.297,1.057-0.01,1.021-0.682l-0.087-1.617c-0.035-0.674,0.461-1.365,1.106-1.539l1.543-0.416\r\n\tC19.072,13.295,19.19,12.789,18.69,12.344z M11,14H9v-2h2V14z M11,11H9V6h2V11z"
    }
  }]
};
exports.newIcon = newIcon;
var news = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14,5h-4v2h4V5z M14,8h-4v1h4V8z M9,5H6v4h3V5z M9,11h5v-1H9V11z M12,13h2v-1h-2\r\n\tV13z M14,14H6v1h8V14z M11,12H6v1h5V12z M8,10H6v1h2V10z M17,1H3C2.447,1,2,1.447,2,2v16c0,0.552,0.447,1,1,1h14\r\n\tc0.553,0,1-0.448,1-1V2C18,1.448,17.553,1,17,1z M16,17H4V3h12V17z"
    }
  }]
};
exports.news = news;
var newsletter = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C1.4472656,3,1,3.4472656,1,4v12c0,0.5517578,0.4472656,1,1,1h16c0.5527344,0,1-0.4482422,1-1V4\r\n\tC19,3.4481812,18.5527344,3,18,3z M4,10h6v1H4V10z M12,14H4v-1h8V14z M17,8h-3V5h3V8z"
    }
  }]
};
exports.newsletter = newsletter;
var notification = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,8.38V17H3V5h8.62c-0.073-0.322-0.12-0.655-0.12-1s0.047-0.678,0.12-1H3C1.898,3,1,3.9,1,5v12c0,1.1,0.9,2,2,2h12\r\n\tc1.1,0,2-0.9,2-2V8.38c-0.322,0.073-0.655,0.12-1,0.12S15.322,8.453,15,8.38z M16,1c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3\r\n\tS17.657,1,16,1z"
    }
  }]
};
exports.notification = notification;
var off = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.8,17.4c0.2,0.2,0.2,0.5,0,0.7l-0.7,0.7c-0.2,0.2-0.5,0.2-0.7,0L1.2,2.6C1,2.4,1,2.1,1.2,1.9l0.7-0.7\r\n\tC2.1,1,2.4,1,2.6,1.2L18.8,17.4z M16,7c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3s-3,1.3-3,3C13,5.7,14.3,7,16,7z M15,8.4v3.8l2,2V8.4\r\n\tc-0.3,0.1-0.7,0.1-1,0.1S15.3,8.5,15,8.4z M11.6,5c-0.1-0.3-0.1-0.7-0.1-1c0-0.3,0-0.7,0.1-1H5.8l2,2H11.6z M5,15V7.8l-2-2V15\r\n\tc0,1.1,0.9,2,2,2h9.2l-2-2H5z"
    }
  }]
};
exports.off = off;
var phone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.256,12.253c-0.096-0.667-0.611-1.187-1.274-1.342c-2.577-0.604-3.223-2.088-3.332-3.734C12.193,7.092,11.38,7,10,7\r\n\tS7.807,7.092,7.35,7.177c-0.109,1.646-0.755,3.13-3.332,3.734c-0.663,0.156-1.178,0.675-1.274,1.342l-0.497,3.442\r\n\tC2.072,16.907,2.962,18,4.2,18h11.6c1.237,0,2.128-1.093,1.953-2.305L17.256,12.253z M10,15.492c-1.395,0-2.526-1.12-2.526-2.5\r\n\ts1.131-2.5,2.526-2.5s2.526,1.12,2.526,2.5S11.394,15.492,10,15.492z M19.95,6C19.926,4.5,16.108,2.001,10,2\r\n\tC3.891,2.001,0.073,4.5,0.05,6s0.021,3.452,2.535,3.127c2.941-0.381,2.76-1.408,2.76-2.876C5.345,5.227,7.737,4.98,10,4.98\r\n\ts4.654,0.247,4.655,1.271c0,1.468-0.181,2.495,2.76,2.876C19.928,9.452,19.973,7.5,19.95,6z"
    }
  }]
};
exports.phone = phone;
var palette = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.74,2.608C12.212,1.422,8.674,1.647,5.02,3.882c-2.853,1.743-4.718,6.076-4.103,9.182\r\n\tc0.728,3.671,4.351,5.995,9.243,4.651c5.275-1.449,6.549-4.546,6.379-5.334c-0.17-0.788-2.665-1.652-1.718-3.498\r\n\tc1.188-2.313,3.129-1.149,3.982-1.622C19.658,6.789,19.342,3.819,15.74,2.608z M12.094,13.314c-0.798,0.218-1.623-0.256-1.843-1.059\r\n\tc-0.221-0.805,0.248-1.631,1.046-1.849c0.798-0.218,1.622,0.254,1.843,1.059C13.36,12.268,12.892,13.096,12.094,13.314z"
    }
  }]
};
exports.palette = palette;
var plane = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.64,2.634C18.296,2.755,1.319,8.738,0.984,8.856c-0.284,0.1-0.347,0.345-0.01,0.479c0.401,0.161,3.796,1.521,3.796,1.521\r\n\tl0,0l2.25,0.901c0,0,10.838-7.958,10.984-8.066c0.148-0.108,0.318,0.095,0.211,0.211c-0.107,0.117-7.871,8.513-7.871,8.513v0.002\r\n\tL9.892,12.92l0.599,0.322l0,0c0,0,4.65,2.504,4.982,2.682c0.291,0.156,0.668,0.027,0.752-0.334\r\n\tc0.099-0.426,2.845-12.261,2.906-12.525C19.21,2.722,18.983,2.513,18.64,2.634z M7,17.162c0,0.246,0.139,0.315,0.331,0.141\r\n\tc0.251-0.229,2.85-2.561,2.85-2.561L7,13.098V17.162z"
    }
  }]
};
exports.plane = plane;
var pencil = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.69,2.661c-1.894-1.379-3.242-1.349-3.754-1.266c-0.144,0.023-0.265,0.106-0.35,0.223l-4.62,6.374l-2.263,3.123\r\n\tc-0.277,0.382-0.437,0.836-0.462,1.307l-0.296,5.624c-0.021,0.405,0.382,0.698,0.76,0.553l5.256-2.01\r\n\tc0.443-0.17,0.828-0.465,1.106-0.849l1.844-2.545l5.036-6.949c0.089-0.123,0.125-0.273,0.1-0.423\r\n\tC16.963,5.297,16.56,4.021,14.69,2.661z M8.977,15.465l-2.043,0.789c-0.08,0.031-0.169,0.006-0.221-0.062\r\n\tc-0.263-0.335-0.576-0.667-1.075-1.03c-0.499-0.362-0.911-0.558-1.31-0.706c-0.08-0.03-0.131-0.106-0.126-0.192l0.122-2.186\r\n\tl0.549-0.755c0,0,1.229-0.169,2.833,0.998c1.602,1.166,1.821,2.388,1.821,2.388L8.977,15.465z"
    }
  }]
};
exports.pencil = pencil;
var chart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,0.958v9.039C11,10.551,10.551,11,9.997,11H0.958c0.498,4.555,4.355,8.1,9.042,8.1c5.026,0,9.1-4.074,9.1-9.1\r\n\tC19.1,5.312,15.555,1.456,11,0.958z M9,0.958C4.774,1.42,1.42,4.774,0.958,9H9V0.958z"
    }
  }]
};
exports.chart = chart;
var plus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601\r\n\tC4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399\r\n\tC15.952,9,16,9.447,16,10z"
    }
  }]
};
exports.plus = plus;
var popup = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,2H7.979C6.88,2,6,2.88,6,3.98V12c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V4C18,2.9,17.1,2,16,2z M16,12H8V4h8V12z M4,10H2v6\r\n\tc0,1.1,0.9,2,2,2h6v-2H4V10z"
    }
  }]
};
exports.popup = popup;
var plug = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0,14v1.498C0,15.775,0.225,16,0.502,16h0.997C1.775,16,2,15.775,2,15.498V14c0-0.959,0.801-2.273,2-2.779V9.116\r\n\tC1.684,9.652,0,11.97,0,14z M12.065,4.701L9.535,6.599C9.188,6.859,8.766,7,8.332,7H6.005C5.45,7,5,7.45,5,8.005v3.991\r\n\tC5,12.55,5.45,13,6.005,13h2.327c0.434,0,0.856,0.141,1.203,0.401l2.531,1.898C12.672,15.754,13.41,16,14.168,16H16V4h-1.832\r\n\tC13.41,4,12.672,4.246,12.065,4.701z M17,6v2h3V6H17z M17,14h3v-2h-3V14z"
    }
  }]
};
exports.plug = plug;
var tag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.tag = tag;
var print = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.501,6h17c0.57,0,0.477-0.608,0.193-0.707C18.409,5.194,15.251,4,14.7,4H14V1H6v3H5.301c-0.55,0-3.709,1.194-3.993,1.293\r\n\tC1.024,5.392,0.931,6,1.501,6z M19,7H1C0.45,7,0,7.45,0,8v5c0,0.551,0.45,1,1,1h2.283l-0.882,5h15.199l-0.883-5H19\r\n\tc0.551,0,1-0.449,1-1V8C20,7.45,19.551,7,19,7z M4.603,17l1.198-7.003H14.2L15.399,17H4.603z"
    }
  }]
};
exports.print = print;
var empty = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z"
    }
  }]
};
exports.empty = empty;
var full = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z\r\n\t M12,8H8v4h4V8z M17,8h-4v4h4V8z"
    }
  }]
};
exports.full = full;
var one = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z"
    }
  }]
};
exports.one = one;
var two = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z\r\n\t M12,8H8v4h4V8z"
    }
  }]
};
exports.two = two;
var publish = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.967,8.193L5,13h3v6h4v-6h3L9.967,8.193z M18,1H2C0.9,1,0,1.9,0,3v12c0,1.1,0.9,2,2,2h4v-2H2V6h16v9h-4v2h4\r\n\tc1.1,0,2-0.9,2-2V3C20,1.9,19.1,1,18,1z M2.5,4.25c-0.414,0-0.75-0.336-0.75-0.75c0-0.414,0.336-0.75,0.75-0.75\r\n\tc0.414,0,0.75,0.336,0.75,0.75C3.25,3.914,2.914,4.25,2.5,4.25z M4.5,4.25c-0.414,0-0.75-0.336-0.75-0.75\r\n\tc0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75C5.25,3.914,4.914,4.25,4.5,4.25z M18,4H6V3h12.019L18,4z"
    }
  }]
};
exports.publish = publish;
var quote = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.315,3.401c-1.61,0-2.916,1.343-2.916,3c0,1.656,1.306,3,2.916,3c2.915,0,0.972,5.799-2.916,5.799v1.4\r\n\tC9.338,16.601,12.057,3.401,5.315,3.401z M13.715,3.401c-1.609,0-2.915,1.343-2.915,3c0,1.656,1.306,3,2.915,3\r\n\tc2.916,0,0.973,5.799-2.915,5.799v1.4C17.738,16.601,20.457,3.401,13.715,3.401z"
    }
  }]
};
exports.quote = quote;
var radio = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,8H5.021l8.974-5.265L13,1L1.736,7.571C1.28,7.837,1,8.324,1,8.852V17c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2v-7\r\n\tC19,8.895,18.105,8,17,8z M15.5,17c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5\r\n\tC17,16.328,16.328,17,15.5,17z M17,12H3v-2h14V12z"
    }
  }]
};
exports.radio = radio;
var all = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.225,5.767V3.086L0,9.542l7.225,6.691v-2.777L3,9.542L7.225,5.767z M12.225,6.953V3.086L5,9.542l7.225,6.691v-4.357\r\n\tc3.292,0,5.291,0.422,7.775,4.81C20,16.685,19.632,6.953,12.225,6.953z"
    }
  }]
};
exports.all = all;
var reply = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,16.685c0,0-2.225-9.732-11-9.732V2.969L1,9.542l7,6.69v-4.357C12.763,11.874,16.516,12.296,19,16.685z"
    }
  }]
};
exports.reply = reply;
var oneHundredPercent = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.1,14.1L1,17l2,2l2.9-3.1L8,18v-6H2L4.1,14.1z M19,3l-2-2l-2.9,3.1L12,2v6h6l-2.1-2.1L19,3z"
    }
  }]
};
exports.oneHundredPercent = oneHundredPercent;
var fullScreen = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.987,10.987l-2.931,3.031L2,11.589V18h6.387l-2.43-2.081l3.03-2.932L6.987,10.987z M11.613,2l2.43,2.081l-3.03,2.932l2,2\r\n\tl2.931-3.031L18,8.411V2H11.613z"
    }
  }]
};
exports.fullScreen = fullScreen;
var retweet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,13V8h2L3.5,4L0,8h2v6c0,1.104,0.895,2,2,2h9.482l-2.638-3H5z M9.156,7L6.518,4H16c1.104,0,2,0.897,2,2v6h2l-3.5,4L13,12\r\n\th2V7H9.156z"
    }
  }]
};
exports.retweet = retweet;
var rocket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.933,13.069c0,0,7.059-5.094,6.276-10.924c-0.017-0.127-0.059-0.213-0.112-0.268c-0.054-0.055-0.137-0.098-0.263-0.115\r\n\tC12.137,0.961,7.16,8.184,7.16,8.184C2.842,7.667,3.156,8.528,1.186,13.26c-0.377,0.902,0.234,1.213,0.904,0.959\r\n\tc0.67-0.252,2.148-0.811,2.148-0.811l2.59,2.648c0,0-0.546,1.514-0.793,2.199c-0.248,0.686,0.055,1.311,0.938,0.926\r\n\tC11.597,17.165,12.439,17.487,11.933,13.069z M12.942,7.153c-0.598-0.613-0.598-1.604,0-2.217c0.598-0.611,1.567-0.611,2.166,0\r\n\tc0.598,0.611,0.598,1.603,0,2.217C14.509,7.764,13.539,7.764,12.942,7.153z"
    }
  }]
};
exports.rocket = rocket;
var rss = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.4,2.4v2.367c7.086,0,12.83,5.746,12.83,12.832h2.369C17.599,9.205,10.794,2.4,2.4,2.4z M2.4,7.137v2.369\r\n\tc4.469,0,8.093,3.623,8.093,8.094h2.368C12.861,11.822,8.177,7.137,2.4,7.137z M4.669,13.059c-1.254,0-2.27,1.018-2.27,2.271\r\n\ts1.016,2.27,2.27,2.27s2.269-1.016,2.269-2.27S5.923,13.059,4.669,13.059z"
    }
  }]
};
exports.rss = rss;
var ruler = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.249,0.438L0.438,14.251c-0.584,0.584-0.584,1.538,0.002,2.124l3.185,3.187c0.584,0.584,1.541,0.586,2.124,0.002\r\n\tL19.562,5.751c0.584-0.585,0.584-1.541,0-2.125l-3.186-3.188C15.789-0.148,14.834-0.145,14.249,0.438z M3.929,15.312L3.17,16.071\r\n\tl-1.896-1.897l0.759-0.759L3.929,15.312z M6.965,15.312l-0.759,0.759l-3.415-3.415l0.759-0.76L6.965,15.312z M6.965,12.276\r\n\tl-0.759,0.759l-1.898-1.896l0.76-0.76L6.965,12.276z M8.483,10.758l-0.759,0.759L5.828,9.621l0.759-0.76L8.483,10.758z\r\n\t M11.518,10.758l-0.759,0.759L7.345,8.103l0.759-0.759L11.518,10.758z M11.518,7.723l-0.759,0.759L8.863,6.586l0.759-0.759\r\n\tL11.518,7.723z M13.036,6.206l-0.759,0.759L10.38,5.068l0.759-0.759L13.036,6.206z M16.072,6.206l-0.76,0.759L11.898,3.55\r\n\tl0.759-0.76L16.072,6.206z M16.071,3.171l-0.759,0.759l-1.896-1.898l0.759-0.758L16.071,3.171z"
    }
  }]
};
exports.ruler = ruler;
var save = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.173,2H4C2.899,2,2,2.9,2,4v12c0,1.1,0.899,2,2,2h12c1.101,0,2-0.9,2-2V5.127L15.173,2z M14,8c0,0.549-0.45,1-1,1H7\r\n\tC6.45,9,6,8.549,6,8V3h8V8z M13,4h-2v4h2V4z"
    }
  }]
};
exports.save = save;
var scissors = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.38,5.59c0-2.038-1.652-3.69-3.69-3.69S1,3.552,1,5.59c0,2.038,1.652,3.69,3.69,3.69c0.96,0,1.826-0.376,2.483-0.976\r\n\tL9,9.991L9.012,10l-0.004,0.003l-1.836,1.693C6.516,11.096,5.65,10.72,4.69,10.72C2.652,10.72,1,12.372,1,14.41\r\n\tc0,2.038,1.652,3.69,3.69,3.69s3.69-1.652,3.69-3.69c0-0.297-0.044-0.582-0.111-0.858l2.844-1.991l4.127,3.065\r\n\tc2.212,1.549,3.76-0.663,3.76-0.663L8.269,6.448C8.335,6.172,8.38,5.887,8.38,5.59z M4.69,7.39c-0.994,0-1.8-0.806-1.8-1.8\r\n\ts0.806-1.8,1.8-1.8s1.8,0.806,1.8,1.8S5.684,7.39,4.69,7.39z M4.69,16.21c-0.994,0-1.8-0.806-1.8-1.8s0.806-1.8,1.8-1.8\r\n\ts1.8,0.806,1.8,1.8S5.684,16.21,4.69,16.21z M19,6.038c0,0-1.548-2.212-3.76-0.663L12.035,7.61l2.354,1.648L19,6.038z"
    }
  }]
};
exports.scissors = scissors;
var arrows = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1L5,8h10L10,1z M10,19l5-7H5L10,19z"
    }
  }]
};
exports.arrows = arrows;
var alternative = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9,13h2V4h2l-3-4L7,4h2V13z M17,7h-3v2h2v9H4V9h2V7H3C2.447,7,2,7.447,2,8v11c0,0.552,0.447,1,1,1h14c0.553,0,1-0.448,1-1V8\r\n\tC18,7.448,17.553,7,17,7z"
    }
  }]
};
exports.alternative = alternative;
var share = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,13.442c-0.633,0-1.204,0.246-1.637,0.642l-5.938-3.463C7.471,10.433,7.5,10.237,7.5,10.037S7.471,9.642,7.425,9.454\r\n\tL13.3,6.025C13.746,6.442,14.342,6.7,15,6.7c1.379,0,2.5-1.121,2.5-2.5S16.379,1.7,15,1.7s-2.5,1.121-2.5,2.5\r\n\tc0,0.2,0.029,0.396,0.075,0.583L6.7,8.212C6.254,7.796,5.658,7.537,5,7.537c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5\r\n\tc0.658,0,1.254-0.258,1.7-0.675l5.938,3.463c-0.042,0.175-0.067,0.358-0.067,0.546c0,1.342,1.087,2.429,2.429,2.429\r\n\ts2.429-1.088,2.429-2.429S16.342,13.442,15,13.442z"
    }
  }]
};
exports.share = share;
var shareable = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.8,10c0,1.768,1.433,3.201,3.2,3.201c1.768,0,3.199-1.433,3.199-3.201c0-1.767-1.431-3.2-3.199-3.2S6.8,8.233,6.8,10z\r\n\t M4.529,8.8C5.078,6.284,7.318,4.4,10,4.4c1.546,0,2.945,0.627,3.959,1.64c0.469,0.469,1.229,0.469,1.697,0\r\n\tc0.469-0.469,0.469-1.229,0-1.697C14.209,2.896,12.209,2,10,2C6.418,2,3.386,4.354,2.367,7.601H0V10h3.199\r\n\tC4.198,10,4.444,9.187,4.529,8.8z M16.8,10c-0.999,0-1.245,0.814-1.329,1.199c-0.549,2.516-2.789,4.4-5.471,4.4\r\n\tc-1.547,0-2.946-0.627-3.959-1.641c-0.469-0.469-1.229-0.469-1.698,0c-0.468,0.469-0.468,1.229,0,1.697C5.791,17.104,7.791,18,10,18\r\n\tc3.582,0,6.613-2.356,7.633-5.6H20V10H16.8z"
    }
  }]
};
exports.shareable = shareable;
var shield = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.604,3.332C12.99,4,12.075,2.833,10,1C7.925,2.833,7.01,4,2.396,3.332C-0.063,15.58,10,19,10,19\r\n\tS20.063,15.58,17.604,3.332z M12.473,13.309L10,12.009l-2.472,1.3L8,10.556L6,8.606l2.764-0.401L10,5.7l1.236,2.505L14,8.606\r\n\tl-2,1.949L12.473,13.309z"
    }
  }]
};
exports.shield = shield;
var shop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.123,7.25L6.914,2H2.8L1.081,6.5C1.028,6.66,1,6.826,1,7c0,1.104,1.15,2,2.571,2C4.881,9,5.964,8.236,6.123,7.25z M10,9\r\n\tc1.42,0,2.571-0.896,2.571-2c0-0.041-0.003-0.082-0.005-0.121L12.057,2H7.943l-0.51,4.875C7.431,6.916,7.429,6.957,7.429,7\r\n\tC7.429,8.104,8.58,9,10,9z M15,10.046V14H5v-3.948C4.562,10.21,4.08,10.3,3.571,10.3c-0.195,0-0.384-0.023-0.571-0.049V16.6\r\n\tc0,0.77,0.629,1.4,1.398,1.4H15.6c0.77,0,1.4-0.631,1.4-1.4v-6.348c-0.188,0.025-0.376,0.049-0.571,0.049\r\n\tC15.923,10.3,15.439,10.208,15,10.046z M18.92,6.5L17.199,2h-4.113l0.79,5.242C14.03,8.232,15.113,9,16.429,9\r\n\tC17.849,9,19,8.104,19,7C19,6.826,18.972,6.66,18.92,6.5z"
    }
  }]
};
exports.shop = shop;
var bag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.121,3.271c-0.295-0.256-1.906-1.731-2.207-1.991C15.615,1.021,15.158,1,14.812,1H5.188C4.843,1,4.386,1.021,4.086,1.28\r\n\tC3.785,1.54,2.174,3.016,1.879,3.271C1.582,3.527,1.336,3.914,1.415,4.463c0.079,0.551,1.89,13.661,1.937,13.973\r\n\tC3.398,18.747,3.67,18.993,4,19h12c0.33-0.007,0.602-0.253,0.648-0.565c0.047-0.311,1.858-13.422,1.938-13.973\r\n\tC18.664,3.914,18.418,3.527,18.121,3.271z M10,11.973c-3.248,0-3.943-4.596-4.087-5.543H7.75c0.276,1.381,0.904,3.744,2.25,3.744\r\n\ts1.975-2.363,2.25-3.744h1.838C13.943,7.377,13.248,11.973,10,11.973z M3.17,4.006L5,2h10l1.83,2.006H3.17z"
    }
  }]
};
exports.bag = bag;
var basket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.399,7h-5.007l-1.812,1.812c-0.453,0.453-1.056,0.702-1.696,0.702c-0.642,0-1.244-0.25-1.698-0.703\r\n\tC7.734,8.359,7.484,7.757,7.483,7.116c0-0.039,0.01-0.077,0.011-0.116H1.6C1.268,7,1,7.268,1,7.6V10h18V7.6\r\n\tC19,7.268,18.73,7,18.399,7z M10.768,7.999l5.055-5.055c0.235-0.234,0.237-0.613,0.002-0.849l-0.92-0.92\r\n\tc-0.234-0.234-0.614-0.233-0.85,0L9,6.231c-0.488,0.488-0.488,1.28,0,1.768C9.488,8.486,10.279,8.487,10.768,7.999z M3.823,17.271\r\n\tC3.92,17.672,4.338,18,4.75,18h10.5c0.412,0,0.83-0.328,0.927-0.729L17.7,11H2.3L3.823,17.271z"
    }
  }]
};
exports.basket = basket;
var cart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,17c0,1.104,0.894,2,2,2c1.104,0,2-0.896,2-2c0-1.106-0.896-2-2-2C13.894,15,13,15.894,13,17z M3,17c0,1.104,0.895,2,2,2\r\n\tc1.103,0,2-0.896,2-2c0-1.106-0.897-2-2-2C3.895,15,3,15.894,3,17z M6.547,12.172L17.615,9.01C17.826,8.949,18,8.721,18,8.5V3H4V1.4\r\n\tC4,1.18,3.819,1,3.601,1H0.399C0.18,1,0,1.18,0,1.4L0,3h2l1.91,8.957L4,12.9v1.649c0,0.219,0.18,0.4,0.4,0.4H17.6\r\n\tc0.22,0,0.4-0.182,0.4-0.4V13H6.752C5.602,13,5.578,12.449,6.547,12.172z"
    }
  }]
};
exports.cart = cart;
var shuffle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.093,6.694h0.92v2.862L20,5.532l-3.988-4.025v2.387h-0.92c-3.694,0-5.776,2.738-7.614,5.152\r\n\tc-1.652,2.172-3.08,4.049-5.386,4.049H0v2.799h2.093c3.694,0,5.776-2.736,7.614-5.152C11.359,8.569,12.787,6.694,15.093,6.694z\r\n\t M5.41,8.458c0.158-0.203,0.316-0.412,0.477-0.623C6.277,7.321,6.691,6.78,7.139,6.239C5.817,5.005,4.224,4.095,2.093,4.095H0v2.799\r\n\th2.093C3.42,6.894,4.455,7.517,5.41,8.458z M16.012,13.294h-0.92c-1.407,0-2.487-0.701-3.491-1.738\r\n\tc-0.1,0.131-0.201,0.264-0.303,0.397c-0.441,0.58-0.915,1.201-1.439,1.818c1.356,1.324,3,2.324,5.232,2.324h0.92v2.398L20,14.468\r\n\tl-3.988-4.025V13.294z"
    }
  }]
};
exports.shuffle = shuffle;
var signal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,14c-1.094,0-1.981,0.894-1.981,2c0,1.104,0.887,2,1.981,2c1.094,0,1.98-0.896,1.98-2C11.98,14.895,11.094,14,10,14z\r\n\t M5.8,11.758l1.4,1.414c1.546-1.562,4.054-1.562,5.601,0l1.399-1.414C11.881,9.415,8.119,9.415,5.8,11.758z M3,8.928l1.4,1.414\r\n\tc3.092-3.123,8.106-3.123,11.199,0L17,8.928C13.135,5.024,6.865,5.024,3,8.928z M0.199,6.1l1.4,1.414\r\n\tc4.639-4.686,12.161-4.686,16.801,0L19.8,6.1C14.388,0.633,5.612,0.633,0.199,6.1z"
    }
  }]
};
exports.signal = signal;
var mix = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,1.6C5,1.047,4.552,1,4,1C3.447,1,3,1.047,3,1.6V10h2V1.6z M3,18.4C3,18.951,3.447,19,4,19c0.552,0,1-0.049,1-0.6V15H3\r\n\tV18.4z M6.399,11H1.599C1.046,11,1,11.448,1,12v1c0,0.553,0.046,1,0.599,1h4.801C6.95,14,7,13.553,7,13v-1\r\n\tC7,11.448,6.95,11,6.399,11z M18.399,12h-4.801C13.046,12,13,12.448,13,13v1c0,0.553,0.046,1,0.599,1h4.801\r\n\tC18.95,15,19,14.553,19,14v-1C19,12.448,18.95,12,18.399,12z M13,7c0-0.552-0.05-1-0.601-1H7.599C7.046,6,7,6.448,7,7v1\r\n\tc0,0.553,0.046,1,0.599,1h4.801C12.95,9,13,8.553,13,8V7z M11,1.6C11,1.047,10.552,1,10,1C9.447,1,9,1.047,9,1.6V5h2V1.6z M9,18.4\r\n\tc0,0.551,0.447,0.6,1,0.6c0.552,0,1-0.049,1-0.6V10H9V18.4z M17,1.6C17,1.047,16.552,1,16,1c-0.553,0-1,0.047-1,0.6V11h2V1.6z\r\n\t M15,18.4c0,0.551,0.447,0.6,1,0.6c0.552,0,1-0.049,1-0.6V16h-2V18.4z"
    }
  }]
};
exports.mix = mix;
var mute = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527\r\n\tc4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941\r\n\tc-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384\r\n\tC5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108\r\n\tc-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0L18.521,2.892C18.912,2.501,18.912,1.868,18.521,1.478z"
    }
  }]
};
exports.mute = mute;
var sound = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789\r\n\tc1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928\r\n\tC6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156z\r\n\t M15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0l-1.904,1.906\r\n\tc-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388\r\n\tl1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388l-1.087,1.926\r\n\tC10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061\r\n\tc-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"
    }
  }]
};
exports.sound = sound;
var club = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,13.5l4,2.5l4-2.5V5H6V13.5z M4.5,10c0-1.105-0.896-2-2-2s-2,0.895-2,2c0,1.105,0.896,2,2,2S4.5,11.105,4.5,10z M17.5,8\r\n\tc-1.104,0-2,0.895-2,2c0,1.105,0.896,2,2,2s2-0.895,2-2C19.5,8.895,18.604,8,17.5,8z M4.485,6.199C5.74,4.384,7.802,3.3,10,3.3\r\n\tc2.158,0,4.198,1.056,5.456,2.823c0.449,0.629,1.323,0.776,1.952,0.329c0.63-0.448,0.777-1.323,0.329-1.953\r\n\tC15.955,1.995,13.062,0.5,10,0.5c-3.117,0-6.04,1.535-7.817,4.107c-0.439,0.636-0.28,1.508,0.355,1.948\r\n\tC3.175,6.993,4.046,6.834,4.485,6.199z M15.456,13.877C14.198,15.645,12.158,16.7,10,16.7c-2.198,0-4.26-1.084-5.515-2.899\r\n\tc-0.439-0.636-1.311-0.794-1.947-0.356c-0.636,0.44-0.795,1.312-0.355,1.948C3.96,17.965,6.883,19.5,10,19.5\r\n\tc3.062,0,5.955-1.495,7.737-3.999c0.448-0.63,0.301-1.504-0.329-1.953C16.779,13.101,15.905,13.248,15.456,13.877z"
    }
  }]
};
exports.club = club;
var spreadsheet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M15,8H9v9H8V8H5V7h3V3h1v4h6V8z"
    }
  }]
};
exports.spreadsheet = spreadsheet;
var star = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.3l2.388,6.722H18.8l-5.232,3.948l1.871,6.928L10,14.744l-5.438,4.154l1.87-6.928L1.199,8.022h6.412L10,1.3z"
    }
  }]
};
exports.star = star;
var stopwatch = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.376,6.745c-0.447,0.275,1.197,4.242,1.598,4.888c0.35,0.569,1.093,0.742,1.658,0.394c0.568-0.352,0.745-1.094,0.395-1.66\r\n\tC10.63,9.719,7.822,6.469,7.376,6.745z M7.041,2.402C7.969,2.079,8.963,1.9,10,1.9s2.031,0.179,2.959,0.502\r\n\tc0.329,0.114,0.765-0.115,0.572-0.611c-0.141-0.36-0.277-0.712-0.332-0.855c-0.131-0.339-0.6-0.619-0.804-0.665\r\n\tC11.623,0.097,10.823,0,10,0S8.377,0.097,7.604,0.271C7.4,0.317,6.932,0.597,6.801,0.936C6.746,1.079,6.609,1.431,6.469,1.791\r\n\tC6.276,2.287,6.712,2.517,7.041,2.402z M19.098,3.186c-0.192-0.23-0.396-0.455-0.613-0.672c-0.216-0.217-0.441-0.42-0.67-0.613\r\n\tc-0.153-0.129-0.603-0.234-0.888,0.051c-0.284,0.285-1.648,1.647-1.648,1.647c0.402,0.288,0.793,0.605,1.155,0.966\r\n\tc0.362,0.361,0.677,0.752,0.966,1.155c0,0,1.363-1.362,1.647-1.647C19.333,3.787,19.228,3.338,19.098,3.186z M10,2.9\r\n\tc-4.475,0-8.101,3.626-8.101,8.1c0,4.475,3.626,8.101,8.101,8.101c4.473,0,8.1-3.626,8.1-8.101C18.1,6.527,14.473,2.9,10,2.9z\r\n\t M10,17.101c-3.368,0-6.1-2.731-6.1-6.1c0-3.369,2.731-6.1,6.1-6.1c3.369,0,6.101,2.731,6.101,6.1\r\n\tC16.101,14.369,13.369,17.101,10,17.101z"
    }
  }]
};
exports.stopwatch = stopwatch;
var suitcase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,4h-1v15h1c1.1,0,2-0.9,2-2V6C20,4.9,19.1,4,18,4z M0,6l0,11c0,1.1,0.899,2,2,2h1V4H2C0.899,4,0,4.9,0,6z M13.5,1.906\r\n\tC12.819,1.59,11.611,1,9.981,1C8.348,1,7.181,1.59,6.5,1.906V4H4v15h12V4h-2.5V1.906z M12,4H8V2.664\r\n\tc0.534-0.23,1.078-0.465,1.981-0.465c0.902,0,1.486,0.234,2.019,0.465V4z"
    }
  }]
};
exports.suitcase = suitcase;
var swap = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,5H4V3L0,6.5L4,10V8h10V5z M20,13.5L16,10v2H6v3h10v2L20,13.5z"
    }
  }]
};
exports.swap = swap;
var sweden = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.sweden = sweden;
var switchIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,3H7c-3.866,0-7,3.134-7,7c0,3.866,3.134,7,7,7h6c3.866,0,7-3.134,7-7C20,6.134,16.866,3,13,3z M13,15\r\n\tc-2.761,0-5-2.239-5-5s2.239-5,5-5s5,2.239,5,5S15.761,15,13,15z"
    }
  }]
};
exports.switchIcon = switchIcon;
var mobileCombo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.00354,5H11.99646C10.8938599,5,10,5.8937988,10,6.9963989V18.00354C10,19.1061401,10.8938599,20,11.99646,20H17.00354\r\n\tC18.1061401,20,19,19.1061401,19,18.00354V6.9963989C19,5.8937988,18.1061401,5,17.00354,5z M14.5,19\r\n\tc-0.6904297,0-1.25-0.4473267-1.25-1c0-0.5527344,0.5595703-1,1.25-1c0.6895142,0,1.25,0.4472656,1.25,1\r\n\tC15.75,18.5526733,15.1895142,19,14.5,19z M17,16h-5V7h5V16z M8,16H3V2h12v1h2V2c0-1.1010742-0.8994141-2-2-2H3\r\n\tC1.9003906,0,1,0.8989258,1,2v16c0,1.0996094,0.9003906,2,2,2h5.5551758C8.2114258,19.4101562,8,18.7338867,8,18.003418V16z"
    }
  }]
};
exports.mobileCombo = mobileCombo;
var tablet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,0H4C2.9,0,2,0.899,2,2v16c0,1.1,0.9,2,2,2h12c1.101,0,2-0.9,2-2V2C18,0.899,17.101,0,16,0z M10,19\r\n\tc-0.69,0-1.25-0.447-1.25-1s0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1S10.689,19,10,19z M16,16H4V2h12V16z"
    }
  }]
};
exports.tablet = tablet;
var documentInverted = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M13,15H7v-2h6V15z M13,11H7V9h6V11z M13,7H7V5h6V7z"
    }
  }]
};
exports.documentInverted = documentInverted;
var text = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M15.5,11h-11C4.225,11,4,11.225,4,11.5v1C4,12.776,4.225,13,4.5,13h11\r\n\tc0.276,0,0.5-0.224,0.5-0.5v-1C16,11.225,15.776,11,15.5,11z M15.5,7h-11C4.225,7,4,7.225,4,7.5v1C4,8.776,4.225,9,4.5,9h11\r\n\tC15.776,9,16,8.776,16,8.5v-1C16,7.225,15.776,7,15.5,7z M10.5,15h-6C4.225,15,4,15.225,4,15.5v1C4,16.776,4.225,17,4.5,17h6\r\n\tc0.276,0,0.5-0.224,0.5-0.5v-1C11,15.225,10.776,15,10.5,15z M15.5,3h-11C4.225,3,4,3.225,4,3.5v1C4,4.776,4.225,5,4.5,5h11\r\n\tC15.776,5,16,4.776,16,4.5v-1C16,3.225,15.776,3,15.5,3z"
    }
  }]
};
exports.text = text;
var thermometer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,10.123V1c0-0.553-0.447-1-1-1H7.799C7.247,0,7,0.447,7,1v9.123c-1.444,0.969-2.4,2.608-2.4,4.477\r\n\tc0,2.982,2.418,5.4,5.4,5.4c2.982,0,5.4-2.418,5.4-5.4C15.4,12.731,14.444,11.092,13,10.123z M10,17.9c-1.823,0-3.3-1.477-3.3-3.3\r\n\tc0-1.472,0.97-2.703,2.3-3.129V4h2v7.471c1.33,0.426,2.3,1.657,2.3,3.129C13.3,16.422,11.823,17.9,10,17.9z"
    }
  }]
};
exports.thermometer = thermometer;
var ticket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.906,11.541l3.551,3.553l6.518-6.518l-3.553-3.551L4.906,11.541z M19.104,6.664l-1.511-1.512\r\n\tc-0.289,0.156-0.618,0.246-0.969,0.246c-1.118,0-2.024-0.906-2.024-2.023c0-0.352,0.089-0.682,0.246-0.969l-1.511-1.512\r\n\tc-0.394-0.393-1.038-0.393-1.432,0l-11.01,11.01c-0.393,0.392-0.393,1.037,0,1.432l1.512,1.51C2.694,14.69,3.023,14.6,3.375,14.6\r\n\tc1.117,0,2.023,0.906,2.023,2.025c0,0.35-0.089,0.68-0.246,0.969l1.512,1.51c0.394,0.394,1.037,0.394,1.432,0L19.104,8.096\r\n\tC19.498,7.701,19.498,7.057,19.104,6.664z M8.457,16.719l-5.176-5.178l8.142-8.141l5.176,5.176L8.457,16.719z"
    }
  }]
};
exports.ticket = ticket;
var slot = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6h0V10l6.792-3.396\r\n\tC17.305,7.627,17.6,8.777,17.6,10C17.6,14.197,14.197,17.599,10,17.599z"
    }
  }]
};
exports.slot = slot;
var tools = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.135,6.89c0.933-0.725,1.707-0.225,2.74,0.971c0.116,0.135,0.272-0.023,0.361-0.1c0.088-0.078,1.451-1.305,1.518-1.361\r\n\tC7.82,6.341,7.9,6.231,7.795,6.108C7.688,5.985,7.301,5.483,7.052,5.157c-1.808-2.365,4.946-3.969,3.909-3.994\r\n\tc-0.528-0.014-2.646-0.039-2.963-0.004C6.715,1.294,5.104,2.493,4.293,3.052C3.232,3.778,2.836,4.204,2.771,4.263\r\n\tc-0.3,0.262-0.048,0.867-0.592,1.344C1.604,6.11,1.245,5.729,0.912,6.021C0.747,6.167,0.285,6.513,0.153,6.628\r\n\tC0.02,6.745-0.004,6.942,0.132,7.099c0,0,1.264,1.396,1.37,1.52C1.607,8.741,1.893,8.847,2.069,8.69\r\n\tc0.177-0.156,0.632-0.553,0.708-0.623C2.855,8.001,2.727,7.206,3.135,6.89z M8.843,7.407c-0.12-0.139-0.269-0.143-0.397-0.029\r\n\tL7.012,8.63c-0.113,0.1-0.129,0.283-0.027,0.4l8.294,9.439c0.194,0.223,0.53,0.246,0.751,0.053L17,17.709\r\n\tc0.222-0.195,0.245-0.533,0.052-0.758L8.843,7.407z M19.902,3.39c-0.074-0.494-0.33-0.391-0.463-0.182\r\n\tc-0.133,0.211-0.721,1.102-0.963,1.506c-0.24,0.4-0.832,1.191-1.934,0.41c-1.148-0.811-0.749-1.377-0.549-1.758\r\n\tc0.201-0.383,0.818-1.457,0.907-1.59c0.089-0.135-0.015-0.527-0.371-0.363c-0.357,0.164-2.523,1.025-2.823,2.26\r\n\tc-0.307,1.256,0.257,2.379-0.85,3.494l-1.343,1.4l1.349,1.566l1.654-1.57c0.394-0.396,1.236-0.781,1.998-0.607\r\n\tc1.633,0.369,2.524-0.244,3.061-1.258C20.057,5.792,19.977,3.884,19.902,3.39z M2.739,17.053c-0.208,0.209-0.208,0.549,0,0.758\r\n\tl0.951,0.93c0.208,0.209,0.538,0.121,0.746-0.088l4.907-4.824L7.84,12.115L2.739,17.053z"
    }
  }]
};
exports.tools = tools;
var cone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,12.078c2.39,0,4.392-0.812,4.513-1.873c-0.356-0.996-0.744-2.084-1.125-3.152C13.124,7.814,11.663,8.354,10,8.354\r\n\tS6.876,7.814,6.612,7.053c-0.381,1.068-0.769,2.156-1.124,3.152C5.609,11.266,7.61,12.078,10,12.078z M10,5.373\r\n\tc1.124,0,2.167-0.348,2.473-0.889c-0.421-1.182-0.782-2.197-1.011-2.836C11.31,1.221,10.621,1,10,1S8.69,1.221,8.538,1.648\r\n\tc-0.228,0.639-0.59,1.654-1.011,2.836C7.833,5.025,8.877,5.373,10,5.373z M18.78,13.066l-3.755-1.514l0.433,1.207\r\n\tc-0.022,1.279-2.504,2.299-5.458,2.299c-2.953,0-5.437-1.019-5.458-2.299l0.433-1.207L1.22,13.066\r\n\tc-1.053,0.424-1.098,1.209-0.098,1.744l7.062,3.787c0.998,0.535,2.633,0.535,3.632,0l7.063-3.787\r\n\tC19.878,14.275,19.833,13.49,18.78,13.066z"
    }
  }]
};
exports.cone = cone;
var trash = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.389,7.113L4.49,18.021C4.551,18.482,6.777,19.998,10,20c3.225-0.002,5.451-1.518,5.511-1.979l1.102-10.908\r\n\tC14.929,8.055,12.412,8.5,10,8.5C7.59,8.5,5.072,8.055,3.389,7.113z M13.168,1.51l-0.859-0.951C11.977,0.086,11.617,0,10.916,0\r\n\tH9.085c-0.7,0-1.061,0.086-1.392,0.559L6.834,1.51C4.264,1.959,2.4,3.15,2.4,4.029v0.17C2.4,5.746,5.803,7,10,7\r\n\tc4.198,0,7.601-1.254,7.601-2.801v-0.17C17.601,3.15,15.738,1.959,13.168,1.51z M12.07,4.34L11,3H9L7.932,4.34h-1.7\r\n\tc0,0,1.862-2.221,2.111-2.522C8.533,1.588,8.727,1.5,8.979,1.5h2.043c0.253,0,0.447,0.088,0.637,0.318\r\n\tc0.248,0.301,2.111,2.522,2.111,2.522H12.07z"
    }
  }]
};
exports.trash = trash;
var trophy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.trophy = trophy;
var tv = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,1H2C0.899,1,0,1.9,0,3v11c0,1.1,0.882,2.178,1.961,2.393l4.372,0.875C6.333,17.268,2.57,19,5,19h10\r\n\tc2.43,0-1.334-1.732-1.334-1.732l4.373-0.875C19.117,16.178,20,15.1,20,14V3C20,1.9,19.1,1,18,1z M18,14H2V3h16V14z"
    }
  }]
};
exports.tv = tv;
var typing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,4H4C2.899,4,2,4.9,2,6v7c0,1.1,0.899,2,2,2h4l4,3v-3h4c1.1,0,2-0.9,2-2V6C18,4.9,17.1,4,16,4z M6,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C7.1,10.107,6.607,10.6,6,10.6z M10,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C11.1,10.107,10.607,10.6,10,10.6z M14,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C15.1,10.107,14.607,10.6,14,10.6z"
    }
  }]
};
exports.typing = typing;
var uninstall = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H5.546C4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927\r\n\tc-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18h14.383c0.755,0,1.399-0.546,1.523-1.291\r\n\tl0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M5.52,4.786l1.639-1.132l2.868,2.011l2.868-2.011l1.639,1.132l-2.869,2.033\r\n\tl2.928,2.06l-1.639,1.171l-2.927-2.076L7.1,10.05L5.461,8.879l2.928-2.06L5.52,4.786z M16.959,15.245\r\n\tC16.887,15.681,16.51,16,16.068,16H3.932c-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867\r\n\tc0.558,0,0.983,0.501,0.891,1.052L16.959,15.245z"
    }
  }]
};
exports.uninstall = uninstall;
var unread = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17,3c-1.104,0-2,0.895-2,2c0,1.105,0.896,2,2,2s2-0.895,2-2\r\n\tC19,3.895,18.104,3,17,3z M12.5,4h-11C1.224,4,1,4.224,1,4.5v1C1,5.776,1.224,6,1.5,6h11C12.776,6,13,5.776,13,5.5v-1\r\n\tC13,4.224,12.776,4,12.5,4z M12.5,9h-11C1.224,9,1,9.224,1,9.5v1C1,10.776,1.224,11,1.5,11h11c0.276,0,0.5-0.224,0.5-0.5v-1\r\n\tC13,9.224,12.776,9,12.5,9z M12.5,14h-11C1.224,14,1,14.224,1,14.5v1C1,15.776,1.224,16,1.5,16h11c0.276,0,0.5-0.224,0.5-0.5v-1\r\n\tC13,14.224,12.776,14,12.5,14z"
    }
  }]
};
exports.unread = unread;
var untag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1,14.742l4.945-0.709L5.239,19l5.962-5.985L7.132,8.586L1,14.742z M18.664,5.521c0.391-0.393,0.5-0.945,0-1.419\r\n\tl-2.826-2.839c-0.279-0.308-1.021-0.392-1.412,0l-3.766,3.78l4.068,4.429L18.664,5.521z M18.706,15.293l-14.001-14\r\n\tc-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414l14.001,14C17.488,16.903,17.744,17,17.999,17\r\n\tc0.256,0,0.512-0.098,0.707-0.293C19.097,16.317,19.097,15.684,18.706,15.293z"
    }
  }]
};
exports.untag = untag;
var toCloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.toCloud = toCloud;
var upload = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8,12h4V6h3l-5-5L5,6h3V12z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757\r\n\tl3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408\r\n\tL5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449\r\n\tl0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074\r\n\tC20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  }]
};
exports.upload = upload;
var users = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.989,19.129c0-2.246-2.187-3.389-4.317-4.307c-2.123-0.914-2.801-1.684-2.801-3.334c0-0.989,0.648-0.667,0.932-2.481\r\n\tc0.12-0.752,0.692-0.012,0.802-1.729c0-0.684-0.313-0.854-0.313-0.854s0.159-1.013,0.221-1.793c0.064-0.817-0.398-2.56-2.301-3.095\r\n\tC7.88,1.195,7.655,0.654,8.679,0.112c-2.24-0.104-2.761,1.068-3.954,1.93c-1.015,0.756-1.289,1.953-1.24,2.59\r\n\tc0.065,0.78,0.223,1.793,0.223,1.793s-0.314,0.17-0.314,0.854c0.11,1.718,0.684,0.977,0.803,1.729\r\n\tC4.481,10.822,5.13,10.5,5.13,11.489c0,1.65-0.212,2.21-2.336,3.124C0.663,15.53,0,17,0.011,19.129C0.014,19.766,0,20,0,20h16\r\n\tC16,20,15.989,19.766,15.989,19.129z M18.528,13.365c-1.135-0.457-1.605-1.002-1.605-2.066c0-0.641,0.418-0.432,0.602-1.603\r\n\tc0.077-0.484,0.447-0.008,0.518-1.115c0-0.441-0.202-0.551-0.202-0.551s0.103-0.656,0.143-1.159c0.05-0.627-0.364-2.247-2.268-2.247\r\n\tc-1.903,0-2.318,1.62-2.269,2.247c0.042,0.502,0.144,1.159,0.144,1.159s-0.202,0.109-0.202,0.551\r\n\tc0.071,1.107,0.441,0.631,0.518,1.115c0.184,1.172,0.602,0.963,0.602,1.603c0,1.064-0.438,1.562-1.809,2.152\r\n\tc-0.069,0.029-0.12,0.068-0.183,0.102c1.64,0.712,4.226,1.941,4.838,4.447H20c0,0,0-1.906,0-2.318\r\n\tC20,14.682,19.727,13.848,18.528,13.365z"
    }
  }]
};
exports.users = users;
var vinyl = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.999,0.8C4.918,0.8,0.8,4.919,0.8,10.001c0,5.08,4.118,9.199,9.199,9.199c5.081,0,9.2-4.119,9.2-9.199\r\n\tC19.199,4.919,15.08,0.8,9.999,0.8z M10,13.001c-1.657,0-3-1.344-3-3c0-1.656,1.343-3,3-3c1.656,0,3,1.344,3,3\r\n\tC13,11.657,11.656,13.001,10,13.001z"
    }
  }]
};
exports.vinyl = vinyl;
var voicemail = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.4,5.801c-2.541,0-4.601,2.059-4.601,4.6c0,0.965,0.298,1.859,0.806,2.6H8.394c0.508-0.74,0.805-1.635,0.805-2.6\r\n\tc0-2.541-2.059-4.6-4.6-4.6c-2.54,0-4.6,2.059-4.6,4.6C0,12.941,2.059,15,4.6,15H15.4c2.54,0,4.6-2.059,4.6-4.6\r\n\tC20,7.859,17.94,5.801,15.4,5.801z M2,10.4c0-1.436,1.164-2.6,2.6-2.6c1.436,0,2.6,1.164,2.6,2.6c0,1.436-1.164,2.6-2.6,2.6\r\n\tC3.164,13,2,11.836,2,10.4z M15.4,13c-1.437,0-2.601-1.164-2.601-2.6c0-1.436,1.164-2.6,2.601-2.6c1.435,0,2.6,1.164,2.6,2.6\r\n\tC18,11.836,16.836,13,15.4,13z"
    }
  }]
};
exports.voicemail = voicemail;
var wallet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,6H3.5V5.5l11-0.88V5.5H16V4c0-1.1-0.891-1.872-1.979-1.717L3.98,3.717C2.891,3.873,2,4.9,2,6v10c0,1.104,0.895,2,2,2h12\r\n\tc1.104,0,2-0.896,2-2V8C18,6.896,17.104,6,16,6z M14.5,13.006c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5\r\n\tS15.328,13.006,14.5,13.006z"
    }
  }]
};
exports.wallet = wallet;
var warning = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.511,17.98L10.604,1.348C10.48,1.133,10.25,1,10,1C9.749,1,9.519,1.133,9.396,1.348L0.49,17.98\r\n\tc-0.121,0.211-0.119,0.471,0.005,0.68C0.62,18.871,0.847,19,1.093,19h17.814c0.245,0,0.474-0.129,0.598-0.34\r\n\tC19.629,18.451,19.631,18.191,19.511,17.98z M11,17H9v-2h2V17z M11,13.5H9V7h2V13.5z"
    }
  }]
};
exports.warning = warning;
var water = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.882,9.093c-0.511,4.115-3.121,4.847-3.121,7.708C6.761,18.567,8.244,20,10,20c1.756,0,3.238-1.434,3.238-3.199\r\n\tc0-2.861-2.61-3.593-3.121-7.708C10.101,8.97,9.898,8.97,9.882,9.093z M3.883,0.093C3.372,4.208,0.762,4.939,0.762,7.801\r\n\tC0.762,9.566,2.244,11,4,11c1.756,0,3.238-1.434,3.238-3.199c0-2.861-2.61-3.593-3.121-7.708C4.102-0.03,3.898-0.03,3.883,0.093z\r\n\t M15.883,0.093c-0.511,4.115-3.121,4.847-3.121,7.708C12.762,9.566,14.244,11,16,11c1.756,0,3.238-1.434,3.238-3.199\r\n\tc0-2.861-2.61-3.593-3.121-7.708C16.101-0.03,15.898-0.03,15.883,0.093z"
    }
  }]
};
exports.water = water;
var fiveHundredPX = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.398,14.775c0.481-0.174,0.928-0.4,1.337-0.683c0.41-0.282,0.797-0.608,1.16-0.982c0.363-0.373,0.736-0.759,1.118-1.159\r\n\tc0.346,0.4,0.71,0.786,1.092,1.159c0.382,0.374,0.787,0.7,1.214,0.982c0.428,0.282,0.887,0.509,1.379,0.683\r\n\tc0.49,0.173,1.017,0.259,1.582,0.259c0.727,0,1.387-0.132,1.977-0.396c0.591-0.264,1.087-0.627,1.487-1.092\r\n\tc0.399-0.464,0.71-1.005,0.928-1.623C19.891,11.306,20,10.642,20,9.932c0-0.71-0.109-1.364-0.328-1.964\r\n\tc-0.218-0.602-0.528-1.123-0.928-1.569c-0.4-0.446-0.892-0.795-1.473-1.05c-0.583-0.256-1.238-0.383-1.966-0.383\r\n\tc-0.581,0-1.123,0.092-1.623,0.273c-0.5,0.182-0.964,0.423-1.391,0.723c-0.428,0.3-0.828,0.65-1.201,1.051\r\n\tc-0.372,0.399-0.732,0.81-1.078,1.228C9.648,7.804,9.28,7.391,8.908,6.999C8.535,6.608,8.135,6.262,7.707,5.962\r\n\tc-0.428-0.3-0.891-0.541-1.391-0.723c-0.5-0.182-1.051-0.273-1.65-0.273c-0.728,0-1.385,0.133-1.965,0.396\r\n\tC2.117,5.626,1.628,5.979,1.227,6.426c-0.4,0.446-0.706,0.974-0.914,1.583C0.104,8.618,0,9.277,0,9.985\r\n\tc0,0.71,0.108,1.374,0.326,1.992c0.219,0.619,0.537,1.15,0.955,1.597c0.419,0.446,0.919,0.801,1.5,1.064\r\n\tc0.584,0.264,1.246,0.396,1.993,0.396C5.374,15.034,5.916,14.948,6.398,14.775z M3.164,11.65c-0.383-0.418-0.573-0.955-0.573-1.609\r\n\tc0-0.6,0.186-1.142,0.561-1.624c0.372-0.48,0.876-0.723,1.515-0.723c0.345,0,0.689,0.078,1.035,0.232\r\n\tc0.346,0.154,0.678,0.35,0.997,0.587C7.016,8.75,7.321,9.009,7.611,9.29c0.291,0.283,0.546,0.542,0.765,0.778\r\n\tc-0.219,0.255-0.464,0.515-0.737,0.776c-0.273,0.266-0.562,0.502-0.872,0.71c-0.311,0.21-0.637,0.382-0.983,0.519\r\n\tc-0.345,0.137-0.691,0.205-1.036,0.205C4.073,12.278,3.546,12.069,3.164,11.65z M14.256,12.088c-0.336-0.127-0.66-0.296-0.968-0.505\r\n\tc-0.311-0.209-0.603-0.445-0.874-0.709c-0.273-0.264-0.528-0.532-0.764-0.806c0.218-0.236,0.463-0.495,0.736-0.778\r\n\tc0.273-0.281,0.56-0.54,0.859-0.776c0.3-0.237,0.619-0.433,0.955-0.587c0.337-0.154,0.688-0.232,1.051-0.232\r\n\tc0.673,0,1.204,0.227,1.596,0.683c0.392,0.454,0.587,1,0.587,1.638c0,0.637-0.183,1.172-0.546,1.608\r\n\tc-0.364,0.438-0.882,0.655-1.555,0.655C14.952,12.278,14.592,12.215,14.256,12.088z"
    }
  }]
};
exports.fiveHundredPX = fiveHundredPX;
var store = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.5640259,13.8623047\r\n\tc-0.4133301,0.9155273-0.6115723,1.3251343-1.1437988,2.1346436c-0.7424927,1.1303711-1.7894897,2.5380249-3.086853,2.5500488\r\n\tc-1.1524048,0.0109253-1.4483032-0.749939-3.0129395-0.741333c-1.5640259,0.008606-1.8909302,0.755127-3.0438843,0.7442017\r\n\tc-1.296814-0.0120239-2.2891235-1.2833252-3.0321655-2.4136963c-2.0770874-3.1607666-2.2941895-6.8709106-1.0131836-8.8428955\r\n\tc0.9106445-1.4013062,2.3466187-2.2217407,3.6970215-2.2217407c1.375,0,2.239502,0.7539673,3.3761597,0.7539673\r\n\tc1.1028442,0,1.7749023-0.755127,3.3641357-0.755127c1.201416,0,2.4744263,0.6542969,3.3816528,1.7846069\r\n\tC14.0778809,8.4837646,14.5608521,12.7279663,17.5640259,13.8623047z M12.4625244,3.8076782\r\n\tc0.5775146-0.741333,1.0163574-1.7880859,0.8571167-2.857666c-0.9436035,0.0653076-2.0470581,0.6651611-2.6912842,1.4477539\r\n\tC10.0437012,3.107605,9.56073,4.1605835,9.7486572,5.1849365C10.7787476,5.2164917,11.8443604,4.6011963,12.4625244,3.8076782z"
    }
  }]
};
exports.store = store;
var baidu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.4116364,6.9370399c-0.3587151-0.2830696-0.923996-0.4004283-1.4627256-0.3652954\r\n\tc-0.4163361,0.0265503-0.7609177,0.0346184-1.0045052,0.1825905c-1.1165419,0.6770897-1.2169638,4.3529868,0.1820755,4.9340606\r\n\tC18.100399,12.9238987,19.1828365,8.3379107,17.4116364,6.9370399z M12.933279,10.7750425\r\n\tc-0.9637632-1.1185446-1.6411963-2.6815205-3.5630016-2.375906c-1.7067132,0.2714539-1.9238648,1.6706648-2.8335552,2.6501064\r\n\tc-1.0796924,1.1637497-3.1049521,2.0173635-3.5640316,3.8376598c-0.3346822,1.3286009,0.1159286,2.8923788,0.9135242,3.4726515\r\n\tc1.5661802,1.1375408,4.473722-0.1246262,6.5796628,0.0911503c1.2606802,0.1290321,2.2246733,0.571804,3.197649,0.5484009\r\n\tc2.2625532-0.0532722,4.0896587-1.669405,3.1077557-4.294507C16.2904587,13.418684,14.1704426,12.21099,12.933279,10.7750425z\r\n\t M12.6592512,6.8458877c1.1333075,0.0318718,2.3012905-1.2649717,2.3760777-2.467402\r\n\tc0.0976181-1.5697851-0.929431-3.1436331-2.4671726-2.7416024c-0.9137535,0.2387236-1.66397,1.4105408-1.7361822,2.5593553\r\n\tC10.7485466,5.5281014,11.4487524,6.8116126,12.6592512,6.8458877z M8.2726755,6.4801922\r\n\tC9.4498711,6.321291,9.9402504,4.9083467,9.7355728,3.2816844c-0.1689148-1.338729-0.8955564-2.6371751-2.4675736-2.192801\r\n\tC5.1026068,1.7001691,5.4477601,6.8620238,8.2726755,6.4801922z M4.1614451,10.5923948\r\n\tc2.5823007-0.3854933,1.9797125-5.9385071-0.8224294-5.2997556C0.9296925,5.8418407,1.2518435,11.0266409,4.1614451,10.5923948z"
    }
  }]
};
exports.baidu = baidu;
var basecamp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2C5.327,2,0.7,8.481,0.7,14.422C0.7,15.799,5.234,18,10,18s9.3-2.201,9.3-3.578C19.3,8.481,14.673,2,10,2z\r\n\t M10.006,15.615c-5.198,0-6.673-2.068-6.673-2.722c0-1.287,2.13-4.485,2.906-4.485c0.719,0,1.542,1.811,2.314,1.811\r\n\tc1.241,0,2.567-3.954,3.579-3.954s4.601,5.178,4.601,6.749C16.733,13.285,15.649,15.615,10.006,15.615z"
    }
  }]
};
exports.basecamp = basecamp;
var behance = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.072,9.301c0,0,1.892-0.147,1.892-2.459c0-2.315-1.548-3.441-3.51-3.441H0v12.926h6.454c0,0,3.941,0.129,3.941-3.816\r\n\tC10.394,12.51,10.566,9.301,8.072,9.301z M2.844,5.697h3.61c0,0,0.878,0,0.878,1.344c0,1.346-0.516,1.541-1.102,1.541H2.844V5.697z\r\n\t M6.271,14.029H2.844v-3.455h3.61c0,0,1.308-0.018,1.308,1.775C7.762,13.861,6.785,14.018,6.271,14.029z M15.649,6.688\r\n\tc-4.771,0-4.767,4.967-4.767,4.967s-0.326,4.941,4.767,4.941c0,0,4.243,0.254,4.243-3.437h-2.182c0,0,0.072,1.391-1.988,1.391\r\n\tc0,0-2.184,0.152-2.184-2.25h6.423C19.962,12.299,20.67,6.688,15.649,6.688z M17.59,10.574h-4.074c0,0,0.266-1.992,2.182-1.992\r\n\tS17.59,10.574,17.59,10.574z M18.097,4.16H12.98v1.594h5.117V4.16z"
    }
  }]
};
exports.behance = behance;
var dribbble = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.565,7.421C8.207,5.007,6.754,3.038,6.648,2.893C4.457,3.929,2.822,5.948,2.311,8.38C2.517,8.384,5.793,8.423,9.565,7.421\r\n\tz M10.543,10.061c0.102-0.033,0.206-0.064,0.309-0.094c-0.197-0.447-0.412-0.895-0.637-1.336C6.169,9.843,2.287,9.755,2.15,9.751\r\n\tc-0.003,0.084-0.007,0.166-0.007,0.25c0,2.019,0.763,3.861,2.016,5.252l-0.005-0.006C4.154,15.247,6.304,11.433,10.543,10.061z\r\n\t M5.171,16.194V16.19c-0.058-0.045-0.12-0.086-0.178-0.135C5.099,16.14,5.171,16.194,5.171,16.194z M8.118,2.372\r\n\tC8.111,2.374,8.103,2.376,8.103,2.376c0.006-0.002,0.014-0.002,0.014-0.002L8.118,2.372z M15.189,4.104\r\n\tC13.805,2.886,11.99,2.143,10,2.143c-0.639,0-1.258,0.078-1.852,0.221c0.12,0.16,1.595,2.119,2.938,4.584\r\n\tC14.048,5.839,15.167,4.136,15.189,4.104z M10,19.2c-5.08,0-9.199-4.119-9.199-9.199C0.8,4.919,4.919,0.8,10,0.8\r\n\tc5.082,0,9.2,4.119,9.2,9.201C19.2,15.081,15.082,19.2,10,19.2z M11.336,11.286c-4.611,1.607-6.134,4.838-6.165,4.904\r\n\tc1.334,1.041,3.006,1.666,4.828,1.666c1.088,0,2.125-0.221,3.067-0.621c-0.116-0.689-0.573-3.096-1.679-5.967\r\n\tC11.371,11.274,11.354,11.28,11.336,11.286z M11.69,8.12c0.184,0.373,0.358,0.754,0.523,1.139c0.059,0.135,0.114,0.272,0.17,0.406\r\n\tc2.713-0.342,5.385,0.238,5.473,0.256c-0.019-1.863-0.686-3.572-1.787-4.912C16.051,5.032,14.79,6.852,11.69,8.12z M12.861,10.905\r\n\tc1.031,2.836,1.449,5.142,1.529,5.611c1.764-1.191,3.018-3.08,3.367-5.27C17.601,11.196,15.401,10.499,12.861,10.905z"
    }
  }]
};
exports.dribbble = dribbble;
var dropbox = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.109,0.902L0.4,4.457l3.911,3.279L10,4.043L6.109,0.902z M13.452,15.992c-0.102,0-0.203-0.033-0.285-0.102L10,13.262\r\n\tl-3.167,2.629c-0.082,0.068-0.184,0.102-0.285,0.102c-0.085,0-0.17-0.023-0.244-0.072l-2.346-1.533v0.904L10,19.098l6.042-3.807\r\n\tv-0.904l-2.346,1.533C13.622,15.969,13.537,15.992,13.452,15.992z M19.6,4.457l-5.71-3.555L10,4.043l5.688,3.693L19.6,4.457z\r\n\t M10,11.291l3.528,2.928l5.641-3.688l-3.481-2.795L10,11.291z M6.472,14.219L10,11.291L4.311,7.736l-3.48,2.795L6.472,14.219z"
    }
  }]
};
exports.dropbox = dropbox;
var evernote = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.3,4.3c0-1.2-1.7-1.3-1.7-1.3l-4.1-0.3c0,0-0.1-1.1-0.9-1.5C9.8,0.9,8.9,1,8.3,1C7.6,1,7.5,1.9,7.5,2.6\r\n\tc0,0.8,0,1.7,0,2.2c0,1-0.4,1.4-1.6,1.4H3.6c-0.6,0-1.1,0.1-1.1,0.6c0,0.5,0.8,5,1.8,6c0.6,0.6,4.3,1,5.1,1s0.5-2.3,0.7-2.3\r\n\ts0.5,1.3,1.7,1.6c1.2,0.3,2.9,0.2,3,1.1c0.1,1.2,0.2,2.6-0.5,2.7l-1.7,0.1c-1.2-0.1-0.9-1.4-0.3-1.4c0.5,0,0.8,0,0.8,0l0.1-1.4\r\n\tc0,0-2.7-0.3-2.8,1.5c-0.1,1.7,0.2,2.4,0.4,2.6c0.2,0.2,0.6,0.5,3.9,0.5C19,19,17.3,5.5,17.3,4.3z M15.4,10.3\r\n\tC15.3,10.5,14.6,10,14,10c-0.6,0-1.3,0.3-1.5,0.1c-0.2-0.2,0.1-2,1.3-2S15.6,10.1,15.4,10.3z M5.3,4.6c-0.5,0-2.9,0-2.9,0l3.5-3.4\r\n\tc0,0-0.1,2.8-0.1,3C5.8,4.4,5.7,4.6,5.3,4.6z"
    }
  }]
};
exports.evernote = evernote;
var facebook = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,1H3C1.9,1,1,1.9,1,3v14c0,1.101,0.9,2,2,2h7v-7H8V9.525h2V7.475c0-2.164,1.212-3.684,3.766-3.684l1.803,0.002v2.605\r\n\th-1.197C13.378,6.398,13,7.144,13,7.836v1.69h2.568L15,12h-2v7h4c1.1,0,2-0.899,2-2V3C19,1.9,18.1,1,17,1z"
    }
  }]
};
exports.facebook = facebook;
var flattr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.598,8.541c0-1.637,0.434-2.678,1.889-2.912c0.508-0.1,1.566-0.064,2.239-0.064v2.5c0,0.024,0.003,0.064,0.009,0.084\r\n\tC9.762,8.25,9.854,8.324,9.963,8.324c0.061,0,0.118-0.031,0.178-0.09L16.377,2H12.19H7.548C3.874,2,2,4.115,2,8.066v8.287\r\n\tl3.598-3.602V8.541z M14.4,7.248v4.209c0,1.637-0.434,2.68-1.889,2.912c-0.508,0.1-1.566,0.065-2.238,0.065v-2.5\r\n\tc0-0.022-0.004-0.062-0.009-0.084c-0.028-0.1-0.12-0.174-0.228-0.176c-0.062,0-0.118,0.033-0.179,0.092l-6.235,6.232L7.809,18h4.643\r\n\tC16.125,18,18,15.885,18,11.934V3.647L14.4,7.248z"
    }
  }]
};
exports.flattr = flattr;
var flickr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,14c-2.188,0-3.96-1.789-3.96-4c0-2.211,1.772-4,3.96-4c2.187,0,3.96,1.789,3.96,4C8.96,12.211,7.187,14,5,14z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M15,14c-2.188,0-3.96-1.789-3.96-4c0-2.211,1.772-4,3.96-4c2.187,0,3.96,1.789,3.96,4C18.96,12.211,17.187,14,15,14z"
    }
  }]
};
exports.flickr = flickr;
var foursquare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.92,1C4.412,1,4,1.412,4,1.92v16.516c0,0.625,0.765,0.926,1.192,0.47l4.471-4.79C9.731,14.042,9.826,14,9.927,14h3.237\r\n\tc0.486,0,0.905-0.343,1.001-0.82l2.111-10.514C16.449,1.804,15.79,1,14.911,1H4.92z M8.838,12.19L6,15.527V3.343\r\n\tC6,3.154,6.154,3,6.343,3h7.14c0.342,0,0.598,0.313,0.53,0.648l-0.413,2.055C13.566,5.876,13.414,6,13.238,6h-3.71\r\n\tC9.236,6,9,6.236,9,6.528v1.22C9,7.887,9.113,8,9.253,8h3.294c0.306,0,0.536,0.28,0.476,0.581l-0.614,3.058\r\n\tC12.366,11.849,12.181,12,11.967,12H9.25C9.091,12,8.941,12.069,8.838,12.19z"
    }
  }]
};
exports.foursquare = foursquare;
var github = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.18,11.309c-0.718,0-1.3,0.807-1.3,1.799c0,0.994,0.582,1.801,1.3,1.801s1.3-0.807,1.3-1.801\r\n\tC14.479,12.116,13.898,11.309,13.18,11.309z M17.706,6.626c0.149-0.365,0.155-2.439-0.635-4.426c0,0-1.811,0.199-4.551,2.08\r\n\tc-0.575-0.16-1.548-0.238-2.519-0.238c-0.973,0-1.945,0.078-2.52,0.238C4.74,2.399,2.929,2.2,2.929,2.2\r\n\tC2.14,4.187,2.148,6.261,2.295,6.626C1.367,7.634,0.8,8.845,0.8,10.497c0,7.186,5.963,7.301,7.467,7.301\r\n\tc0.342,0,1.018,0.002,1.734,0.002c0.715,0,1.392-0.002,1.732-0.002c1.506,0,7.467-0.115,7.467-7.301\r\n\tC19.2,8.845,18.634,7.634,17.706,6.626z M10.028,16.915H9.972c-3.771,0-6.709-0.449-6.709-4.115c0-0.879,0.31-1.693,1.047-2.369\r\n\tc1.227-1.127,3.305-0.531,5.662-0.531c0.01,0,0.02,0,0.029,0c0.01,0,0.018,0,0.027,0c2.357,0,4.436-0.596,5.664,0.531\r\n\tc0.735,0.676,1.045,1.49,1.045,2.369C16.737,16.466,13.8,16.915,10.028,16.915z M6.821,11.309c-0.718,0-1.3,0.807-1.3,1.799\r\n\tc0,0.994,0.582,1.801,1.3,1.801c0.719,0,1.301-0.807,1.301-1.801C8.122,12.116,7.54,11.309,6.821,11.309z"
    }
  }]
};
exports.github = github;
var googlePlus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.989,5.589c0,1.494,0.499,2.572,1.482,3.205c0.806,0.52,1.74,0.598,2.226,0.598c0.118,0,0.213-0.006,0.279-0.01\r\n\tc0,0-0.154,1.004,0.59,1.996H6.532c-1.289,0-5.493,0.269-5.493,3.727c0,3.516,3.861,3.695,4.636,3.695\r\n\tc0.061,0,0.097-0.002,0.097-0.002c0.008,0,0.063,0.002,0.158,0.002c0.497,0,1.782-0.062,2.975-0.643\r\n\tc1.548-0.75,2.333-2.059,2.333-3.885c0-1.764-1.196-2.814-2.069-3.582c-0.533-0.469-0.994-0.873-0.994-1.266\r\n\tc0-0.4,0.337-0.701,0.762-1.082c0.689-0.615,1.339-1.492,1.339-3.15c0-1.457-0.189-2.436-1.354-3.057\r\n\tc0.121-0.062,0.551-0.107,0.763-0.137c0.631-0.086,1.554-0.184,1.554-0.699V1.2H6.64C6.594,1.202,1.989,1.372,1.989,5.589z\r\n\t M9.413,14.602c0.088,1.406-1.115,2.443-2.922,2.574c-1.835,0.135-3.345-0.691-3.433-2.096c-0.043-0.676,0.254-1.336,0.835-1.863\r\n\tc0.589-0.533,1.398-0.863,2.278-0.928c0.104-0.006,0.207-0.012,0.31-0.012C8.18,12.278,9.33,13.276,9.413,14.602z M8.212,4.626\r\n\tc0.451,1.588-0.23,3.246-1.316,3.553C6.771,8.214,6.643,8.231,6.512,8.231c-0.994,0-1.979-1.006-2.345-2.393\r\n\tC3.963,5.062,3.98,4.38,4.214,3.726c0.229-0.645,0.643-1.078,1.163-1.225c0.125-0.035,0.254-0.053,0.385-0.053\r\n\tC6.962,2.448,7.734,2.946,8.212,4.626z M16,8V5h-2v3h-3v2h3v3h2v-3h3V8H16z"
    }
  }]
};
exports.googlePlus = googlePlus;
var hangouts = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0C5.25,0,1.4,3.806,1.4,8.5C1.4,13.194,5.25,17,10,17v3c3.368-1.672,8.6-5.305,8.6-11.5C18.6,3.806,14.75,0,10,0z\r\n\t M9,9.741c0,1.328-1.021,2.422-2.32,2.538c-0.123,0.011-0.228-0.088-0.228-0.211v-0.852c0-0.106,0.079-0.194,0.184-0.21\r\n\tC7.167,10.93,7.573,10.519,7.683,10H5.732C5.328,10,5,9.672,5,9.268V6.732C5,6.328,5.328,6,5.732,6h2.536C8.672,6,9,6.328,9,6.732\r\n\tV9.741z M15,9.741c0,1.328-1.021,2.422-2.32,2.538c-0.123,0.011-0.228-0.088-0.228-0.211v-0.852c0-0.106,0.079-0.194,0.184-0.21\r\n\tc0.531-0.077,0.937-0.487,1.047-1.006h-1.951C11.328,10,11,9.672,11,9.268V6.732C11,6.328,11.328,6,11.732,6h2.536\r\n\tC14.672,6,15,6.328,15,6.732V9.741z"
    }
  }]
};
exports.hangouts = hangouts;
var grooveshark = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.grooveshark = grooveshark;
var houzz = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4,10l6,3l-6,3V10z M10,7l6,3V4L10,7z M10,20l6-3v-7l-6,3V20z M10,0L4,3v7l6-3V0z"
    }
  }]
};
exports.houzz = houzz;
var icloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.909,5c1.884,0,3.417,1.598,3.417,3.561c0,0.136-0.012,0.29-0.037,0.484c0,0-0.163,1.262-0.206,1.594\r\n\tc-0.043,0.332,0.186,0.65,0.528,0.653c0.342,0.002,1.65,0.01,1.65,0.01C17.219,11.308,18,12.137,18,13.15\r\n\tc0,1.02-0.785,1.85-1.75,1.85H4.167C2.972,15,2,13.978,2,12.722c0-0.913,0.519-1.735,1.323-2.095c0,0,0.421-0.188,0.651-0.291\r\n\tc0.23-0.103,0.508-0.431,0.516-0.775c0.008-0.344,0.016-0.714,0.016-0.714c0.012-0.535,0.421-0.97,0.91-0.97\r\n\tc0.032,0,0.094,0.006,0.207,0.035c0,0,0.774,0.197,1.039,0.264c0.265,0.067,0.606-0.066,0.73-0.309\r\n\tc0.124-0.243,0.503-0.981,0.503-0.981C8.493,5.723,9.648,5,10.909,5 M10.909,3C8.828,3,7.023,4.207,6.116,5.974\r\n\tC5.891,5.917,5.659,5.878,5.417,5.878c-1.587,0-2.873,1.304-2.91,2.924C1.033,9.461,0,10.966,0,12.722C0,15.085,1.865,17,4.167,17\r\n\tH16.25c2.071,0,3.75-1.724,3.75-3.85c0-2.118-1.667-3.835-3.728-3.848c0.031-0.243,0.053-0.489,0.053-0.741\r\n\tC16.326,5.49,13.901,3,10.909,3L10.909,3z"
    }
  }]
};
exports.icloud = icloud;
var instagram = {
  "viewBox": "0 0 18 18",
  "children": [{
    "name": "title",
    "attribs": {}
  }, {
    "name": "path",
    "attribs": {
      "d": "M18.94586,6.28931a6.60561,6.60561,0,0,0-.41833-2.18463,4.41189,4.41189,0,0,0-1.03809-1.59412,4.41189,4.41189,0,0,0-1.59412-1.03809,6.60561,6.60561,0,0,0-2.18463-.41833C12.75073,1.01038,12.44427,1,10,1s-2.75073.01038-3.71069,0.05414a6.60561,6.60561,0,0,0-2.18463.41833A4.41189,4.41189,0,0,0,2.51056,2.51056,4.41189,4.41189,0,0,0,1.47247,4.10468a6.60561,6.60561,0,0,0-.41833,2.18463C1.01038,7.24927,1,7.55573,1,10s0.01038,2.75073.05414,3.71069a6.60561,6.60561,0,0,0,.41833,2.18463,4.41189,4.41189,0,0,0,1.03809,1.59412,4.41109,4.41109,0,0,0,1.59412,1.03809,6.60561,6.60561,0,0,0,2.18463.41833C7.24927,18.98969,7.55573,19,10,19s2.75073-.01031,3.71069-0.05414a6.60561,6.60561,0,0,0,2.18463-.41833,4.60208,4.60208,0,0,0,2.6322-2.6322,6.60561,6.60561,0,0,0,.41833-2.18463C18.98962,12.75073,19,12.44427,19,10S18.98962,7.24927,18.94586,6.28931Zm-1.61993,7.34747a4.97824,4.97824,0,0,1-.30994,1.67114A2.98017,2.98017,0,0,1,15.30792,17.016a4.9786,4.9786,0,0,1-1.67114.30994C12.68787,17.3692,12.40326,17.37836,10,17.37836s-2.68787-.00916-3.63678-0.05243A4.9786,4.9786,0,0,1,4.69208,17.016a2.78769,2.78769,0,0,1-1.03485-.67322A2.78769,2.78769,0,0,1,2.984,15.30792a4.97824,4.97824,0,0,1-.30994-1.67114C2.6308,12.68774,2.62164,12.40314,2.62164,10s0.00916-2.68774.05243-3.63678A4.9786,4.9786,0,0,1,2.984,4.69208a2.78769,2.78769,0,0,1,.67322-1.03485A2.78769,2.78769,0,0,1,4.69208,2.984a4.9786,4.9786,0,0,1,1.67114-.30994C7.31226,2.6308,7.59686,2.62164,10,2.62164s2.68774,0.00916,3.63678.05243a4.9786,4.9786,0,0,1,1.67114.30994,2.78769,2.78769,0,0,1,1.03485.67322A2.78769,2.78769,0,0,1,17.016,4.69208a4.9786,4.9786,0,0,1,.30994,1.67114c0.04327,0.949.05243,1.2337,0.05243,3.63678S17.3692,12.68774,17.32593,13.63678ZM10,5.37836A4.62164,4.62164,0,1,0,14.62164,10,4.62169,4.62169,0,0,0,10,5.37836ZM10,13a3,3,0,1,1,3-3A3,3,0,0,1,10,13Zm5.88422-7.8042a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,15.88422,5.1958Z",
      "transform": "translate(-1 -1)"
    }
  }]
};
exports.instagram = instagram;
var lastfm = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.574,14.576C8.097,14.924,7.119,15.6,5.193,15.6C2.532,15.6,0,13.707,0,10.195C0,6.547,2.637,4.4,5.354,4.4\r\n\tc3.047,0,4.183,1.108,5.144,4.109l0.756,2.309c0.551,1.688,1.713,2.91,4.026,2.91c1.558,0,2.382-0.346,2.382-1.199\r\n\tc0-0.67-0.389-1.156-1.557-1.434l-1.559-0.369c-1.9-0.461-2.656-1.455-2.656-3.025c0-2.516,2.016-3.301,4.077-3.301\r\n\tc2.337,0,3.757,0.854,3.94,2.932l-2.291,0.277c-0.092-0.992-0.688-1.408-1.787-1.408c-1.008,0-1.627,0.461-1.627,1.246\r\n\tc0,0.693,0.299,1.109,1.307,1.34l1.466,0.324C18.945,9.572,20,10.543,20,12.414c0,2.309-1.924,3.186-4.766,3.186\r\n\tc-3.963,0-5.338-1.801-6.07-4.041L8.43,9.25c-0.549-1.687-0.99-2.902-3.006-2.902c-1.398,0-3.219,0.916-3.219,3.756\r\n\tc0,2.217,1.523,3.604,3.104,3.604c1.34,0,2.146-0.754,2.564-1.131L8.574,14.576z"
    }
  }]
};
exports.lastfm = lastfm;
var linkedin = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,3c0,1.1-0.7,2-2,2C1.8,5,1,4.1,1,3.1C1,2,1.8,1,3,1S5,1.9,5,3z M1,19h4V6H1V19z M14.6,6.2c-2.1,0-3.3,1.2-3.8,2h-0.1\r\n\tl-0.2-1.7H6.9C6.9,7.6,7,8.9,7,10.4V19h4v-7.1c0-0.4,0-0.7,0.1-1c0.3-0.7,0.8-1.6,1.9-1.6c1.4,0,2,1.2,2,2.8V19h4v-7.4\r\n\tC19,7.9,17.1,6.2,14.6,6.2z"
    }
  }]
};
exports.linkedin = linkedin;
var medium = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.7502384,5C18.7502384,5,18,5,18,5.7501426s0,8.5002785,0,8.5002785S18,15,18.7502384,15H19v2h-6v-2h1V5.6999512\r\n\th-0.0999756L10.8354492,17H8.1365967L5.0999761,5.6999512H5.0000005V15h1v2h-5v-2h0.2497627c0,0,0.7502373,0,0.7502373-0.7501431\r\n\tc0-0.7501421,0-8.5002775,0-8.5002775S2.0000005,5,1.2497631,5H1.0000005V3h6.6340332l2.3269038,8.6591797h0.0766602L12.3859863,3\r\n\tH19v2H18.7502384z"
    }
  }]
};
exports.medium = medium;
var mixi = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.mixi = mixi;
var onedrive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.429,9.847c0.487-1.961,2.249-3.394,4.341-3.394c1.236,0,2.394,0.505,3.232,1.382c0.354-0.114,0.768-0.202,1.136-0.21\r\n\tv-0.13c0-2.482-1.845-4.495-4.12-4.495C9.392,3,7.998,4.038,7.328,5.531C6.834,5.197,6.257,4.996,5.634,4.996\r\n\tc-1.785,0-3.231,1.577-3.231,3.523c0,0.21,0.024,0.414,0.057,0.613c-1.377,0.136-2.455,1.544-2.455,3.08\r\n\tc0,0.016,0.004,0.029,0.004,0.045C0.008,12.271,0,12.285,0,12.299c0,0.615,0.214,1.177,0.561,1.631C1.053,14.592,1.823,15,2.701,15\r\n\th1.261c-0.246-0.488-0.398-1.032-0.398-1.615C3.563,11.648,4.794,10.193,6.429,9.847z M17.889,11.777\r\n\tc-0.025,0-0.05,0.007-0.075,0.008c0.007-0.074,0.022-0.146,0.022-0.222c0-1.472-1.193-2.664-2.665-2.664\r\n\tc-0.586,0-1.123,0.194-1.564,0.516c-0.546-1.015-1.604-1.712-2.838-1.712c-1.788,0-3.237,1.449-3.237,3.237\r\n\tc0,0.023,0.006,0.043,0.007,0.066C7.421,10.988,7.303,10.97,7.18,10.97c-1.335,0-2.415,1.081-2.415,2.415\r\n\tc0,0.167,0.017,0.33,0.049,0.487C5.042,15.083,6.102,16,7.38,16h10.706v-0.019C19.158,15.879,20,14.987,20,13.889\r\n\tC20,12.723,19.055,11.777,17.889,11.777z"
    }
  }]
};
exports.onedrive = onedrive;
var paypal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.914,10.677h1.659c3.604,0,5.649-1.623,6.3-4.96c0.021-0.11,0.04-0.216,0.056-0.322c0.036-0.226,0.054-0.429,0.062-0.624\r\n\tC15.997,4.637,16.001,4.558,16,4.484c-0.008-0.391-0.077-0.722-0.216-1.039c-0.129-0.296-0.324-0.587-0.613-0.918\r\n\tC14.318,1.557,12.832,1,11.057,1H5.404C5.006,1,4.667,1.29,4.605,1.683l-1.02,6.571l-1.269,8.185C2.27,16.734,2.498,17,2.796,17\r\n\tl2.772,0l0.849-5.043C6.534,11.217,7.164,10.677,7.914,10.677z M17.017,6.09c-0.792,3.771-3.357,5.772-7.445,5.772H7.914\r\n\tc-0.164,0-0.302,0.118-0.328,0.282L6.481,19h2.907c0.348,0,0.645-0.253,0.699-0.597l0.029-0.15l0.555-3.514l0.036-0.194\r\n\tc0.054-0.344,0.351-0.597,0.699-0.597h0.44c2.85,0,5.081-1.158,5.733-4.506C17.847,8.062,17.711,6.908,17.017,6.09z"
    }
  }]
};
exports.paypal = paypal;
var picasa = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.808,1.823C2.719,3.411,0.8,6.544,0.8,10.021c0,0.633,0.08,1.275,0.221,1.918L8.97,4.7\r\n\tC8.122,3.929,5.894,1.901,5.808,1.823z M13.793,1.626C12.593,1.081,11.317,0.8,9.999,0.8c-0.934,0-1.855,0.156-2.749,0.441\r\n\tl6.543,5.951V1.626z M15.192,2.438v10.617h3.485c0.343-0.982,0.522-2.004,0.522-3.035C19.2,6.987,17.677,4.148,15.192,2.438z\r\n\t M1.463,13.429c0.674,1.693,1.857,3.15,3.368,4.184v-7.25l-2.045,1.861C2.088,12.858,1.506,13.39,1.463,13.429z M6.23,18.425\r\n\tc0.935,0.422,1.913,0.682,2.92,0.775h1.689c3.019-0.281,5.727-2.068,7.199-4.744H6.23V18.425z"
    }
  }]
};
exports.picasa = picasa;
var pinterest = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.617,13.227C8.091,15.981,7.45,18.621,5.549,20C4.963,15.838,6.41,12.713,7.083,9.395\r\n\tc-1.147-1.93,0.138-5.812,2.555-4.855c2.975,1.176-2.576,7.172,1.15,7.922c3.891,0.781,5.479-6.75,3.066-9.199\r\n\tC10.369-0.275,3.708,3.18,4.528,8.245c0.199,1.238,1.478,1.613,0.511,3.322c-2.231-0.494-2.897-2.254-2.811-4.6\r\n\tc0.138-3.84,3.449-6.527,6.771-6.9c4.201-0.471,8.144,1.543,8.689,5.494c0.613,4.461-1.896,9.293-6.389,8.945\r\n\tC10.081,14.411,9.571,13.807,8.617,13.227z"
    }
  }]
};
exports.pinterest = pinterest;
var qq = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.005,13.018c-0.779-0.547-1.751-0.51-2.304,0.277c-0.553,0.785-4.418,5.633-10.751,3.619\r\n\tc0.239,0.209,0.49,0.406,0.755,0.592c4.153,2.926,9.892,1.928,12.816-2.225C18.076,14.494,17.784,13.567,17.005,13.018z\r\n\t M4.785,12.401C4.381,11.53,2.116,5.758,7.025,1.28c-0.3,0.104-0.597,0.221-0.89,0.357C1.526,3.772-0.481,9.24,1.654,13.85\r\n\tc0.403,0.871,1.353,1.084,2.218,0.684C4.736,14.133,5.188,13.272,4.785,12.401z M10.826,0.823c-0.956-0.086-1.614,0.629-1.7,1.578\r\n\tC9.041,3.35,9.561,4.172,10.517,4.258c0.956,0.086,7.087,1.01,8.51,7.502c0.062-0.311,0.106-0.627,0.136-0.949\r\n\tC19.618,5.75,15.886,1.278,10.826,0.823z M6.891,10.53c-0.264,0.619-0.306,1.213-0.094,1.322c0.146,0.076,0.374-0.098,0.588-0.416\r\n\tC7.47,11.783,7.68,12.098,7.98,12.35c-0.314,0.115-0.52,0.305-0.52,0.519c0,0.354,0.556,0.639,1.241,0.639\r\n\tc0.618,0,1.13-0.232,1.225-0.537c0.025,0,0.123,0,0.147,0c0.095,0.305,0.607,0.537,1.226,0.537c0.686,0,1.241-0.285,1.241-0.639\r\n\tc0-0.215-0.205-0.404-0.52-0.519c0.299-0.252,0.51-0.566,0.594-0.914c0.214,0.318,0.442,0.492,0.589,0.416\r\n\tc0.211-0.109,0.17-0.703-0.095-1.322c-0.207-0.488-0.488-0.848-0.702-0.926C12.41,9.573,12.41,9.541,12.41,9.51\r\n\tc0-0.19-0.052-0.363-0.142-0.504c0.002-0.012,0.002-0.023,0.002-0.033c0-0.088-0.021-0.168-0.056-0.238\r\n\tC12.16,7.467,11.335,6.461,10,6.461c-1.336,0-2.161,1.006-2.215,2.273c-0.035,0.07-0.057,0.15-0.057,0.238\r\n\tc0,0.01,0.001,0.021,0.002,0.033C7.642,9.147,7.589,9.321,7.589,9.51c0,0.031,0.001,0.062,0.004,0.094\r\n\tC7.38,9.682,7.098,10.041,6.891,10.53z"
    }
  }]
};
exports.qq = qq;
var raft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.6734395,19c-0.877316,0-1.6501045-0.3605442-2.1763153-1.0143661\r\n\tc-0.6450326-0.8027058-0.8514075-1.9354591-0.5816016-3.1901903l0.0580709-0.2699594l1.9735143,0.4313974l-0.0580707,0.269063\r\n\tc-0.13937,0.6448536-0.083086,1.1650429,0.1581311,1.4654961c0.148304,0.1838589,0.3591456,0.2780323,0.6262712,0.2780323\r\n\tc0.7754688,0,1.5446839-1.2412777,2.125392-3.4179964c-0.6360989-0.2161474-1.2203803-0.5354357-1.7403374-0.9524832\r\n\tl-0.213522-0.1713028l1.2579031-1.5892649l0.2153087,0.1722002c0.2742729,0.2206316,0.580708,0.4009037,0.9139452,0.5372286\r\n\tc0.1688519-0.968626,0.3037548-2.0323219,0.4029226-3.168664L8.659173,8.1047468l2.0110369,0.1775808l-0.0241213,0.2744446\r\n\tc-0.1018476,1.1695271-0.240324,2.2673035-0.4109631,3.2682171c1.3874464-0.1399126,2.6516027-0.9273701,3.3547068-2.1112471\r\n\tc1.152482-1.9408398,0.694169-4.3704782-1.0890512-5.7776766c-0.7620678-0.601804-1.8814945-0.9433796-2.9267693-0.8913608\r\n\tc-1.3043594,0.0547094-2.4041319,0.642029-3.2680469,1.765815C5.2660508,6.1621122,5.1561627,8.1881561,6.0450931,9.6267452\r\n\tl0.1447301,0.2340851L4.4745007,10.934391l-0.1447301-0.2349815c-1.338309-2.1677494-1.182858-5.1014323,0.3796935-7.1328573\r\n\tc1.2266345-1.59644,2.8794193-2.4716568,4.7805681-2.5514789c1.5518312-0.0609876,3.1134892,0.4205006,4.2570381,1.3218613\r\n\tc2.5944252,2.0466716,3.2573261,5.5875397,1.5768461,8.4180813c-0.7397337,1.2457609-1.8823881,2.1955528-3.2430325,2.7067728\r\n\tc0.2519379,0.3838625,0.4663534,0.8430634,0.712038,1.5139265l0.1581316,0.4394693\r\n\tc0.4967279,1.3874674,0.7236509,1.5112371,1.2453957,1.5112371c0.2358561,0,0.4940481-0.1004505,0.6566467-0.256506\r\n\tc0.3126888-0.2995567,0.4047089-0.8753519,0.2742729-1.7121372l-0.0428829-0.2726507l1.9949551-0.3148041l0.0428829,0.2726507\r\n\tc0.235857,1.513031-0.0678978,2.7229156-0.8773155,3.4987144c-0.5422916,0.5183945-1.2891722,0.8152599-2.0485592,0.8152599\r\n\tc-0.9309206,0-1.684948-0.3479881-2.239747-1.0332012c-0.3850546-0.4735508-0.5985765-0.9641418-0.9050112-1.8179684\r\n\tl-0.152771-0.4260159c-0.3546791-0.9677296-0.6682615-1.4565268-1.1203203-1.7067556\r\n\tc-0.1375828,0.5264664-0.2894602,1.0188513-0.453846,1.4681864C8.4599457,17.8026695,7.2315245,19,5.6734395,19z"
    }
  }]
};
exports.raft = raft;
var rainbow = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,5C4.4771729,5,0,9.4771118,0,15h1.5c0-4.694458,3.8056641-8.5,8.5-8.5s8.5,3.805542,8.5,8.5H20\r\n\tC20,9.4771118,15.5228271,5,10,5z M10,11c-2.2092285,0-4,1.7908325-4,4h1.5c0-1.3807373,1.1192627-2.5,2.5-2.5\r\n\ts2.5,1.1192627,2.5,2.5H14C14,12.7908325,12.2092285,11,10,11z M10,8c-3.8659668,0-7,3.1339722-7,7h1.5\r\n\tc0-3.0375977,2.4624023-5.5,5.5-5.5s5.5,2.4624023,5.5,5.5H17C17,11.1339722,13.8659668,8,10,8z"
    }
  }]
};
exports.rainbow = rainbow;
var rdio = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.203,10.001c0,4.307-3.448,7.799-7.701,7.799S0.8,14.308,0.8,10.001C0.8,5.692,4.248,2.2,8.501,2.2\r\n\tc0.611,0,1.204,0.076,1.774,0.213v4.441c-0.902-0.33-2.01-0.281-3.053,0.223c-1.885,0.91-2.841,2.957-2.135,4.57\r\n\tc0.705,1.615,2.807,2.188,4.691,1.277c1.299-0.627,2.443-2.137,2.443-4.029V3.171c0.162,0.09,0.32,0.188,0.475,0.289\r\n\tc1.464,0.92,3.638,2.152,6.178,2.281c0.99,0.049-0.389,2.541-2.738,3.236C16.18,9.311,16.203,9.653,16.203,10.001z"
    }
  }]
};
exports.rdio = rdio;
var renren = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.468,0.865C4.117,1.594,0.8,5.377,0.8,9.936c0,2.266,0.82,4.338,2.179,5.941c3.221-1.559,5.472-5.086,5.489-9.191V0.865z\r\n\t M10.002,12.258c-0.573,2.373-2.285,4.4-4.418,5.748C6.894,18.725,8.4,19.135,10,19.135c1.602,0,3.108-0.41,4.418-1.129\r\n\tC12.285,16.658,10.574,14.631,10.002,12.258z M11.535,6.643c0,4.123,2.256,7.668,5.487,9.234c1.358-1.603,2.178-3.676,2.178-5.941\r\n\tc0-4.559-3.315-8.34-7.665-9.07V6.643z"
    }
  }]
};
exports.renren = renren;
var scribd = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.643,18.284c0,0.224-0.072,0.492-0.148,0.716h5.737c0.328-0.377,0.513-0.831,0.513-1.342c0-1.385-1.644-2.154-5.241-3.842\r\n\tL4.998,13.58C3.225,12.737,1.912,11.995,1,11.111v4.398c0.176-0.024,0.359-0.042,0.558-0.042\r\n\tC4.559,15.468,4.643,18.256,4.643,18.284z M17,1h-3.738c1.748,1.178,2.467,2.842,2.467,4.142c0,2.194-1.836,2.905-2.727,2.905\r\n\tl-0.271,0.002c-2.046,0-3.09-1.247-3.104-3.707C9.506,4.246,8.939,3.889,7.28,3.889c-1.96,0-2.773,1.543-2.773,2.369\r\n\tc0,0.973,0.543,2.055,4.484,3.382c6.736,2.254,6.736,5.255,6.736,7.903v0.026c0,0.437-0.031,0.924-0.117,1.431H17c1.1,0,2-0.899,2-2\r\n\tV3C19,1.9,18.1,1,17,1z"
    }
  }]
};
exports.scribd = scribd;
var weibo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.688,10.068c-0.274-0.084-0.463-0.142-0.319-0.508c0.311-0.797,0.344-1.484,0.007-1.975\r\n\tc-0.633-0.92-2.364-0.871-4.348-0.025c0-0.002-0.623,0.277-0.464-0.227C9.87,6.336,9.823,5.5,9.348,5.018\r\n\tC8.272,3.92,5.411,5.059,2.956,7.557C1.117,9.428,0.05,11.41,0.05,13.125c0,3.281,4.132,5.475,8.175,5.475\r\n\tc5.299,0,8.825-3.334,8.825-5.822C17.05,11.273,15.806,10.42,14.688,10.068z M8.236,17.129c-3.225,0.32-6.011-1.147-6.22-3.275\r\n\tc-0.209-2.129,2.236-4.115,5.462-4.438c3.226-0.32,6.011,1.146,6.22,3.275C13.907,14.822,11.462,16.809,8.236,17.129z M19.95,7.397\r\n\tc-0.001-3.312-2.686-5.996-6-5.996c-0.387,0-0.699,0.312-0.699,0.699s0.312,0.699,0.699,0.699c2.541,0,4.601,2.061,4.601,4.602\r\n\tc0,0.387,0.313,0.699,0.7,0.699S19.95,7.787,19.95,7.4V7.397z M17.169,7.295c-0.319-1.562-1.551-2.793-3.113-3.113\r\n\tc-0.378-0.078-0.748,0.166-0.826,0.545c-0.077,0.377,0.166,0.748,0.545,0.826c1.016,0.207,1.816,1.008,2.024,2.023\r\n\tc0.078,0.379,0.448,0.621,0.826,0.545C17.002,8.043,17.247,7.672,17.169,7.295z M6.582,11.502c-1.3,0.262-2.177,1.352-1.959,2.434\r\n\tc0.218,1.084,1.447,1.75,2.747,1.488c1.299-0.262,2.176-1.352,1.959-2.434C9.111,11.908,7.88,11.24,6.582,11.502z"
    }
  }]
};
exports.weibo = weibo;
var skype = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.671,12.037c0.132-0.623,0.203-1.272,0.203-1.938c0-4.986-3.93-9.029-8.777-9.029c-0.511,0-1.012,0.047-1.5,0.133\r\n\tC7.812,0.695,6.885,0.4,5.89,0.4C3.079,0.4,0.8,2.744,0.8,5.637c0,0.965,0.256,1.871,0.699,2.648\r\n\tC1.383,8.871,1.321,9.479,1.321,10.1c0,4.986,3.93,9.029,8.775,9.029c0.551,0,1.087-0.051,1.607-0.15\r\n\tc0.717,0.396,1.535,0.621,2.406,0.621c2.811,0,5.09-2.344,5.09-5.236C19.2,13.527,19.009,12.738,18.671,12.037z M14.599,14.416\r\n\tc-0.406,0.59-1.006,1.059-1.783,1.391c-0.769,0.33-1.692,0.496-2.742,0.496c-1.26,0-2.317-0.227-3.143-0.678\r\n\tc-0.59-0.328-1.076-0.771-1.445-1.318c-0.372-0.555-0.561-1.104-0.561-1.633c0-0.33,0.123-0.617,0.365-0.852\r\n\tc0.24-0.232,0.549-0.352,0.916-0.352c0.301,0,0.562,0.094,0.773,0.277c0.202,0.176,0.375,0.438,0.514,0.773\r\n\tc0.156,0.367,0.326,0.676,0.505,0.92c0.172,0.234,0.42,0.432,0.735,0.586c0.318,0.154,0.748,0.232,1.275,0.232\r\n\tc0.725,0,1.32-0.158,1.768-0.473c0.438-0.309,0.65-0.676,0.65-1.127c0-0.357-0.111-0.637-0.34-0.857\r\n\tc-0.238-0.228-0.555-0.408-0.936-0.531c-0.399-0.127-0.941-0.266-1.611-0.41c-0.91-0.201-1.683-0.439-2.299-0.707\r\n\tc-0.63-0.275-1.137-0.658-1.508-1.137C5.357,8.533,5.165,7.924,5.165,7.209c0-0.682,0.2-1.297,0.596-1.828\r\n\tc0.393-0.525,0.965-0.935,1.703-1.217C8.192,3.887,9.06,3.746,10.04,3.746c0.783,0,1.473,0.094,2.047,0.277\r\n\tc0.578,0.186,1.066,0.436,1.449,0.744c0.387,0.311,0.674,0.643,0.854,0.986c0.182,0.35,0.275,0.695,0.275,1.031\r\n\tc0,0.322-0.121,0.615-0.361,0.871c-0.24,0.258-0.543,0.387-0.9,0.387c-0.324,0-0.58-0.082-0.756-0.242\r\n\tc-0.164-0.148-0.336-0.383-0.524-0.717c-0.219-0.428-0.484-0.766-0.788-1.002c-0.295-0.232-0.788-0.35-1.466-0.35\r\n\tc-0.629,0-1.141,0.131-1.519,0.387C7.983,6.367,7.806,6.65,7.806,6.984c0,0.207,0.058,0.379,0.176,0.525\r\n\tc0.125,0.158,0.301,0.295,0.523,0.41C8.735,8.039,8.972,8.133,9.21,8.201c0.244,0.07,0.654,0.172,1.215,0.307\r\n\tc0.711,0.156,1.363,0.332,1.939,0.521c0.585,0.193,1.09,0.43,1.502,0.705c0.42,0.283,0.754,0.645,0.989,1.076\r\n\tc0.237,0.434,0.357,0.969,0.357,1.59C15.213,13.145,15.006,13.822,14.599,14.416z"
    }
  }]
};
exports.skype = skype;
var slideshare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,7.08c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5S11.62,7.08,13,7.08z M18.845,5.943\r\n\tC15.265,8.498,13.616,8.051,12,8c-1.118-0.057-1.5,0.298-1.5,1.08l0.001,6c0,5,8.421,3.43,5.165-4.949\r\n\tc1.671-0.959,3.076-2.434,3.876-3.412C19.953,6.111,19.514,5.474,18.845,5.943z M7,2.08c-1.381,0-2.5,1.119-2.5,2.5\r\n\ts1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S8.38,2.08,7,2.08z M8,8C6.384,8.051,4.735,8.498,1.155,5.943\r\n\tC0.486,5.474,0.047,6.111,0.458,6.718c0.8,0.979,2.205,2.453,3.876,3.412c-3.256,8.379,5.165,9.949,5.165,4.949l0.001-6\r\n\tC9.5,8.298,9.118,7.943,8,8z"
    }
  }]
};
exports.slideshare = slideshare;
var smashing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.023,16.032c-2.508,0-4.253-1.555-4.253-1.555L4.287,17.84c1.023,0.547,2.092,0.936,2.709,1.141l-1.592,0.381\r\n\tc-0.746,0.178-1.496-0.283-1.675-1.029L0.639,5.405C0.46,4.659,0.92,3.909,1.667,3.729L5.383,2.84\r\n\tc-0.91,1.029-1.263,2.252-1.174,3.65c0.139,2.193,2.237,3.879,4.734,4.822C13.644,13.088,12.529,16.032,10.023,16.032z\r\n\t M19.361,14.594L16.27,1.666c-0.178-0.746-0.928-1.207-1.675-1.027l-2.663,0.637c0.679,0.105,2.024,0.4,3.505,1.178l-1.159,3.213\r\n\tc0,0-0.965-1.078-3.553-1.209c-2.46-0.125-3.828,2.537,0.969,4.105c3.674,1.201,4.848,3.516,4.787,5.658\r\n\tc-0.031,1.113-0.421,2.018-0.872,2.701l2.725-0.652C19.08,16.092,19.54,15.342,19.361,14.594z"
    }
  }]
};
exports.smashing = smashing;
var soundcloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.672,13.055L1,11.654l-0.328-1.447c-0.009-0.043-0.092-0.076-0.191-0.076c-0.102,0-0.184,0.033-0.191,0.076L0,11.654\r\n\tl0.289,1.4c0.008,0.045,0.09,0.076,0.191,0.076C0.58,13.131,0.663,13.1,0.672,13.055z M2.723,13.832L3,11.668L2.723,8.32\r\n\tC2.714,8.236,2.609,8.168,2.484,8.168c-0.127,0-0.233,0.068-0.238,0.152L2,11.668l0.246,2.164c0.006,0.086,0.111,0.152,0.238,0.152\r\n\tC2.609,13.984,2.714,13.918,2.723,13.832z M4.768,13.797L5,11.67L4.768,7.213C4.762,7.107,4.639,7.025,4.486,7.025\r\n\tc-0.152,0-0.275,0.082-0.281,0.188L4,11.67l0.205,2.129c0.006,0.103,0.129,0.186,0.281,0.186\r\n\tC4.639,13.984,4.762,13.902,4.768,13.797z M6.81,13.766L7,11.67L6.81,7.18C6.805,7.057,6.664,6.959,6.49,6.959\r\n\tc-0.176,0-0.316,0.098-0.321,0.221L6,11.67l0.17,2.096c0.004,0.123,0.145,0.221,0.32,0.221C6.664,13.986,6.805,13.891,6.81,13.766z\r\n\t M8.85,13.738L9,11.672L8.85,6.523C8.846,6.381,8.686,6.268,8.492,6.268c-0.194,0-0.354,0.115-0.357,0.256L8,11.67l0.135,2.068\r\n\tc0.003,0.141,0.163,0.256,0.357,0.256C8.686,13.994,8.846,13.881,8.85,13.738z M10.277,13.996c0.008,0,7.1,0.004,7.145,0.004\r\n\tC18.846,14,20,12.883,20,11.506c0-1.377-1.154-2.492-2.578-2.492c-0.353,0-0.689,0.07-0.996,0.193\r\n\tc-0.205-2.246-2.153-4.008-4.529-4.008c-0.581,0-1.148,0.111-1.648,0.297C10.053,5.57,10.002,5.644,10,5.791v7.91\r\n\tC10.002,13.854,10.124,13.98,10.277,13.996z"
    }
  }]
};
exports.soundcloud = soundcloud;
var spotify = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.spotify = spotify;
var stumbleupon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.051,8.059l1.365,0.66l2.059-0.66V6.865C14.475,4.402,12.467,2.4,10,2.4S5.525,4.402,5.525,6.865v6.27\r\n\tc0,0.578-0.472,1.049-1.051,1.049c-0.58,0-1.051-0.471-1.051-1.049V10.51H0v2.625C0,15.596,2.007,17.6,4.475,17.6\r\n\tc2.467,0,4.474-2.004,4.474-4.465v-6.27c0-0.578,0.472-1.049,1.052-1.049c0.579,0,1.051,0.471,1.051,1.049V8.059z M16.576,10.51\r\n\tv2.625c0,0.578-0.471,1.049-1.051,1.049c-0.58,0-1.051-0.471-1.051-1.049v-2.678l-2.059,0.658l-1.365-0.658v2.678\r\n\tc0,2.461,2.008,4.465,4.475,4.465S20,15.596,20,13.135V10.51H16.576z"
    }
  }]
};
exports.stumbleupon = stumbleupon;
var swarm = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.286,18.821c-1.429-0.232-2.733-0.607-3.677-0.923c-0.046-0.015-0.781-0.282-1.007-0.37\r\n\tc-0.278-0.107-0.423-0.431-0.317-0.71c0.086-0.225,0.379-0.949,0.399-0.994c0.4-0.92,1-2.153,1.795-3.379\r\n\tc0.029,1.203,0.297,2.399,0.791,3.506C8.75,17.028,9.439,18.007,10.286,18.821z M10.173,7.027c-2.791-5.689-8.99-5.486-9.968-2.943\r\n\tc-0.751,1.952,2.535,6.602,10.097,3.244c0.002-0.001,0.002-0.001,0.004-0.002C10.28,7.279,10.192,7.079,10.173,7.027z M11.56,6.805\r\n\tc0.001,0,0.002-0.001,0.002-0.001c4.271-1.897,3.674-5.191,2.569-5.614c-1.487-0.569-4.19,1.624-2.647,5.447\r\n\tC11.499,6.664,11.55,6.777,11.56,6.805z M19.413,10.97C18.767,9.52,17.58,8.481,16.2,7.986c-0.139-0.05-0.281-0.073-0.423-0.073\r\n\tc-0.717,0-1.407,0.595-1.472,1.338c-0.109,1.239,0.137,2.501,0.68,3.718c0.535,1.199,1.294,2.213,2.27,2.957\r\n\tc0.254,0.194,0.565,0.285,0.875,0.285c0.559,0,1.117-0.296,1.339-0.826C20.04,14.023,20.066,12.432,19.413,10.97z M16.172,17.339\r\n\tc-1.195-0.912-2.142-2.139-2.815-3.646c-0.682-1.529-0.961-3.075-0.827-4.596c0.037-0.423,0.161-0.831,0.36-1.204\r\n\tc-0.035,0.009-0.111,0.027-0.114,0.028c-0.628,0.157-1.237,0.429-1.778,0.784c-0.784,0.514-1.475,1.277-1.772,2.177\r\n\tc-0.08,0.243-0.141,0.51-0.161,0.765c-0.095,1.218,0.103,2.476,0.636,3.67c0.516,1.155,1.285,2.118,2.213,2.853\r\n\tC12.48,18.617,13.5,18.9,14.334,18.9c0.783,0,1.556-0.233,2.25-0.585c0.217-0.11,0.695-0.408,0.726-0.429\r\n\tC16.895,17.78,16.506,17.594,16.172,17.339z"
    }
  }]
};
exports.swarm = swarm;
var tripadvisor = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,6.0090332h-2.8286133C15.2119141,4.6748047,12.8125,4,10,4S4.7880859,4.6748047,2.8286133,6.0090332H0\r\n\tC0.4279785,6.4293823,0.8271484,7.348877,0.9931641,8.0480957C0.3771973,8.8793335,0,9.8972778,0,11.0090332\r\n\tc0,2.7568359,2.2431641,5,5,5c1.3266602,0,2.5268555-0.5282593,3.4228516-1.3746338L10,17l1.5771484-2.3656006\r\n\tC12.4731445,15.4807739,13.6733398,16.0090332,15,16.0090332c2.7568359,0,5-2.2431641,5-5\r\n\tc0-1.1117554-0.3771973-2.1296997-0.9931641-2.9609375C19.1728516,7.348877,19.5720215,6.4293823,20,6.0090332z M5,14.4090576\r\n\tc-1.8745117,0-3.3999023-1.5254517-3.3999023-3.4000244S3.1254883,7.6090088,5,7.6090088s3.3999023,1.5254517,3.3999023,3.4000244\r\n\tS6.8745117,14.4090576,5,14.4090576z M10,11.0090332c0-2.4172974-1.7250977-4.4382935-4.0085449-4.8997803\r\n\tC7.1948242,5.7042847,8.5290527,5.5,10,5.5s2.8051758,0.2042847,4.0085449,0.6092529\r\n\tC11.7250977,6.5707397,10,8.5917358,10,11.0090332z M15,14.4090576c-1.8745117,0-3.3999023-1.5254517-3.3999023-3.4000244\r\n\tS13.1254883,7.6090088,15,7.6090088s3.3999023,1.5254517,3.3999023,3.4000244S16.8745117,14.4090576,15,14.4090576z M5,8.8590088\r\n\tc-1.1850586,0-2.1499023,0.9644775-2.1499023,2.1500244S3.8149414,13.1590576,5,13.1590576s2.1499023-0.9644775,2.1499023-2.1500244\r\n\tS6.1850586,8.8590088,5,8.8590088z M5,11.6500244c-0.3588867,0-0.6499023-0.2910156-0.6499023-0.6500244\r\n\tS4.6411133,10.3499756,5,10.3499756S5.6499023,10.6409912,5.6499023,11S5.3588867,11.6500244,5,11.6500244z M15,8.8590088\r\n\tc-1.1850586,0-2.1499023,0.9644775-2.1499023,2.1500244S13.8149414,13.1590576,15,13.1590576\r\n\ts2.1499023-0.9644775,2.1499023-2.1500244S16.1850586,8.8590088,15,8.8590088z M15,11.6500244\r\n\tc-0.3588867,0-0.6499023-0.2910156-0.6499023-0.6500244S14.6411133,10.3499756,15,10.3499756S15.6499023,10.6409912,15.6499023,11\r\n\tS15.3588867,11.6500244,15,11.6500244z"
    }
  }]
};
exports.tripadvisor = tripadvisor;
var tumblr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,18.196c-0.777,0.371-1.48,0.631-2.109,0.781c-0.63,0.148-1.311,0.223-2.043,0.223c-0.831,0-1.566-0.107-2.205-0.318\r\n\tc-0.639-0.213-1.183-0.516-1.635-0.908c-0.451-0.395-0.764-0.812-0.938-1.254c-0.174-0.443-0.261-1.086-0.261-1.926V8.339H4.4V5.735\r\n\tc0.714-0.234,1.326-0.57,1.835-1.01c0.51-0.438,0.918-0.965,1.227-1.58C7.77,2.532,7.981,1.749,8.098,0.8h2.585v4.652h4.314v2.887\r\n\th-4.314v4.719c0,1.066,0.056,1.752,0.168,2.055c0.111,0.303,0.319,0.545,0.622,0.725c0.403,0.244,0.863,0.367,1.381,0.367\r\n\tc0.92,0,1.836-0.303,2.746-0.908V18.196z"
    }
  }]
};
exports.tumblr = tumblr;
var twitter = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.316,6.246c0.008,0.162,0.011,0.326,0.011,0.488c0,4.99-3.797,10.742-10.74,10.742c-2.133,0-4.116-0.625-5.787-1.697\r\n\tc0.296,0.035,0.596,0.053,0.9,0.053c1.77,0,3.397-0.604,4.688-1.615c-1.651-0.031-3.046-1.121-3.526-2.621\r\n\tc0.23,0.043,0.467,0.066,0.71,0.066c0.345,0,0.679-0.045,0.995-0.131c-1.727-0.348-3.028-1.873-3.028-3.703c0-0.016,0-0.031,0-0.047\r\n\tc0.509,0.283,1.092,0.453,1.71,0.473c-1.013-0.678-1.68-1.832-1.68-3.143c0-0.691,0.186-1.34,0.512-1.898\r\n\tC3.942,5.498,6.725,7,9.862,7.158C9.798,6.881,9.765,6.594,9.765,6.297c0-2.084,1.689-3.773,3.774-3.773\r\n\tc1.086,0,2.067,0.457,2.756,1.191c0.859-0.17,1.667-0.484,2.397-0.916c-0.282,0.881-0.881,1.621-1.66,2.088\r\n\tc0.764-0.092,1.49-0.293,2.168-0.594C18.694,5.051,18.054,5.715,17.316,6.246z"
    }
  }]
};
exports.twitter = twitter;
var vimeo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.91,5.84c-1.006,5.773-6.625,10.66-8.315,11.777c-1.69,1.115-3.233-0.447-3.792-1.631\r\n\tC6.162,14.639,4.244,7.33,3.741,6.725C3.238,6.119,1.731,7.33,1.731,7.33L1,6.354c0,0,3.061-3.725,5.391-4.191\r\n\tC8.861,1.67,8.857,6.027,9.451,8.445c0.574,2.342,0.961,3.68,1.463,3.68c0.502,0,1.462-1.305,2.512-3.305\r\n\tc1.053-2.004-0.045-3.772-2.101-2.514C12.148,1.279,19.916,0.07,18.91,5.84z"
    }
  }]
};
exports.vimeo = vimeo;
var vine = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.452,9.951c-0.438,0.101-0.863,0.145-1.244,0.145c-2.145,0-3.797-1.496-3.797-4.102c0-1.277,0.493-1.941,1.192-1.941\r\n\tc0.664,0,1.107,0.596,1.107,1.805c0,0.688-0.184,1.44-0.32,1.887c0,0,0.66,1.152,2.469,0.799c0.385-0.852,0.593-1.956,0.593-2.924\r\n\tc0-2.605-1.33-4.119-3.763-4.119c-2.504,0-3.968,1.922-3.968,4.461c0,2.512,1.175,4.668,3.113,5.651\r\n\tc-0.815,1.629-1.852,3.065-2.933,4.146c-1.961-2.371-3.734-5.534-4.463-11.706H2.548c1.335,10.279,5.319,13.553,6.373,14.181\r\n\tc0.596,0.358,1.108,0.341,1.654,0.034c0.855-0.485,3.422-3.054,4.847-6.061c0.597-0.002,1.314-0.069,2.03-0.231V9.951z"
    }
  }]
};
exports.vine = vine;
var alternitive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,17V3c0-1.1-0.903-2-2.005-2H3.005C1.855,1,1,1.853,1,3v14c0,1.148,0.855,2,2.005,2h13.99C18.097,19,19,18.101,19,17z\r\n\t M15.184,11.607c0,0,1.132,1.117,1.411,1.635c0.008,0.011,0.011,0.021,0.014,0.025c0.113,0.19,0.142,0.34,0.085,0.45\r\n\tC16.6,13.9,16.28,13.992,16.171,14c0,0-1.943,0-1.999,0c-0.14,0-0.43-0.036-0.782-0.279c-0.27-0.188-0.537-0.499-0.797-0.802\r\n\tc-0.388-0.45-0.724-0.84-1.062-0.84c-0.043,0-0.086,0.007-0.126,0.021c-0.257,0.082-0.583,0.447-0.583,1.422\r\n\tc0,0.305-0.24,0.479-0.41,0.479c0,0-0.872,0-0.916,0c-0.312,0-1.937-0.109-3.376-1.628c-1.766-1.86-3.352-5.591-3.366-5.624\r\n\tc-0.1-0.241,0.107-0.372,0.332-0.372h2.02c0.271,0,0.358,0.164,0.42,0.311C5.596,6.855,5.86,7.529,6.292,8.287\r\n\tc0.703,1.233,1.136,1.735,1.481,1.735c0.064,0,0.126-0.017,0.184-0.049c0.451-0.249,0.367-1.857,0.347-2.189\r\n\tc0-0.063-0.001-0.719-0.231-1.034C7.907,6.522,7.626,6.435,7.456,6.402c0.045-0.065,0.142-0.166,0.266-0.226\r\n\tC8.031,6.022,8.588,6,9.142,6h0.308c0.601,0.008,0.757,0.047,0.974,0.102c0.439,0.105,0.448,0.39,0.409,1.36\r\n\tc-0.011,0.276-0.023,0.589-0.023,0.956c0,0.079-0.003,0.166-0.003,0.256c-0.014,0.496-0.03,1.057,0.32,1.287\r\n\tc0.046,0.028,0.097,0.044,0.151,0.044c0.122,0,0.487,0,1.476-1.697c0.435-0.749,0.77-1.633,0.793-1.699\r\n\tc0.02-0.036,0.079-0.142,0.148-0.183c0.056-0.033,0.128-0.039,0.166-0.039h2.375c0.26,0,0.436,0.039,0.469,0.138\r\n\tc0.057,0.159-0.011,0.644-1.096,2.11c-0.184,0.243-0.343,0.455-0.483,0.64C14.142,10.563,14.142,10.629,15.184,11.607z"
    }
  }]
};
exports.alternitive = alternitive;
var vk = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.802,12.298c0,0,1.617,1.597,2.017,2.336c0.011,0.016,0.016,0.028,0.018,0.035\r\n\tc0.163,0.273,0.203,0.487,0.123,0.645c-0.135,0.261-0.592,0.392-0.747,0.403c0,0-2.778,0-2.858,0c-0.199,0-0.613-0.052-1.117-0.4\r\n\tc-0.385-0.269-0.768-0.712-1.139-1.145c-0.554-0.643-1.033-1.201-1.518-1.201c-0.062,0-0.122,0.01-0.18,0.03\r\n\tc-0.367,0.116-0.833,0.639-0.833,2.032c0,0.436-0.344,0.684-0.585,0.684c0,0-1.248,0-1.309,0c-0.446,0-2.768-0.156-4.827-2.327\r\n\tc-2.523-2.658-4.789-7.99-4.811-8.037C-0.105,5.008,0.191,4.82,0.511,4.82h2.886c0.387,0,0.513,0.234,0.601,0.444\r\n\tc0.102,0.241,0.48,1.205,1.1,2.288c1.004,1.762,1.621,2.479,2.114,2.479c0.093,0,0.181-0.023,0.264-0.07\r\n\tc0.644-0.354,0.524-2.654,0.494-3.128c0-0.092-0.001-1.027-0.331-1.479C7.403,5.03,7.001,4.904,6.758,4.858\r\n\tc0.065-0.094,0.203-0.238,0.38-0.323c0.441-0.22,1.238-0.252,2.029-0.252h0.439c0.858,0.012,1.08,0.067,1.392,0.146\r\n\tc0.628,0.15,0.64,0.557,0.585,1.943c-0.016,0.396-0.033,0.842-0.033,1.367c0,0.112-0.005,0.237-0.005,0.364\r\n\tc-0.019,0.711-0.044,1.512,0.458,1.841c0.064,0.04,0.139,0.062,0.217,0.062c0.174,0,0.695,0,2.108-2.425\r\n\tc0.62-1.071,1.1-2.334,1.133-2.429c0.028-0.053,0.112-0.202,0.214-0.262c0.078-0.048,0.182-0.056,0.236-0.056h3.395\r\n\tc0.37,0,0.621,0.056,0.67,0.196c0.082,0.227-0.016,0.92-1.566,3.016c-0.261,0.349-0.49,0.651-0.691,0.915\r\n\tC16.314,10.805,16.314,10.898,17.802,12.298z"
    }
  }]
};
exports.vk = vk;
var xing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.703,1h-2.828c-0.223,0-0.553,0.105-0.69,0.381S13.875,2,13.875,2l-5,10l3,6c0,0,0.172,0.344,0.31,0.619\r\n\tS12.652,19,12.875,19h2.828c0.5,0,0.48-0.381,0.355-0.631S15.875,18,15.875,18l-3-6l5-10c0,0,0.059-0.119,0.184-0.369\r\n\tS18.203,1,17.703,1z M6.815,5.381C6.678,5.105,6.348,5,6.125,5H3.297c-0.5,0-0.48,0.381-0.355,0.631S3.125,6,3.125,6l1.25,2.5\r\n\tL2.125,13c0,0-0.059,0.119-0.184,0.369S1.797,14,2.297,14h2.828c0.223,0,0.553-0.106,0.691-0.381C5.953,13.344,6.125,13,6.125,13\r\n\tl2.25-4.5L7.125,6C7.125,6,6.953,5.656,6.815,5.381z"
    }
  }]
};
exports.xing = xing;
var yelp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.538,12.471l4.523,1.466c0,0,0.647,0.119,0.64,0.552c-0.004,0.305-0.197,0.652-0.197,0.652l-1.91,2.756\r\n\tc0,0-0.341,0.286-0.686,0.286c-0.344,0-0.741-0.537-0.741-0.537l-2.417-4.073c0,0-0.272-0.594,0.05-0.921\r\n\tC12.095,12.352,12.538,12.471,12.538,12.471z M11.57,10.6c0.231,0.396,0.87,0.281,0.87,0.281l4.513-1.331\r\n\tc0,0,0.615-0.253,0.703-0.589c0.086-0.337-0.102-0.743-0.102-0.743l-2.157-2.564c0,0-0.187-0.324-0.575-0.357\r\n\tc-0.428-0.037-0.691,0.486-0.691,0.486l-2.55,4.05C11.582,9.832,11.357,10.235,11.57,10.6z M9.438,9.021\r\n\tc0.531-0.132,0.616-0.911,0.616-0.911l-0.036-6.485c0,0-0.08-0.8-0.436-1.017c-0.559-0.342-0.724-0.164-0.884-0.14L4.951,1.873\r\n\tc0,0-0.367,0.123-0.558,0.432C4.12,2.742,4.67,3.384,4.67,3.384l3.894,5.358C8.564,8.742,8.949,9.143,9.438,9.021z M8.513,11.645\r\n\tc0.013-0.5-0.595-0.801-0.595-0.801L3.89,8.791c0,0-0.597-0.248-0.887-0.075C2.782,8.848,2.585,9.088,2.566,9.299l-0.262,3.259\r\n\tc0,0-0.039,0.565,0.106,0.822c0.205,0.364,0.881,0.111,0.881,0.111l4.702-1.049C8.175,12.318,8.495,12.306,8.513,11.645z\r\n\t M9.682,13.404c-0.404-0.209-0.887,0.224-0.887,0.224l-3.148,3.498c0,0-0.393,0.535-0.293,0.863c0.094,0.308,0.25,0.461,0.47,0.569\r\n\tl3.162,1.007c0,0,0.383,0.08,0.674-0.005c0.412-0.121,0.336-0.772,0.336-0.772l0.071-4.736\r\n\tC10.067,14.053,10.051,13.597,9.682,13.404z"
    }
  }]
};
exports.yelp = yelp;
var youko = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.418047,12.0796385c-0.5478516-1.0457487-2.1255493-1.7149191-2.8060303-2.6412954\r\n\tc0.4585571-1.0617428,2.9511719-1.7141776,2.7406616-3.5655117c-0.1517944-1.3371668-2.1604614-1.4112105-2.6756592-0.3305092\r\n\tc-0.3861084,0.4457431-0.7995005,0.8636346-1.2400522,1.254293c-0.2116089,0.269928-0.4511719,0.5119433-0.7175293,0.7264161\r\n\tc-0.3097534,0.3260632-0.5610962,0.7093105-0.979187,0.9249573V5.8728313c-0.0095825-1.400774-2.6002808-1.400774-2.6101685,0\r\n\tv7.3295012c0.1132812,0.5230598,0.3482666,0.9234743,0.9133911,0.9899845h0.7833252\r\n\tc0.5371704-0.0944233,0.8428955-0.4238205,0.9134521-0.9899845v-1.5851727c0-0.549428-0.1014404-1.4766083,0.2612305-0.9241543\r\n\tc0.5316772,0.5263948,1.2804565,1.0925589,1.9580078,1.7160301c0.6503305,0.6000061,1.272706,1.5688076,1.9572153,1.7170801\r\n\tC19.3184376,14.4302559,19.9368458,13.068881,19.418047,12.0796385z M8.1933756,4.1556897\r\n\tC7.636735,4.5449276,7.3271646,5.7449384,6.9533243,6.5988774C6.5416422,7.5382848,6.1798868,8.4847937,5.7787027,9.1743431\r\n\tC4.6934977,7.9286342,3.9533243,5.1675968,2.6461954,4.1556897c-0.4216309-0.3260012-1.3457031-0.3167379-1.7619629,0\r\n\tC-0.241744,5.0133343,0.8880777,6.5300832,1.3409586,7.3256645c0.9940186,1.7442522,2.0955811,3.6115799,2.9366455,5.2160816\r\n\tc-0.5467529,1.4587612-3.3081665,5.5814819,0.3916626,5.3487911c0.8953857-0.5855541,1.2750854-1.8037815,1.762146-2.9060354\r\n\tc0.9957275-2.255393,1.8415527-4.204113,2.8713989-6.5365133c0.4280396-0.9695439,1.4592285-2.4023066,1.2398682-3.500052\r\n\tC10.3683634,4.0776324,9.0449381,3.5608718,8.1933756,4.1556897z"
    }
  }]
};
exports.youko = youko;
var youtube = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.3C0.172,2.3,0,3.174,0,10s0.172,7.7,10,7.7s10-0.874,10-7.7S19.828,2.3,10,2.3z M13.205,10.334l-4.49,2.096\r\n\tC8.322,12.612,8,12.408,8,11.974V8.026C8,7.593,8.322,7.388,8.715,7.57l4.49,2.096C13.598,9.85,13.598,10.15,13.205,10.334z"
    }
  }]
};
exports.youtube = youtube;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/entypo/index.js
// module id = 1440
// module chunks = 0